var _style, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-poke-bowl",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-poke-bowl:not(.animated) .animable {opacity: 0;}svg#freepik_stories-poke-bowl.animated #freepik--poke-bowl--inject-3 {animation: 1.5s Infinite  linear floating;animation-delay: 0s;}            @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }        .animator-hidden { display: none; }")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-3",
    className: "animable",
    style: {
      transformOrigin: "249.999px 357.781px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-3",
    d: "M91.19,265.72C3.72,316.22,4.4,398.49,92.7,449.47s230.11,51,316.74,0,85.95-133.25-1.52-183.75S178.65,215.23,91.19,265.72Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "249.999px 357.781px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-3",
    className: "animable",
    style: {
      transformOrigin: "249.975px 389.785px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-3",
    d: "M328.69,344.27c-43.51-25.07-114-25-157.45.13-21.73,12.57-32.59,29-32.57,45.48,0,.59,0,1.19.05,1.78v.22c.86,15.77,11.73,31.4,32.59,43.42,43.51,25.07,114,25,157.45-.13,20.85-12.06,31.69-27.71,32.52-43.48,0-.07,0-.15,0-.22,0-.59,0-1.19,0-1.78C361.32,373.24,350.44,356.8,328.69,344.27Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "249.975px 389.785px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Rice--inject-3",
    className: "animable",
    style: {
      transformOrigin: "252.113px 260.656px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--rice--inject-3",
    className: "animable",
    style: {
      transformOrigin: "252.113px 260.656px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.22,220.52c2.83,2.36,4,3.86,2.94,5.08s-2.69.38-5.52-2-5.27-5.92-4.73-6.57S86.38,218.16,89.22,220.52Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "87.1902px 221.526px"
    },
    id: "eldjnvi91kkwd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.18,251.06c-.49,3.65-1.16,5.41-2.73,5.2s-1.75-2.08-1.26-5.74,2.2-7.61,3-7.49S67.67,247.41,67.18,251.06Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "65.1471px 249.652px"
    },
    id: "elidllu8zdsn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.09,109c-.34-3.67-.08-5.53,1.5-5.68s2.17,1.64,2.51,5.31-.46,7.91-1.3,8S265.42,112.65,265.09,109Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "267.069px 109.971px"
    },
    id: "el0cq2dhbqphnp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.37,109c2.93-2.23,4.65-3,5.61-1.74s-.24,2.71-3.17,5-6.94,3.82-7.45,3.15S306.44,111.28,309.37,109Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "309.8px 111.112px"
    },
    id: "elao9suzq7qrq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.48,172.72c2.93-2.24,4.65-3,5.61-1.75s-.24,2.71-3.17,4.95-6.94,3.82-7.45,3.15S372.55,175,375.48,172.72Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "375.91px 174.798px"
    },
    id: "elqu2pj6ycyb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.05,404.8c-.49,3.65-1.16,5.41-2.73,5.2s-1.75-2.09-1.26-5.74,2.2-7.61,3-7.49S430.54,401.14,430.05,404.8Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "428.017px 403.392px"
    },
    id: "elh3txhkjg5c9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.19,407.55c-3-2.13-4.26-3.53-3.35-4.83s2.66-.59,5.67,1.53,5.74,5.47,5.25,6.16S67.21,409.67,64.19,407.55Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "66.1835px 406.326px"
    },
    id: "elsasrm9vtdsc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.19,386.65c2.83,2.36,4,3.86,2.94,5.07s-2.69.38-5.52-2-5.27-5.91-4.73-6.56S384.35,384.29,387.19,386.65Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "385.16px 387.648px"
    },
    id: "elj495omt2xnf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.49,418.69c-.49,3.65-1.16,5.41-2.73,5.2s-1.75-2.08-1.26-5.74,2.2-7.61,3-7.49S376,415,375.49,418.69Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "373.461px 417.282px"
    },
    id: "el3t311opv4dh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.79,358.61c2.83,2.36,4,3.86,2.95,5.08s-2.7.37-5.53-2-5.27-5.91-4.73-6.56S115,356.25,117.79,358.61Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "115.762px 359.619px"
    },
    id: "eldwl1x12i2u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.17,416.08c-.49,3.65-1.16,5.41-2.73,5.2s-1.75-2.08-1.26-5.74,2.2-7.6,3-7.49S125.66,412.43,125.17,416.08Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "123.137px 414.672px"
    },
    id: "el6herg89nvtc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.73,226c-3,2.07-4.81,2.74-5.7,1.43s.39-2.7,3.44-4.76,7.14-3.43,7.62-2.73S45.78,223.89,42.73,226Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "42.4484px 223.929px"
    },
    id: "elqxxjytsi9tf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.42,319.15c-2.55-2.65-3.51-4.27-2.37-5.37s2.72-.07,5.28,2.58,4.59,6.46,4,7.05S82,321.81,79.42,319.15Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "81.504px 318.426px"
    },
    id: "elff5g9zstwtu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.72,286.37c-.88,3.58-1.73,5.26-3.27,4.88s-1.52-2.25-.64-5.83,3-7.34,3.81-7.14S89.59,282.79,88.72,286.37Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "86.7556px 284.788px"
    },
    id: "el6n2h1ucwgdx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.4,314.73c.88-3.58,1.73-5.26,3.27-4.88s1.52,2.25.65,5.84-3,7.33-3.82,7.13S410.53,318.31,411.4,314.73Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "413.364px 316.312px"
    },
    id: "eloatyr4lj33n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.73,227.55c2.83,2.36,4,3.86,2.95,5.08s-2.7.38-5.53-2-5.27-5.92-4.73-6.57S443.9,225.19,446.73,227.55Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "444.702px 228.556px"
    },
    id: "elh69kj5dkd86",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.55,117.77c-2.83-2.36-4-3.86-2.95-5.08s2.7-.38,5.53,2,5.27,5.92,4.73,6.57S453.38,120.13,450.55,117.77Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "452.578px 116.764px"
    },
    id: "elkru86xnbnkm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.05,250.68c-.49,3.65-1.16,5.41-2.73,5.2s-1.75-2.08-1.26-5.74,2.2-7.61,3-7.49S430.54,247,430.05,250.68Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "428.017px 249.272px"
    },
    id: "el3u4conoja9g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.85,226c-3.05,2.07-4.81,2.74-5.69,1.43s.38-2.7,3.43-4.76,7.15-3.43,7.62-2.73S414.91,223.89,411.85,226Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "411.574px 223.929px"
    },
    id: "elbcogqwt3m8s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.74,287.34c-1.71-3.27-2.18-5.08-.78-5.82s2.64.68,4.35,4,2.61,7.48,1.86,7.87S438.46,290.6,436.74,287.34Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "438.787px 287.376px"
    },
    id: "elvrbrrlb13nh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.08,318.69c-1.84,3.19-3.13,4.56-4.5,3.77s-.83-2.59,1-5.78,4.93-6.21,5.66-5.78S466.92,315.5,465.08,318.69Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "463.643px 316.769px"
    },
    id: "elqgb1mh8btmo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.85,282.09c-2.59-2.64-3.56-4.24-2.43-5.35s2.72-.11,5.3,2.52,4.65,6.42,4.05,7S44.43,284.72,41.85,282.09Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "43.9143px 281.325px"
    },
    id: "elvhlvj0j7oii",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.23,137.49c-2.55-2.66-3.51-4.27-2.37-5.37s2.72-.08,5.28,2.58,4.58,6.46,4,7S353.79,140.15,351.23,137.49Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "353.313px 136.734px"
    },
    id: "elsi0ghfkija7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.42,123.38c-.88,3.58-1.73,5.25-3.27,4.88s-1.52-2.26-.64-5.84,3-7.33,3.81-7.13S381.29,119.8,380.42,123.38Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "378.456px 121.796px"
    },
    id: "elzu0nfueb6h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.66,110.79c-3.13,1.95-4.9,2.56-5.74,1.22s.48-2.68,3.61-4.63,7.26-3.16,7.71-2.45S54.79,108.84,51.66,110.79Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "51.4793px 108.726px"
    },
    id: "elsml41ch2se",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.74,151.39c2.55-2.65,3.51-4.27,2.37-5.37s-2.72-.08-5.27,2.58-4.59,6.46-4,7.05S139.18,154.05,141.74,151.39Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "139.661px 150.665px"
    },
    id: "elbcecuio9yhw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.47,126.28c-3.13,1.95-4.45,3.28-3.61,4.63s2.61.73,5.74-1.22,6-5.14,5.58-5.86S200.59,124.32,197.47,126.28Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "199.417px 127.626px"
    },
    id: "el7y9ukyggkub",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.46,134.29c.88,3.58,1.73,5.26,3.27,4.88s1.52-2.25.65-5.83-3-7.34-3.82-7.14S110.59,130.71,111.46,134.29Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "113.424px 132.708px"
    },
    id: "elcgc7dyqbl5r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.64,99.4c-3.11-2-4.88-2.62-5.73-1.29s.45,2.68,3.55,4.67,7.22,3.26,7.68,2.55S202.74,101.39,199.64,99.4Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "199.422px 101.467px"
    },
    id: "elrvl73qz19jd",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Avocado--inject-3",
    className: "animable",
    style: {
      transformOrigin: "70.0542px 352.886px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--avocado--inject-3",
    className: "animable",
    style: {
      transformOrigin: "70.0542px 352.886px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.8,379.4s-7,15.42-24.2,14-30.22-13.31-36.88-29.58-6.95-27.13-9.18-33.8.16-14.58,6.23-18Z",
    style: {
      fill: "current",
      transformOrigin: "70.2595px 352.756px"
    },
    id: "eltisdkiercfh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el52imtxw1188"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.8,379.4s-7,15.42-24.2,14-30.22-13.31-36.88-29.58-6.95-27.13-9.18-33.8.16-14.58,6.23-18Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "70.2595px 352.756px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.53,367.85c7.6,15.63,20.54,25.2,36,26.46,17.6,1.43,24.71-14.2,24.78-14.36l-1-1.1c-.28.6-7.26,15-23.6,13.68-15.93-1.3-29.1-11.89-36.13-29a124.22,124.22,0,0,1-7.18-25.26,69,69,0,0,0-2-8.48c-2.2-6.54.48-14,6-17.11l-1.23-1.31c-6.25,3.55-8.93,11.66-6.46,19a67,67,0,0,1,1.91,8.25,126.79,126.79,0,0,0,7.29,25.6C44.4,365.43,45,366.66,45.53,367.85Z",
    style: {
      fill: "current",
      transformOrigin: "70.0542px 352.886px"
    },
    id: "el3rj7p7m9jvn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elm86q6j6zxs"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.35,
      transformOrigin: "70.0542px 352.886px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.53,367.85c7.6,15.63,20.54,25.2,36,26.46,17.6,1.43,24.71-14.2,24.78-14.36l-1-1.1c-.28.6-7.26,15-23.6,13.68-15.93-1.3-29.1-11.89-36.13-29a124.22,124.22,0,0,1-7.18-25.26,69,69,0,0,0-2-8.48c-2.2-6.54.48-14,6-17.11l-1.23-1.31c-6.25,3.55-8.93,11.66-6.46,19a67,67,0,0,1,1.91,8.25,126.79,126.79,0,0,0,7.29,25.6C44.4,365.43,45,366.66,45.53,367.85Z",
    id: "el7pk824jtvn",
    className: "animable",
    style: {
      transformOrigin: "70.0542px 352.886px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "el6mr1amqzzyb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.43,362.18s2.58,4.48,1.2,7-16.82,5.55-26.94-6-7.43-29.46-4.8-29.92a5.45,5.45,0,0,1,4.53,1.53Z",
    style: {
      fill: "current",
      opacity: 0.3,
      transformOrigin: "73.7555px 352.366px"
    },
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cucumber--inject-3",
    className: "animable",
    style: {
      transformOrigin: "430.229px 167.892px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--cucumber--inject-3",
    className: "animable",
    style: {
      transformOrigin: "430.229px 167.892px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M400.48,145c-3.64,4.17-4.54,10.74-1.81,18.74,5.45,16,23.3,31.61,39.87,34.89,8.29,1.64,14.69-.12,18.34-4.28l3.1-3.54c3.64-4.17,4.53-10.74,1.81-18.74-5.45-16-23.3-31.62-39.88-34.9-8.28-1.64-14.68.12-18.33,4.29Zm6.31.67c2.91-1.93,7.21-2.43,12.42-1.4,7.14,1.42,14.84,5.49,21.67,11.46s11.88,13.07,14.23,20c1.71,5,1.79,9.36.27,12.49-2.91,1.92-7.21,2.42-12.42,1.39-7.14-1.41-14.84-5.48-21.67-11.45s-11.88-13.07-14.23-20C405.35,153.13,405.27,148.8,406.79,145.67Z",
    style: {
      fill: "current",
      transformOrigin: "430.228px 167.9px"
    },
    id: "elpbdh48h0kj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elfi6hp6we41d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M421.91,137.17c8.56,1.7,17.45,6.68,24.81,13.31l-5.15,5.89c-.24-.21-.45-.43-.69-.64-6.83-6-14.53-10-21.67-11.46-5.21-1-9.51-.53-12.42,1.4-1.52,3.13-1.44,7.46.27,12.49,2.35,6.89,7.4,14,14.23,20l.72.59-6.86,7.85c-7.55-6.41-13.67-14.56-16.48-22.82-2.73-8-1.83-14.57,1.81-18.74l3.1-3.54C407.23,137.29,413.63,135.53,421.91,137.17Z",
    style: {
      opacity: 0.1,
      transformOrigin: "421.9px 161.581px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M422.23,140.83c7.14,1.41,14.84,5.48,21.66,11.45s11.89,13.07,14.24,20c2.1,6.16,1.74,11.28-1,14.42a5.49,5.49,0,0,1-.53.55l0,0c-.12.12-.25.23-.38.34l-.31.25c-.16.12-.31.23-.48.34-2.89,1.93-7.2,2.42-12.4,1.39-7.15-1.41-14.85-5.48-21.68-11.45s-11.88-13.07-14.23-20c-1.71-5-1.79-9.36-.27-12.49.11-.21.22-.42.34-.63l.09-.13a4.3,4.3,0,0,1,.35-.52.09.09,0,0,1,0,0,6.9,6.9,0,0,1,.47-.6C410.82,140.6,415.85,139.56,422.23,140.83Z",
    style: {
      fill: "current",
      transformOrigin: "432.626px 165.199px"
    },
    id: "elyl40uoueoa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elabognqdnv"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M422.23,140.83c7.14,1.41,14.84,5.48,21.66,11.45s11.89,13.07,14.24,20c2.1,6.16,1.74,11.28-1,14.42a5.49,5.49,0,0,1-.53.55l0,0c-.12.12-.25.23-.38.34l-.31.25c-.16.12-.31.23-.48.34-2.89,1.93-7.2,2.42-12.4,1.39-7.15-1.41-14.85-5.48-21.68-11.45s-11.88-13.07-14.23-20c-1.71-5-1.79-9.36-.27-12.49.11-.21.22-.42.34-.63l.09-.13a4.3,4.3,0,0,1,.35-.52.09.09,0,0,1,0,0,6.9,6.9,0,0,1,.47-.6C410.82,140.6,415.85,139.56,422.23,140.83Z",
    style: {
      opacity: 0.1,
      transformOrigin: "432.626px 165.199px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M403.84,141.69c-3.61,4.13-4.49,10.64-1.79,18.56,5.39,15.85,23.08,31.32,39.5,34.57,8.21,1.63,14.55-.12,18.16-4.24s4.5-10.64,1.8-18.57c-5.4-15.84-23.08-31.32-39.51-34.57C413.79,135.82,407.46,137.56,403.84,141.69Z",
    style: {
      fill: "current",
      transformOrigin: "431.778px 166.132px"
    },
    id: "el64yyx24xima",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el643b6782uh6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M403.84,141.69c-3.61,4.13-4.49,10.64-1.79,18.56,5.39,15.85,23.08,31.32,39.5,34.57,8.21,1.63,14.55-.12,18.16-4.24s4.5-10.64,1.8-18.57c-5.4-15.84-23.08-31.32-39.51-34.57C413.79,135.82,407.46,137.56,403.84,141.69Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "431.778px 166.132px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M445.53,150.42c7.43,6.5,13,14.28,15.55,21.89s1.95,13.86-1.67,18-9.88,5.57-17.62,4c-7.89-1.56-16.33-6-23.76-12.5s-13-14.28-15.55-21.9c-2.55-7.47-2-13.86,1.67-18s9.88-5.57,17.62-4c7.89,1.56,16.32,6,23.76,12.51m.49-.57c-7.21-6.31-15.82-11-24.11-12.68s-14.68.12-18.33,4.29S399,152.2,401.77,160.2s8.55,15.9,15.76,22.21,15.83,11,24.11,12.68,14.69-.12,18.34-4.28,4.53-10.74,1.81-18.74-8.55-15.9-15.77-22.22Z",
    style: {
      fill: "current",
      transformOrigin: "431.769px 166.13px"
    },
    id: "elh5s2q06jygv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elqih3da1l3r"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M457.08,184.42l.12-13.23a3.4,3.4,0,0,0-2.77-2.77l-17.34-1.83c-1.52-.16-1.57,1.56-.09,2.86l17.22,15.06C455.53,185.66,457.07,185.61,457.08,184.42ZM433.5,170.7l4.11,16.94a3.4,3.4,0,0,0,3.11,2.38l13.1-1.87c1.18-.17,1-1.71-.29-2.85l-17.21-15.07C434.83,168.93,433.14,169.21,433.5,170.7Zm-23.71-20.85c-1.36-1-2.72-.7-2.55.53l1.94,14.1a3.41,3.41,0,0,0,3,2.57L428.36,166c1.39-.09,1.1-1.95-.49-3.1Zm19.4,17.54-16.14,1.08c-1.22.08-1.18,1.57.08,2.76l14.12,13.29c1.23,1.16,2.8,1.25,3,.16l2-14.36C432.41,169.06,430.59,167.3,429.19,167.39Zm7.05-2,14-3.91c1.06-.3.76-1.85-.56-2.92l-15-12.22c-1.34-1.1-2.83-.94-2.75.28l1.08,16.14C433,164.18,435,165.76,436.24,165.41Zm-8.84-22.08-14.23-.05c-1.25,0-1.35,1.38-.19,2.6l15.31,16.19c1.34,1.43,3.22,1.47,3.13.08L430.34,146A3.42,3.42,0,0,0,427.4,143.33Z",
    style: {
      fill: "current",
      opacity: 0.4,
      transformOrigin: "432.213px 166.64px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M450.8,175.49c-1.94-1.93-3.17-2.68-4.15-1.92s-.29,1.94,1.66,3.87,4.85,3.54,5.38,3.13S452.74,177.42,450.8,175.49Z",
    style: {
      fill: "current",
      transformOrigin: "450.003px 176.956px"
    },
    id: "elnqu2f8bjsu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elckzsm4xbsit"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M450.8,175.49c-1.94-1.93-3.17-2.68-4.15-1.92s-.29,1.94,1.66,3.87,4.85,3.54,5.38,3.13S452.74,177.42,450.8,175.49Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "450.003px 176.956px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M455.14,176.71c-.25-2-.87-3.16-2.65-3.83s-2.15.14-1.89,2.13,1.86,4.72,2.82,5.08S455.4,178.7,455.14,176.71Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "452.853px 176.393px"
    },
    id: "elpih17mt5yok",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.13,183.11c-2.17-1.67-3.08-2.79-2.45-3.87s1.88-.53,4.06,1.14,4.14,4.34,3.81,4.92S446.3,184.78,444.13,183.11Z",
    style: {
      fill: "current",
      transformOrigin: "445.535px 182.07px"
    },
    id: "elqd5fgvu1sva",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elvtc0r23cp2l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M444.13,183.11c-2.17-1.67-3.08-2.79-2.45-3.87s1.88-.53,4.06,1.14,4.14,4.34,3.81,4.92S446.3,184.78,444.13,183.11Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "445.535px 182.07px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M445.92,187.25c-2,0-3.25-.44-4.15-2.12s-.15-2.15,1.86-2.16,4.93,1.22,5.41,2.12S447.92,187.24,445.92,187.25Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "445.26px 185.11px"
    },
    id: "elakx07lz0bs5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.69,174.26c2.07.11,2.87-.29,2.06-2s-2.06-2.19-4.13-2.3-3.79,1-3.36,1.91S420.63,174.15,422.69,174.26Z",
    style: {
      fill: "current",
      transformOrigin: "421.127px 172.115px"
    },
    id: "elsyld2f6dfa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elgqee4rrkeqj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M422.69,174.26c2.07.11,2.87-.29,2.06-2s-2.06-2.19-4.13-2.3-3.79,1-3.36,1.91S420.63,174.15,422.69,174.26Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "421.127px 172.115px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M421.37,177.1c2.13,1.74,3.38,2.34,4.1,1.33s-.14-2.13-2.26-3.88-5-3-5.44-2.43S419.25,175.36,421.37,177.1Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "421.713px 175.451px"
    },
    id: "elzeuq9qyapai",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.59,160.45a3.46,3.46,0,0,1,4.14,1.56c1.14,1.66.56,2.29-1.23,2.65s-4.65-.45-5.26-1.33S412.8,160.81,414.59,160.45Z",
    style: {
      fill: "current",
      transformOrigin: "415.697px 162.504px"
    },
    id: "elo42x89ozqn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elpx1ln0v0a3d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M414.59,160.45a3.46,3.46,0,0,1,4.14,1.56c1.14,1.66.56,2.29-1.23,2.65s-4.65-.45-5.26-1.33S412.8,160.81,414.59,160.45Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "415.697px 162.504px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M410.17,158c0-1.88.49-2.59,2.28-1.76s2.29,2,2.29,3.88-1.32,3.39-2.28,2.95S410.17,159.87,410.17,158Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "412.455px 159.522px"
    },
    id: "elax4nisma0qh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.12,149.24a3.48,3.48,0,0,0,2.1,3.89c1.79.91,2.34.25,2.47-1.57s-1.07-4.55-2-5S424.25,147.41,424.12,149.24Z",
    style: {
      fill: "current",
      transformOrigin: "426.378px 150.003px"
    },
    id: "eljghl8246iu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el747e3e7hw39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M424.12,149.24a3.48,3.48,0,0,0,2.1,3.89c1.79.91,2.34.25,2.47-1.57s-1.07-4.55-2-5S424.25,147.41,424.12,149.24Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "426.378px 150.003px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M421.1,145.18c-1.87.25-2.5.82-1.44,2.49s2.28,2,4.15,1.76,3.19-1.76,2.62-2.65S423,144.93,421.1,145.18Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "422.855px 147.32px"
    },
    id: "elr7574z53hig",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.89,155.43c.38,2,.09,2.89-1.68,2.3s-2.45-1.75-2.83-3.78.5-3.9,1.45-3.59S438.51,153.4,438.89,155.43Z",
    style: {
      fill: "current",
      transformOrigin: "436.663px 154.118px"
    },
    id: "el40s0m34sjwk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el8y6yc32z3px"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M438.89,155.43c.38,2,.09,2.89-1.68,2.3s-2.45-1.75-2.83-3.78.5-3.9,1.45-3.59S438.51,153.4,438.89,155.43Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "436.663px 154.118px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M441.53,153.75c2,1.87,2.76,3,1.87,3.88s-2.14.15-4.15-1.73-3.61-4.61-3.13-5.06S439.52,151.87,441.53,153.75Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "439.901px 154.38px"
    },
    id: "el432wu9taq7p",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shrimp--inject-3",
    className: "animable",
    style: {
      transformOrigin: "429.825px 364.438px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--shrimp--inject-3",
    className: "animable",
    style: {
      transformOrigin: "429.825px 364.438px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M410.43,353.49c-5.8-3.32-16.76-3.92-17.06,1.29s5.79,5.82,12.32,3.81c-4.4,6-3.69,11.17.31,11.94s8.56-5,6.12-13Z",
    style: {
      fill: "current",
      transformOrigin: "403.082px 360.765px"
    },
    id: "elvxn4m6tn9qb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elljeewldmynm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M410.43,353.49c-5.8-3.32-16.76-3.92-17.06,1.29s5.79,5.82,12.32,3.81c-4.4,6-3.69,11.17.31,11.94s8.56-5,6.12-13Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "403.082px 360.765px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elnfsrks94hr"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M398.54,354.7c1.85-1.1,4.46-1.12,6.53-.79a18.56,18.56,0,0,1,3.13.76c.52.17,1,.35,1.54.54a4.65,4.65,0,0,1,1.39.65c.53-.32.7.76.26,1.05a9.64,9.64,0,0,0-3.37,3.82,12.89,12.89,0,0,0-1.16,5c0,.31-.36.2-.42,0a8.73,8.73,0,0,1,1-5.8,10.78,10.78,0,0,1,2.7-3.34l-.66-.27c-.52-.19-1-.37-1.56-.53a26.58,26.58,0,0,0-3.16-.8,18.83,18.83,0,0,0-3-.3,27.07,27.07,0,0,0-3.11.31C398.58,355,398.43,354.77,398.54,354.7Z",
    style: {
      fill: "current",
      opacity: 0.4,
      transformOrigin: "405.071px 359.823px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M410.32,353.22c13.93-14.87,37.48-13,47.81-1.33,5.12,5.76,8.83,14.24,6.52,23.93-2.26,9.48-23,4.31-23.55-1.4-1-10.58-6.3-15.77-13.44-17.71-6.1-1.66-15.54.83-15.54.83S409.1,356.18,410.32,353.22Z",
    style: {
      fill: "current",
      transformOrigin: "437.691px 361.834px"
    },
    id: "eleahqpw46gbc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el1gaddz9boor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M410.32,353.22c13.93-14.87,37.48-13,47.81-1.33,5.12,5.76,8.83,14.24,6.52,23.93-2.26,9.48-23,4.31-23.55-1.4-1-10.58-6.3-15.77-13.44-17.71-6.1-1.66-15.54.83-15.54.83S409.1,356.18,410.32,353.22Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "437.691px 361.834px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elt6j5bfo316k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M434.3,357c2.18-3.51,5.79-6.51,9.94-7.15.08,0,.21.13.12.19a46.81,46.81,0,0,0-4,3,19.5,19.5,0,0,0-3.78,4.51,12.1,12.1,0,0,0-1.44,3.14,16.08,16.08,0,0,0-2-1.54A15.82,15.82,0,0,1,434.3,357Z",
    style: {
      fill: "current",
      opacity: 0.4,
      transformOrigin: "438.765px 355.27px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eluha3jrl2o7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M441.41,363.17c3.48-2.24,8-3.39,12-2.18.08,0,.13.21,0,.23a45.22,45.22,0,0,0-4.9,1,19.48,19.48,0,0,0-5.35,2.44,9.83,9.83,0,0,0-3.46,3.38,19.73,19.73,0,0,0-1.11-2.64A14.47,14.47,0,0,1,441.41,363.17Z",
    style: {
      fill: "current",
      opacity: 0.4,
      transformOrigin: "446.04px 364.27px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el5wivwhe79dq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M426.35,356.43a18.05,18.05,0,0,0-2.24-.25c1.2-3.76,3.76-7.33,7.37-9,.07,0,.23.07.17.15a46.45,46.45,0,0,0-3,4A19.24,19.24,0,0,0,426.35,356.43Z",
    style: {
      fill: "current",
      opacity: 0.4,
      transformOrigin: "427.887px 351.805px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M442.64,370.86a3.8,3.8,0,0,1,.37-.33c.27-.22.6-.36.87-.59A4.88,4.88,0,0,1,448,368.8c2.43.5,3.34,2.33,7.7.26s7.89-.84,8.4,2.42c.05.29.18.56.26.85a.93.93,0,0,0,.13.31c.19.33.46.62.68.93a6.55,6.55,0,0,1,1,2.09l0,.06a3.11,3.11,0,0,1-1.16,3.37c-.77.46-1.84.47-2.41,1.18a4.42,4.42,0,0,0-.57,1.66,4.16,4.16,0,0,1-2.08,2.55,4.43,4.43,0,0,1-2.3.44c-.55,0-1.11.05-1.66,0-.39,0-.76-.15-1.15-.18a3.91,3.91,0,0,0-1.13.11,12.57,12.57,0,0,0-2.11.81,4.77,4.77,0,0,1-3.18.54c-1.29-.37-2.08-1.64-3.12-2.5-1.58-1.31-3.87-1.74-5.09-3.39a3.94,3.94,0,0,1-.34-4.05c.43-.87,1.19-1.56,1.55-2.46.22-.56.27-1.17.48-1.73A3.48,3.48,0,0,1,442.64,370.86Z",
    style: {
      fill: "current",
      transformOrigin: "452.877px 377.159px"
    },
    id: "elxx33hvg28w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elhf3ndnkez3f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M442.64,370.86a3.8,3.8,0,0,1,.37-.33c.27-.22.6-.36.87-.59A4.88,4.88,0,0,1,448,368.8c2.43.5,3.34,2.33,7.7.26s7.89-.84,8.4,2.42c.05.29.18.56.26.85a.93.93,0,0,0,.13.31c.19.33.46.62.68.93a6.55,6.55,0,0,1,1,2.09l0,.06a3.11,3.11,0,0,1-1.16,3.37c-.77.46-1.84.47-2.41,1.18a4.42,4.42,0,0,0-.57,1.66,4.16,4.16,0,0,1-2.08,2.55,4.43,4.43,0,0,1-2.3.44c-.55,0-1.11.05-1.66,0-.39,0-.76-.15-1.15-.18a3.91,3.91,0,0,0-1.13.11,12.57,12.57,0,0,0-2.11.81,4.77,4.77,0,0,1-3.18.54c-1.29-.37-2.08-1.64-3.12-2.5-1.58-1.31-3.87-1.74-5.09-3.39a3.94,3.94,0,0,1-.34-4.05c.43-.87,1.19-1.56,1.55-2.46.22-.56.27-1.17.48-1.73A3.48,3.48,0,0,1,442.64,370.86Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "452.877px 377.159px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elmtvjzpq2sh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M444,376.93c.05-.14.19-.31.36-.26.48.15.77.72,1.17,1a4,4,0,0,0,1.32.6,4.73,4.73,0,0,0,2.95-.15,4.43,4.43,0,0,0,2-1.86,5,5,0,0,0,.62-1.49l.49-1.92c.05-.13.22-.24.3-.07a17,17,0,0,0,1,2.3,4,4,0,0,0,1.89,1.57,3.6,3.6,0,0,0,4.39-1c.08-.11.18,0,.17.12a2.46,2.46,0,0,1-1.79,2,4.81,4.81,0,0,1-5.5-1.74q-.15-.22-.27-.45a4.8,4.8,0,0,1-.45,1.18,5.62,5.62,0,0,1-2.77,2.41l-.34.13.26.26a6.57,6.57,0,0,0,.79.6,4,4,0,0,0,1.8.65,3.11,3.11,0,0,0,1.62-.29,2.26,2.26,0,0,0,.71-.51c.08-.09.16-.23.29-.24s.22.14.17.16c.19-.08-.09.43-.15.52l-.14.18a2.5,2.5,0,0,1-.31.34,3.09,3.09,0,0,1-.94.56,3.55,3.55,0,0,1-1.8.22,4.46,4.46,0,0,1-1.82-.7,5.75,5.75,0,0,1-.84-.63,4.43,4.43,0,0,1-.78-.86,5.36,5.36,0,0,1-2-.11C445.38,379.17,443.42,378.26,444,376.93Z",
    style: {
      fill: "current",
      opacity: 0.5,
      transformOrigin: "452.278px 377.238px"
    },
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Salmon--inject-3",
    className: "animable",
    style: {
      transformOrigin: "64.4984px 167.076px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--salmon--inject-3",
    className: "animable",
    style: {
      transformOrigin: "64.4984px 167.076px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.41,141.77a24,24,0,0,0-6.13,1.85c-6.48,3.14-8.3,11.25-11.12,17.24-1.26,2.66-2.55,5.48-2.29,8.41.29,3.43,2.62,6.29,4.85,8.92L44.38,186c3.67,4.33,9,9.81,15.23,8.88a149.74,149.74,0,0,0,22.45-5.59c2.29-.72,3.73-1.3,5-3.43a98.61,98.61,0,0,0,8.06-16.8,11.56,11.56,0,0,0,1-5.76,11.42,11.42,0,0,0-2.51-4.84c-4.5-5.93-9.77-13.09-16-17.26a10.05,10.05,0,0,0-3.94-1.75c-6.09-1-13,.91-19,1.89C53.91,141.5,53.15,141.63,52.41,141.77Z",
    style: {
      fill: "current",
      transformOrigin: "64.4984px 167.076px"
    },
    id: "el1gclabg1xet",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elawb3tsr2nk"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.41,141.77a24,24,0,0,0-6.13,1.85c-6.48,3.14-8.3,11.25-11.12,17.24-1.26,2.66-2.55,5.48-2.29,8.41.29,3.43,2.62,6.29,4.85,8.92L44.38,186c3.67,4.33,9,9.81,15.23,8.88a149.74,149.74,0,0,0,22.45-5.59c2.29-.72,3.73-1.3,5-3.43a98.61,98.61,0,0,0,8.06-16.8,11.56,11.56,0,0,0,1-5.76,11.42,11.42,0,0,0-2.51-4.84c-4.5-5.93-9.77-13.09-16-17.26a10.05,10.05,0,0,0-3.94-1.75c-6.09-1-13,.91-19,1.89C53.91,141.5,53.15,141.63,52.41,141.77Z",
    style: {
      opacity: 0.15,
      transformOrigin: "64.4984px 167.076px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M71,192.11a10.71,10.71,0,0,0-4.58-2.58,7.5,7.5,0,0,1-2.89-1.27,8.62,8.62,0,0,1-1.41-1.71c-.76-1.11-1.66-2.35-3.1-2.43-.07,0-.17.12-.11.19a26.19,26.19,0,0,1,2.7,3.64,6.73,6.73,0,0,0,3.27,2.69,16.29,16.29,0,0,1,4.54,2l.27.23,1.65-.41Z",
    style: {
      fill: "current",
      transformOrigin: "65.1158px 188.495px"
    },
    id: "eloho95dtp4q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.11,165.59c-.22-.1-.48.34-.29.48a3.43,3.43,0,0,1,1,2.78,14.64,14.64,0,0,0-.06,3.5A4.15,4.15,0,0,0,93,174.44c.21-.48.42-.95.62-1.44a2.64,2.64,0,0,1-.75-1.6C92.6,169.47,93.32,166.6,91.11,165.59Z",
    style: {
      fill: "current",
      transformOrigin: "92.1871px 170.008px"
    },
    id: "el45rcpgirpyo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.17,171c1.71,2.8,4.83,4.11,7.69,5.42A23.69,23.69,0,0,1,77.57,179,21.92,21.92,0,0,1,81,182.51a44.81,44.81,0,0,0,4.58,5.21,6.56,6.56,0,0,0,1.22-1.36c-2.17-1.77-3.76-4.13-5.58-6.24a15.74,15.74,0,0,0-7.51-4.94c-3.08-.94-6.25-1.76-8.18-4.56C65.36,170.43,65.08,170.79,65.17,171Z",
    style: {
      fill: "current",
      transformOrigin: "75.9763px 179.143px"
    },
    id: "el7q2rkrqj9xj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1,186a14.52,14.52,0,0,0-5.72-2.38c-2.29-.51-5.18-1-6.7-3-.08-.11-.28.1-.22.2a9,9,0,0,0,5.29,4c2.43.86,4.79,1.57,6.84,3.21a32.82,32.82,0,0,1,2.47,2.24l2-.61A32.91,32.91,0,0,0,77.1,186Z",
    style: {
      fill: "current",
      transformOrigin: "72.7545px 185.429px"
    },
    id: "el5yb4nuur6kf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3,171.67a18.66,18.66,0,0,1-5.44-2.24,10.58,10.58,0,0,1-2.09-1.92A21.42,21.42,0,0,0,72,165.25c-.47-.42-.82.31-.84.68-.09,1.51,1.52,3.14,2.53,4.09a12.68,12.68,0,0,0,4.52,2.75c1.76.6,3.66.84,5.36,1.6,1.41.63,3.08,2,3.19,3.71,0,.31.37,0,.38-.17C87.31,174.46,84.24,172.6,81.3,171.67Z",
    style: {
      fill: "current",
      transformOrigin: "79.1516px 171.668px"
    },
    id: "el1ptnzdv5kvb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.56,167.65c3.45,1.29,7.89.75,11.47.36,3.25-.35,6.46-1.06,9.7-1.58,2.79-.44,7.39-1,7.18-4.79A8.64,8.64,0,0,0,92.33,158a34.73,34.73,0,0,0-4-5.12c-1.39-1.6-2.67-3.32-4.15-4.86a29.07,29.07,0,0,0-10.94-7.48c-3.21-1.14-7.82-.12-11.12.29-4,.51-8,1.28-12,2-1.85.36-4.16,2-3.9,4.16a5.93,5.93,0,0,0,1.49,2.84c4.19,5.19,8.43,10.38,13.46,14.82A14.8,14.8,0,0,0,65.56,167.65Z",
    style: {
      fill: "current",
      transformOrigin: "70.0584px 154.24px"
    },
    id: "elk295vdvoo2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elxd5pusjso1c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.77,147.92a4.52,4.52,0,0,0-1.39,1.55,60.57,60.57,0,0,0-7.21,16.26,9,9,0,0,0-.44,3.78,8.76,8.76,0,0,0,1.42,3.2,90.58,90.58,0,0,0,9.19,11.51,49,49,0,0,0,7.48,7.27,3,3,0,0,0,1.2.61c1.31.25,2.34-1.07,3-2.24a56.41,56.41,0,0,0,4.86-11.92c1.13-4,1.73-8.61-.45-12.19a18.68,18.68,0,0,0-2.71-3.19q-4-4.09-7.82-8.37c-1.26-1.42-2.5-2.84-3.72-4.29C45.26,148.84,44.42,147,42.77,147.92Z",
    style: {
      opacity: 0.15,
      transformOrigin: "47.7922px 169.901px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el1pfk31hlbggh"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "70.145px 153.6px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.19,153a33.42,33.42,0,0,1-3.25-1.55c.87,1.08,1.76,2.15,2.65,3.22,3.63,1.33,8.35,2,10.56,5.4.14.21.46-.21.38-.38C60.59,155.39,56.15,154.59,52.19,153Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "55.7413px 155.789px"
    },
    id: "elhstbtl9t686",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.71,162.24a20.3,20.3,0,0,0-5.34-1.54c-1.79-.23-3.75.13-5.46-.48-1.94-.68-3.24-2.43-4.42-4a17.27,17.27,0,0,0-3.72-3.91c-3.13-2.19-7.14-2.6-10.51-4.31a12.53,12.53,0,0,1-4.73-3.93,8.59,8.59,0,0,1-.73-1.32l-.7.13a5.51,5.51,0,0,0-1.28.43,14,14,0,0,0,3,4.06c3.07,2.93,6.87,3.9,10.78,5.2A12,12,0,0,1,68,155.88c1.25,1.4,2.28,3,3.66,4.25a7.42,7.42,0,0,0,4.75,2.16,29.47,29.47,0,0,1,6,.57A26.43,26.43,0,0,1,89,165.73l.37.23a11,11,0,0,0,2.1-.68A38.8,38.8,0,0,0,85.71,162.24Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "70.145px 154.355px"
    },
    id: "elb4b6ldalsb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82,151.33a8,8,0,0,1-2.57-2c-.84-.87-1.72-1.68-2.61-2.5-.09-.08-.27.14-.21.22,1.23,1.58,2.5,3.5,4.2,4.63s3.88,1.42,5.71,2.19a29.62,29.62,0,0,1,4.91,2.69c-.67-.94-1.41-1.81-2.17-2.69L88,153.32C86,152.48,83.9,152.15,82,151.33Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "84.014px 151.686px"
    },
    id: "el8voiwckxoi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.53,141.35a13.69,13.69,0,0,0,4,3.19c1.69.9,3.57,1.33,5.25,2.23a12.88,12.88,0,0,1,4.72,4.35c.91,1.42,1.61,3,2.94,4.07a11,11,0,0,0,4,1.87c1.56.43,3.17.67,4.74,1.07a15.66,15.66,0,0,1,4.31,1.94c.16.1.39-.22.29-.36-1.82-2.44-5.42-2.89-8.18-3.56A12.21,12.21,0,0,1,76,154.27c-1.44-1.1-2.17-2.73-3.21-4.17a12.76,12.76,0,0,0-3.27-3.2,22.88,22.88,0,0,0-5.2-2.26,13.71,13.71,0,0,1-5-3.4Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "73.6672px 150.665px"
    },
    id: "elfb29brd70wg",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "el8rard7ppncl"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      transformOrigin: "47.17px 168.685px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.19,153.23q-.45.84-.87,1.68c.72.1,1.43.31,2.16.36a10.56,10.56,0,0,0,4.76-1.14,11.58,11.58,0,0,1,2.57-.79,4.93,4.93,0,0,1,1.33,0c-.33-.38-.66-.77-1-1.15a11.26,11.26,0,0,0-2.32.43c-2,.56-3.79,1.28-5.86.78Z",
    style: {
      fill: "current",
      transformOrigin: "43.73px 153.73px"
    },
    id: "elmu8xahmkr6n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.35,163.74a11,11,0,0,0,3.38-.17,9,9,0,0,0,3-1.57,18.31,18.31,0,0,1,3.33-2.1,5.63,5.63,0,0,1,1.71-.46,5.07,5.07,0,0,0,1.56-.12c.11,0,.26-.25.17-.36-1.37-1.68-4.69.49-5.95,1.33a9.29,9.29,0,0,1-4,1.73,18.66,18.66,0,0,1-4.22-.23l-.92-.1c-.22.63-.44,1.26-.64,1.89C35.65,163.62,36.51,163.69,37.35,163.74Z",
    style: {
      fill: "current",
      transformOrigin: "42.6488px 161.069px"
    },
    id: "eld33dk8hcmtn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,183.33a6.32,6.32,0,0,1-1.45.14c-2.35-.05-4.68-.67-7-.86a12,12,0,0,0-6.65,1.13l.42.48.54.6a11.11,11.11,0,0,1,1.62-.43,20,20,0,0,1,6.63.19,24.4,24.4,0,0,0,5.14.6C58.53,184.57,58.79,184,59,183.33Z",
    style: {
      fill: "current",
      transformOrigin: "51.45px 183.854px"
    },
    id: "el614djf9vqgm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38,168.82c4.26-1.12,7.48,2.39,11.63,2.47a9.27,9.27,0,0,0,4.8-1.21c1.55-.89,2.86-2.16,4.41-3.06a9.75,9.75,0,0,1,1.78-.79c-.08-.16-.14-.32-.23-.48a11.94,11.94,0,0,0-.91-1.24l-.26.1c-3.52,1.56-5.74,5-10,4.77-3.87-.17-7-3-11-2a15.29,15.29,0,0,0-4.5,2.24,5.19,5.19,0,0,0,.3,1A15,15,0,0,1,38,168.82Z",
    style: {
      fill: "current",
      transformOrigin: "47.17px 167.901px"
    },
    id: "elcpife6d976m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.23,175.65c2.16-1,4.73-.48,7-.13a30.11,30.11,0,0,1,3.76.86,6.81,6.81,0,0,0,2.76.33c2.25-.25,4.05-1.66,5.72-3.07,0,0,.07-.18,0-.13-1.81,1-4,2.06-6.13,1.88a21.87,21.87,0,0,1-3.87-1.1c-1.21-.33-2.45-.57-3.68-.79a10.52,10.52,0,0,0-6.09.29l-.59.29c.37.54.74,1.07,1.13,1.59Z",
    style: {
      fill: "current",
      transformOrigin: "46.3056px 174.959px"
    },
    id: "elw2it44b7cmg",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "el8npbj109odv"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.4,152.56a2.79,2.79,0,0,0,.34,1.86c2.7,5.82,9.14,9.67,10.5,15.94a17.93,17.93,0,0,1,.27,4.33,44.14,44.14,0,0,1-1,7.59,4.19,4.19,0,0,0-.13,1.65,1.3,1.3,0,0,0,1.09,1.1,1.56,1.56,0,0,0,.92-.32,7.78,7.78,0,0,0,2.1-2.32c2.57-3.95,4.27-8.6,7.87-11.64.9-.77,2-1.75,1.66-2.88-.3-.91-1.4-1.22-2.32-1.5-4.14-1.23-7.31-4.31-10.34-7.23-1.39-1.33-2.95-2.45-4.32-3.74C54.07,154.46,49.41,148.68,48.4,152.56Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.1,
      transformOrigin: "60.2227px 168.132px"
    },
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--poke-bowl--inject-3",
    className: "animable animator-active",
    style: {
      transformOrigin: "250.005px 283.027px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bowl--inject-3",
    className: "animable",
    style: {
      transformOrigin: "250.005px 283.027px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bowl--inject-3",
    className: "animable",
    style: {
      transformOrigin: "250.005px 307.074px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342.36,360.25c0-13.64-9-27.27-27.06-37.65-36.05-20.78-94.48-20.73-130.5.11-18,10.42-27,24.06-27,37.69,0,2.83,0,16.51,0,19.34,0,13.63,9,27.26,27.06,37.65,36.05,20.77,94.48,20.72,130.5-.12,18-10.41,27-24.06,27-37.69C342.38,376.75,342.36,363.07,342.36,360.25Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "250.084px 369.991px"
    },
    id: "elf8waoi5aw8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.07,344.61c-38,0-73.74-8.46-100.53-23.9-26.1-15-40.48-34.8-40.49-55.65s14.32-40.64,40.39-55.72c26.77-15.49,62.46-24,100.49-24.07s73.74,8.45,100.53,23.9c26.1,15,40.48,34.8,40.49,55.65s-14.33,40.64-40.39,55.72C323.79,336,288.1,344.57,250.07,344.61Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "250px 264.94px"
    },
    id: "elc1okxh42q9f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.07,344.61c31.77,0,61.9-6,86.57-17a70.84,70.84,0,0,0-17.57-13.84c-18.4-10.6-42.92-16.43-69-16.41s-50.63,5.89-69,16.53a70.65,70.65,0,0,0-17.55,13.87C188.15,338.71,218.3,344.63,250.07,344.61Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "250.08px 320.985px"
    },
    id: "el8eny0kiqfr8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395,267.14c0,.09,0,.19,0,.28-1.08,20.55-15.2,40.93-42.35,56.63-56.61,32.75-148.42,32.83-205.08.18-27.17-15.66-41.33-36-42.45-56.57v-.27c0-.78-.07-1.55-.07-2.33,0,.78,0,3.37,0,3.75A145,145,0,0,0,395,268.56c0-.38,0-3,0-3.75C395,265.59,395,266.36,395,267.14Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "250.025px 337.903px"
    },
    id: "el91wtfhiq8ej",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.08,272.56c0,21.45,13.84,43.14,42.34,59.22,56.71,32,148.61,31.9,205.27-.18,28.48-16.12,42.26-37.84,42.24-59.29a133.11,133.11,0,0,1-6.08,38.08C384,326.28,371,341.5,349.74,353.78c-55,31.83-144.26,31.91-199.33.17-21.35-12.3-34.43-27.58-39.24-43.53A142.66,142.66,0,0,1,105.08,272.56Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "250.005px 325.007px"
    },
    id: "elyda0vl40foh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.66,353a215.53,215.53,0,0,1-29.9-9.46.39.39,0,0,0-.4.05.43.43,0,0,0-.15.38c.5,3.57,1.32,7.34,2.11,11,.3,1.37.6,2.73.87,4.06a.4.4,0,0,0,.26.3c8.74,3.19,17.3,5.85,26.93,8.35h.11a.37.37,0,0,0,.24-.08.4.4,0,0,0,.16-.32c0-2.32,0-4.21,0-6,0-2.45,0-4.76.05-7.85A.39.39,0,0,0,194.66,353Zm-.55,8.25c0,.8,0,1.63,0,2.5a171.73,171.73,0,0,1-20.85-6c-.12-.78-.23-1.49-.34-2.16-.29-1.85-.54-3.48-.81-5.56,6.19,2.25,9.48,3.26,15.59,5,0,1.54.05,2.5.09,4-3.55-.95-5.43-1.5-8.82-2.56v-.09c-.06-.69-.11-1.15-.18-1.93a.41.41,0,0,0-.44-.37.4.4,0,0,0-.37.44c.07.79.12,1.24.19,1.94l0,.35a.43.43,0,0,0,.28.35c3.74,1.18,5.63,1.73,9.64,2.79a.45.45,0,0,0,.36-.07.43.43,0,0,0,.15-.33l0-.53c0-1.63-.07-2.61-.09-4.34a.39.39,0,0,0-.3-.38c-6.49-1.8-9.77-2.81-16.45-5.25a.39.39,0,0,0-.39.06.41.41,0,0,0-.15.37c.31,2.43.58,4.19.9,6.24.12.74.24,1.53.37,2.4a.39.39,0,0,0,.27.32A170.08,170.08,0,0,0,194,364.53h.11c0,.7,0,1.42,0,2.19-9.33-2.43-17.66-5-26.15-8.11-.26-1.26-.54-2.55-.82-3.85-.74-3.4-1.51-6.91-2-10.24a214.93,214.93,0,0,0,29,9.16C194.11,356.63,194.11,358.86,194.11,361.23Zm-35.9-20.52a126.34,126.34,0,0,1-28-17.07.41.41,0,0,0-.63.48c.59,1.41,1.26,3.07,2,4.85a132.21,132.21,0,0,0,6,13.61.33.33,0,0,0,.13.13,183,183,0,0,0,24.16,14.21.35.35,0,0,0,.18.05.39.39,0,0,0,.25-.1.4.4,0,0,0,.14-.42c-1.49-5.24-3-10.75-4-15.45A.38.38,0,0,0,158.21,340.71Zm-14.4-1.45c.42,1.16.64,1.75,1.08,2.91a.39.39,0,0,0,.17.21c3.44,2.1,5.19,3.07,8.93,5a.4.4,0,0,0,.57-.48c-.76-2.41-1.16-3.74-1.81-5.93a.4.4,0,0,0-.2-.24,104.51,104.51,0,0,1-15.25-9.28.41.41,0,0,0-.62.48l.55,1.41c1.29,3.35,2.31,6,3.84,9.51a.35.35,0,0,0,.15.17,104.76,104.76,0,0,0,19.38,10.69.51.51,0,0,0,.17,0h0c.19.7.39,1.4.59,2.1a183.41,183.41,0,0,1-23.16-13.69,131.91,131.91,0,0,1-5.88-13.43l-1.36-3.4a127.55,127.55,0,0,0,26.7,16.09c.72,3.51,1.76,7.45,2.85,11.39a103.89,103.89,0,0,1-18.77-10.37c-1.5-3.45-2.51-6.07-3.79-9.37l-.06-.16A104.47,104.47,0,0,0,152,341.33c.52,1.8.9,3,1.47,4.85-3.11-1.58-4.83-2.55-7.9-4.42-.41-1.08-.63-1.67-1-2.78a.41.41,0,0,0-.52-.24A.4.4,0,0,0,143.81,339.26Zm-16.7-15.08c-.75-1.88-1.46-3.67-2.08-5.13a.42.42,0,0,0-.09-.14c-6.9-6.58-12.27-14.15-17.72-25,.17.94.35,1.89.55,2.84,5,9.64,10.14,16.61,16.55,22.73.61,1.44,1.3,3.19,2,5,1.14,2.86,2.37,5.94,3.62,8.75A103.09,103.09,0,0,1,115.08,317c-1.35-3.88-2.43-7.2-3.6-11.11a70.67,70.67,0,0,0,9.27,12l.39,1c.63,1.62,1.17,3,1.87,4.73a80.67,80.67,0,0,1-5.55-6.43c-.55-1.49-.83-2.27-1.36-3.76a.41.41,0,0,0-.52-.25.4.4,0,0,0-.24.52c.53,1.51.82,2.3,1.38,3.83a.24.24,0,0,0,.06.11,84.34,84.34,0,0,0,7.1,8,.41.41,0,0,0,.51,0,.4.4,0,0,0,.16-.49c-1.13-2.76-1.81-4.48-2.66-6.65l-.41-1.05a.35.35,0,0,0-.08-.13,72,72,0,0,1-10.87-14.69.4.4,0,0,0-.51-.17.43.43,0,0,0-.23.49c1.57,5.38,2.84,9.38,4.55,14.26a.37.37,0,0,0,0,.11,103.85,103.85,0,0,0,16.18,17.38.3.3,0,0,0,.17.08c.29.63.58,1.24.87,1.82A130,130,0,0,1,114.1,318c.6,1.28,1.27,2.55,2,3.81a128.48,128.48,0,0,0,16.64,17,.37.37,0,0,0,.26.1.39.39,0,0,0,.26-.1.4.4,0,0,0,.09-.51A131.24,131.24,0,0,1,127.11,324.18Zm208.77,18.26a195.73,195.73,0,0,1-30.39,10.43.39.39,0,0,0-.3.4c.06,3.8.07,6.44.08,9.5,0,1.33,0,2.74,0,4.38a.43.43,0,0,0,.16.32.38.38,0,0,0,.25.09l.1,0a191.5,191.5,0,0,0,27.43-8.81.44.44,0,0,0,.24-.29c1.33-6,2.22-10.69,3-15.57a.41.41,0,0,0-.16-.38A.4.4,0,0,0,335.88,342.44Zm-2.45,12.31a.38.38,0,0,0-.21,0,153,153,0,0,1-20.87,7.17v-.62c.06-2.39.1-4,.12-6.53a164.75,164.75,0,0,0,15.88-5.47c-.18,1.5-.32,2.54-.57,4.32-3.52,1.35-5.42,2-9,3.17,0-.55.06-1,.1-1.64a.41.41,0,0,0-.39-.43.4.4,0,0,0-.42.38c-.05.89-.08,1.34-.14,2.24a.41.41,0,0,0,.16.34.39.39,0,0,0,.37.07c4-1.3,5.95-2,9.81-3.45a.42.42,0,0,0,.26-.33c.31-2.2.45-3.27.69-5.25a.4.4,0,0,0-.55-.42A169.43,169.43,0,0,1,312,354.1a.4.4,0,0,0-.29.38c0,2.71-.06,4.34-.12,6.82l0,1.16a.41.41,0,0,0,.16.33.38.38,0,0,0,.25.09H312a156.38,156.38,0,0,0,21.21-7.23c-.17.78-.34,1.58-.53,2.42a189.44,189.44,0,0,1-26.62,8.57c0-1.42,0-2.68,0-3.86,0-3,0-5.56-.09-9.2a196.62,196.62,0,0,0,29.53-10.09C335,347.09,334.3,350.63,333.43,354.75Zm57.18-53.27a.42.42,0,0,0-.51.17,66,66,0,0,1-10.36,13.83.29.29,0,0,0-.08.14c-.4,1.12-.77,2.15-1.12,3.16-1.05,3-2,5.81-3.53,9.58a.4.4,0,0,0,.14.48.39.39,0,0,0,.23.07.38.38,0,0,0,.28-.11,100.67,100.67,0,0,0,10.63-11.7q.7-1.53,1.29-3.06A101,101,0,0,1,376.42,327c1.15-3,2-5.38,2.89-7.91.34-1,.7-2,1.08-3.08a67,67,0,0,0,9-11.59c-.43,1.71-.85,3.3-1.48,5.65a73.27,73.27,0,0,1-5,6.56c.18-.52.35-1,.57-1.71a.41.41,0,0,0-.26-.51.39.39,0,0,0-.51.26c-.48,1.43-.72,2.18-1.23,3.67a.41.41,0,0,0,.7.39,77.57,77.57,0,0,0,6.41-8.26.61.61,0,0,0,.05-.12c.95-3.51,1.41-5.34,2.15-8.36A.41.41,0,0,0,390.61,301.48Zm-14.36,15.24a.28.28,0,0,0-.09.14c-.83,2-1.67,4.32-2.55,6.75-1.53,4.23-3.27,9-5.42,13.54a.39.39,0,0,0,.11.49.43.43,0,0,0,.25.09.39.39,0,0,0,.26-.09,126.19,126.19,0,0,0,12.95-12.39c.87-1.32,1.68-2.66,2.43-4a125.68,125.68,0,0,1-14.5,14.59c1.82-4,3.33-8.21,4.68-11.95.87-2.39,1.69-4.66,2.5-6.65a73.5,73.5,0,0,0,15.48-20.46c.2-1,.39-2.06.57-3.09A71.32,71.32,0,0,1,376.25,316.72Zm-4.66,5.17a.41.41,0,0,0-.14-.48.42.42,0,0,0-.5,0c-9.11,7.51-19,13.06-28.38,17.93a.43.43,0,0,0-.21.27c-1,4.81-2.24,10.1-4,16.12a.41.41,0,0,0,.13.42.37.37,0,0,0,.26.1.33.33,0,0,0,.17,0,137.66,137.66,0,0,0,24.82-14.63.47.47,0,0,0,.13-.15c2.07-4.39,3.74-9,5.21-13C370,326.09,370.78,323.87,371.59,321.89Zm-6.59,15a.37.37,0,0,0-.24.08,123.84,123.84,0,0,1-18.44,11.65c1-3.28,1.61-5.48,2.5-8.68l.05-.19a120,120,0,0,0,14.41-9l-.41,1.15c-.45,1.27-.89,2.48-1.52,4.2-3,2.12-4.74,3.23-7.8,5.05l.6-1.84a.4.4,0,0,0-.26-.51.39.39,0,0,0-.51.26l-.94,2.87a.4.4,0,0,0,.14.44.39.39,0,0,0,.46,0c3.72-2.2,5.46-3.32,8.88-5.7a.41.41,0,0,0,.14-.2c.66-1.79,1.11-3,1.57-4.32l.86-2.39a.39.39,0,0,0-.14-.46.4.4,0,0,0-.48,0,119.06,119.06,0,0,1-15.54,9.76.41.41,0,0,0-.19.24l-.1.36c-1,3.48-1.6,5.78-2.78,9.58a.41.41,0,0,0,.12.43.44.44,0,0,0,.27.09.39.39,0,0,0,.18,0,124.42,124.42,0,0,0,18.61-11.56c-.39.91-.8,1.83-1.23,2.74a137.2,137.2,0,0,1-23.79,14.12c1.58-5.62,2.71-10.59,3.69-15.14,8.94-4.66,18.37-9.93,27.15-17-.62,1.6-1.25,3.33-1.91,5.12C367.35,330.91,366.25,333.91,365,336.93ZM229.38,358.68a235.66,235.66,0,0,1-28.53-4.28.39.39,0,0,0-.34.08.4.4,0,0,0-.15.31l-.13,13.86a.41.41,0,0,0,.32.4,236.65,236.65,0,0,0,28.71,4.3h0a.38.38,0,0,0,.27-.1.43.43,0,0,0,.13-.3l.05-13.87A.4.4,0,0,0,229.38,358.68Zm-.48,10.77a191.3,191.3,0,0,1-21.57-2.94l.06-6.93c6,1.1,9.09,1.57,15.16,2.27l0,3.89c-3.49-.4-5.39-.66-8.9-1.21l0-1.74a.41.41,0,0,0-.41-.41h0a.4.4,0,0,0-.4.4l0,2.09a.42.42,0,0,0,.34.41c3.9.61,5.81.87,9.73,1.32a.4.4,0,0,0,.31-.1.37.37,0,0,0,.14-.3l0-4.71a.41.41,0,0,0-.36-.41c-6.44-.74-9.57-1.21-15.94-2.39a.39.39,0,0,0-.33.09.37.37,0,0,0-.15.31l-.07,7.76a.41.41,0,0,0,.34.4,194.85,194.85,0,0,0,22,3h.07v2.25A236.8,236.8,0,0,1,201,368.32l.13-13a235.09,235.09,0,0,0,27.77,4.16Zm70.74-15.06a.46.46,0,0,0-.34-.08,233.66,233.66,0,0,1-28.52,4.33.41.41,0,0,0-.37.41l.07,13.86a.4.4,0,0,0,.13.3.43.43,0,0,0,.28.11h0A236.18,236.18,0,0,0,299.63,369a.41.41,0,0,0,.32-.4l-.16-13.85A.42.42,0,0,0,299.64,354.39Zm-28.35,18.08-.07-13.06a233,233,0,0,0,27.76-4.2l.12,10H299a190,190,0,0,1-21.37,3.54l-.05-6.94c6.07-.71,9.2-1.19,15.16-2.3l0,3.89c-3.48.65-5.36,1-8.85,1.47l0-1.63a.4.4,0,0,0-.4-.4h0a.41.41,0,0,0-.41.41l0,2.09a.41.41,0,0,0,.14.3.42.42,0,0,0,.32.1c3.92-.57,5.82-.88,9.68-1.61a.38.38,0,0,0,.33-.4l0-4.71a.4.4,0,0,0-.48-.39c-6.37,1.19-9.5,1.66-15.94,2.41a.41.41,0,0,0-.36.41l.05,7.76a.41.41,0,0,0,.41.4h0A194.36,194.36,0,0,0,299.11,366l0,2.22A234,234,0,0,1,271.29,372.47Zm-6.48-13.25a.49.49,0,0,0-.31-.11,235.18,235.18,0,0,1-28.84,0,.45.45,0,0,0-.31.11.38.38,0,0,0-.12.29l0,13.87a.4.4,0,0,0,.38.41c4.81.29,9.66.43,14.51.43s9.7-.16,14.52-.46a.4.4,0,0,0,.38-.4l-.06-13.87A.42.42,0,0,0,264.81,359.22ZM236,373,236,360a237,237,0,0,0,28.08,0l0,10h-.05a194.82,194.82,0,0,1-21.72.31v-7c6.08.2,9.25.2,15.34,0v3.9c-3.53.12-5.44.15-9,.13v-1.69a.41.41,0,0,0-.81,0v2.1a.4.4,0,0,0,.4.4c3.94,0,5.87,0,9.81-.14a.41.41,0,0,0,.39-.4v-4.72a.4.4,0,0,0-.12-.29.45.45,0,0,0-.3-.11c-6.48.23-9.65.23-16.12,0a.47.47,0,0,0-.29.11.41.41,0,0,0-.13.29v7.77a.42.42,0,0,0,.4.41c3.55.12,6.39.18,9.07.18,4.05,0,7.76-.16,13.12-.48h0V373A238.51,238.51,0,0,1,236,373Z",
    style: {
      fill: "current",
      transformOrigin: "250.07px 333.965px"
    },
    id: "elhc1l57s6eu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elhfw6lm55i8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155,328.2c.34,2.94.7,5.87,1.1,8.8a131.73,131.73,0,0,0,4.75,21.31,136.5,136.5,0,0,0,7.12,17.95,96,96,0,0,0,9.28,15.81c.92,1.24,1.87,2.44,2.87,3.61A143.52,143.52,0,0,0,209.94,408c-7.07-12-19.59-37.36-19.06-66.6A180.46,180.46,0,0,1,155,328.2Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.1,
      transformOrigin: "182.47px 368.1px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elcx7e2qqsjao"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.83,391.85a102.66,102.66,0,0,1-9.18-16.17,127,127,0,0,1-11.52-40.83q-.42-3.72-.75-7.44c-2-1-4-2.08-5.87-3.18Q141.89,321,137,317.47c5.42,27.54,19.26,57,33.27,72.3,1.83,1.2,3.69,2.35,5.57,3.47C175.5,392.78,175.16,392.32,174.83,391.85Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.1,
      transformOrigin: "156.42px 355.355px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M352.49,205.65C295.83,173,204,173.08,147.41,205.83,119.11,222.2,105,243.64,105,265.06c0,.78,0,1.55.07,2.33v.27c1.12,20.55,15.28,40.91,42.45,56.57,56.66,32.65,148.47,32.57,205.08-.18,27.15-15.7,41.27-36.08,42.35-56.63,0-.09,0-.19,0-.28,0-.78.06-1.55.06-2.33C395,243.39,380.82,222,352.49,205.65Zm-1.93,114.89c-26.77,15.49-62.46,24-100.49,24.07s-73.74-8.46-100.53-23.9c-26.1-15-40.48-34.79-40.49-55.65s14.32-40.64,40.39-55.72c26.77-15.49,62.46-24,100.49-24.07s73.74,8.46,100.53,23.9c26.1,15,40.48,34.79,40.49,55.64S376.63,305.46,350.56,320.54Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "250.005px 264.94px"
    },
    id: "elym4h24mfta",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Avocados--inject-3",
    className: "animable",
    style: {
      transformOrigin: "262.829px 197.205px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.17,239.23s-9.66,18.15-30.37,15.17S196.17,236,189.32,215.77s-6.37-33.4-8.58-41.65,1.3-17.66,8.92-21.39Z",
    style: {
      fill: "current",
      transformOrigin: "221.129px 203.73px"
    },
    id: "elp68ghrfoddk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elwaqyqybgfgm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.17,239.23s-9.66,18.15-30.37,15.17S196.17,236,189.32,215.77s-6.37-33.4-8.58-41.65,1.3-17.66,8.92-21.39Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "221.129px 203.73px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M190,220.69c8,19.51,23,32.09,41.64,34.78,21.23,3.06,31-15.34,31.12-15.53l-1.18-1.42c-.39.71-9.93,17.64-29.63,14.8-19.22-2.77-34.38-16.6-41.6-37.9a151.07,151.07,0,0,1-6.81-31.15,84.59,84.59,0,0,0-1.75-10.43c-2.17-8.09,1.63-16.9,8.56-20.28l-1.4-1.69c-7.84,3.84-11.69,13.46-9.26,22.53a81.9,81.9,0,0,1,1.7,10.15,153.47,153.47,0,0,0,6.9,31.57Q189.08,218.46,190,220.69Z",
    style: {
      fill: "current",
      transformOrigin: "220.864px 203.842px"
    },
    id: "elmncj7lh51ko",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el0ojt4whwmlqo"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.35,
      transformOrigin: "220.864px 203.842px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190,220.69c8,19.51,23,32.09,41.64,34.78,21.23,3.06,31-15.34,31.12-15.53l-1.18-1.42c-.39.71-9.93,17.64-29.63,14.8-19.22-2.77-34.38-16.6-41.6-37.9a151.07,151.07,0,0,1-6.81-31.15,84.59,84.59,0,0,0-1.75-10.43c-2.17-8.09,1.63-16.9,8.56-20.28l-1.4-1.69c-7.84,3.84-11.69,13.46-9.26,22.53a81.9,81.9,0,0,1,1.7,10.15,153.47,153.47,0,0,0,6.9,31.57Q189.08,218.46,190,220.69Z",
    id: "elddar4gkoi5o",
    className: "animable",
    style: {
      transformOrigin: "220.864px 203.842px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "eltjbzt89pyom"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.64,217.12s2.78,5.64.92,8.62-20.8,5.46-32.2-9.34-6.78-36.26-3.56-36.63a6.62,6.62,0,0,1,5.37,2.21Z",
    style: {
      fill: "current",
      opacity: 0.3,
      transformOrigin: "225.146px 203.88px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M271.53,243.24s-16.42,12.37-33.94.91-24.51-31.75-22.17-53,8.35-33,9.83-41.38,8.63-15.45,17.12-15.61Z",
    style: {
      fill: "current",
      transformOrigin: "243.256px 191.589px"
    },
    id: "elyw1ywhbj6t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eljhvfh1evgt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.53,243.24s-16.42,12.37-33.94.91-24.51-31.75-22.17-53,8.35-33,9.83-41.38,8.63-15.45,17.12-15.61Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "243.256px 191.589px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M214,195.93c-1,21.08,7.28,38.81,23,49.12,17.94,11.75,34.6-.79,34.76-.92l-.47-1.79c-.65.49-16.45,11.8-33.1.9C221.94,232.6,214,213.67,216.5,191.31a151.24,151.24,0,0,1,7-31.12A85,85,0,0,0,226.32,150c1.45-8.25,8.61-14.62,16.33-14.76l-.56-2.12c-8.73.16-16.28,7.26-17.91,16.5a82.28,82.28,0,0,1-2.75,9.92,153.91,153.91,0,0,0-7.09,31.53C214.16,192.71,214,194.33,214,195.93Z",
    style: {
      fill: "current",
      transformOrigin: "242.839px 191.595px"
    },
    id: "els9gxlzodbh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elpxmy4bah2f"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.35,
      transformOrigin: "242.839px 191.595px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214,195.93c-1,21.08,7.28,38.81,23,49.12,17.94,11.75,34.6-.79,34.76-.92l-.47-1.79c-.65.49-16.45,11.8-33.1.9C221.94,232.6,214,213.67,216.5,191.31a151.24,151.24,0,0,1,7-31.12A85,85,0,0,0,226.32,150c1.45-8.25,8.61-14.62,16.33-14.76l-.56-2.12c-8.73.16-16.28,7.26-17.91,16.5a82.28,82.28,0,0,1-2.75,9.92,153.91,153.91,0,0,0-7.09,31.53C214.16,192.71,214,194.33,214,195.93Z",
    id: "elak0bil3tek",
    className: "animable",
    style: {
      transformOrigin: "242.839px 191.595px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "el79ezvcfejfh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.08,215.37s.14,6.28-2.81,8.2S240.12,219.73,236,201.5s9.18-35.74,12.25-34.7a6.62,6.62,0,0,1,3.94,4.26Z",
    style: {
      fill: "current",
      opacity: 0.3,
      transformOrigin: "249.648px 195.339px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M278.32,250.83s-20.11,4.27-31.14-13.52-8.8-39.13,2.29-57.37,21.49-26.35,26.39-33.35,14.36-10.35,22.11-6.91Z",
    style: {
      fill: "current",
      transformOrigin: "268.957px 194.798px"
    },
    id: "elu9jqk6s8v5n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el2e90nhhmi8u"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M278.32,250.83s-20.11,4.27-31.14-13.52-8.8-39.13,2.29-57.37,21.49-26.35,26.39-33.35,14.36-10.35,22.11-6.91Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "268.957px 194.798px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M246.14,183.62c-9.79,18.7-9.8,38.25.12,54.26,11.3,18.23,31.69,13.9,31.9,13.85l.32-1.82c-.79.17-19.9,3.74-30.38-13.18-10.23-16.5-9.38-37,2.29-56.23a151.05,151.05,0,0,1,19.5-25.24,85.33,85.33,0,0,0,6.86-8c4.8-6.87,14-9.61,21-6.48l.39-2.16c-8-3.54-17.83-.3-23.21,7.39a82.43,82.43,0,0,1-6.68,7.83,152.93,152.93,0,0,0-19.75,25.58C247.68,180.78,246.88,182.2,246.14,183.62Z",
    style: {
      fill: "current",
      transformOrigin: "268.474px 194.701px"
    },
    id: "elwbdf23hrrdr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elgpj5s0s6otu"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.35,
      transformOrigin: "268.474px 194.701px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.14,183.62c-9.79,18.7-9.8,38.25.12,54.26,11.3,18.23,31.69,13.9,31.9,13.85l.32-1.82c-.79.17-19.9,3.74-30.38-13.18-10.23-16.5-9.38-37,2.29-56.23a151.05,151.05,0,0,1,19.5-25.24,85.33,85.33,0,0,0,6.86-8c4.8-6.87,14-9.61,21-6.48l.39-2.16c-8-3.54-17.83-.3-23.21,7.39a82.43,82.43,0,0,1-6.68,7.83,152.93,152.93,0,0,0-19.75,25.58C247.68,180.78,246.88,182.2,246.14,183.62Z",
    id: "elf7tlrlt7xcu",
    className: "animable",
    style: {
      transformOrigin: "268.474px 194.701px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elursa8cldgms"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.34,222.42s-2.52,5.75-6,6.24S259.79,216.24,263.79,198s23.43-28.51,25.77-26.27a6.62,6.62,0,0,1,1.77,5.53Z",
    style: {
      fill: "current",
      opacity: 0.3,
      transformOrigin: "277.24px 200.05px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M281.27,260.58s-20-4.64-22.51-25.42,8.56-39.18,26.31-51,30.62-14.79,38-19.06,17.39-3.32,23,3.07Z",
    style: {
      fill: "current",
      transformOrigin: "302.238px 211.538px"
    },
    id: "el0eqpaena5lue",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elh88sr7si7he"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.27,260.58s-20-4.64-22.51-25.42,8.56-39.18,26.31-51,30.62-14.79,38-19.06,17.39-3.32,23,3.07Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "302.238px 211.538px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M280.5,186.07c-16.77,12.81-25.05,30.51-22.82,49.22,2.54,21.29,22.85,26,23.06,26l1.06-1.5c-.79-.19-19.61-5-22-24.79-2.29-19.28,7.14-37.5,25.85-50A150.87,150.87,0,0,1,314,170.4a83.34,83.34,0,0,0,9.62-4.4c7.25-4.18,16.74-2.79,21.8,3l1.27-1.78c-5.74-6.58-16-7.81-24.16-3.11a82.88,82.88,0,0,1-9.36,4.26,153.07,153.07,0,0,0-28.71,14.84C283.1,184.15,281.78,185.09,280.5,186.07Z",
    style: {
      fill: "current",
      transformOrigin: "302.006px 211.284px"
    },
    id: "elgeiue7rtmv8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elc40dlil03k"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.35,
      transformOrigin: "302.006px 211.284px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.5,186.07c-16.77,12.81-25.05,30.51-22.82,49.22,2.54,21.29,22.85,26,23.06,26l1.06-1.5c-.79-.19-19.61-5-22-24.79-2.29-19.28,7.14-37.5,25.85-50A150.87,150.87,0,0,1,314,170.4a83.34,83.34,0,0,0,9.62-4.4c7.25-4.18,16.74-2.79,21.8,3l1.27-1.78c-5.74-6.58-16-7.81-24.16-3.11a82.88,82.88,0,0,1-9.36,4.26,153.07,153.07,0,0,0-28.71,14.84C283.1,184.15,281.78,185.09,280.5,186.07Z",
    id: "elbdymxxtj35g",
    className: "animable",
    style: {
      transformOrigin: "302.006px 211.284px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "el3ad1fdq9l5e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297.83,237s-4.72,4.15-8.09,3.12-10.65-18.67.69-33.52,33.27-15.93,34.46-12.92a6.63,6.63,0,0,1-.74,5.76Z",
    style: {
      fill: "current",
      opacity: 0.3,
      transformOrigin: "304.778px 216.305px"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--cucumber--inject-3",
    className: "animable",
    style: {
      transformOrigin: "147.97px 222.715px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158,183c-6.58-2.72-14.42-1.68-21.95,3.77-15.07,10.9-23.21,35.32-18.18,54.53,2.52,9.6,7.85,16.09,14.43,18.81l5.6,2.32c6.58,2.72,14.42,1.68,22-3.77,15.06-10.9,23.2-35.31,18.17-54.53-2.51-9.6-7.85-16.09-14.43-18.81Zm2.57,7.14c3.68,2.6,6.5,7.17,8.08,13.21,2.17,8.28,1.65,18-1.46,27.32s-8.41,17.07-14.9,21.77c-4.74,3.42-9.55,4.84-13.86,4.13-3.68-2.6-6.5-7.17-8.08-13.2-2.17-8.29-1.65-18,1.46-27.33s8.41-17.07,14.9-21.77C151.42,190.83,156.24,189.41,160.55,190.12Z",
    style: {
      fill: "current",
      transformOrigin: "147.97px 222.715px"
    },
    id: "elhdtxn4sim6f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elr1tmsskhe9d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178,204.11c2.6,9.92,1.68,21.23-1.89,31.34l-9.31-3.85c.12-.32.25-.63.36-.95,3.11-9.34,3.63-19,1.46-27.32-1.58-6-4.4-10.61-8.08-13.21-4.31-.71-9.13.71-13.86,4.13-6.49,4.7-11.79,12.43-14.9,21.77-.11.33-.19.65-.29,1l-12.4-5.13c3.22-10.26,9.15-19.49,16.93-25.12,7.53-5.45,15.37-6.49,21.95-3.77l5.6,2.32C170.16,188,175.5,194.51,178,204.11Z",
    style: {
      opacity: 0.1,
      transformOrigin: "149.289px 208.502px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M174.08,205.58c2.17,8.28,1.65,18-1.46,27.32s-8.41,17.07-14.9,21.77c-5.8,4.2-11.73,5.38-16.69,3.33a9.06,9.06,0,0,1-.89-.42l-.07,0a6.63,6.63,0,0,1-.59-.31c-.15-.09-.3-.17-.44-.27l-.64-.41c-3.68-2.59-6.5-7.17-8.07-13.2-2.17-8.28-1.66-18,1.46-27.33s8.41-17.06,14.9-21.76c4.73-3.43,9.55-4.85,13.85-4.14.3,0,.59.11.89.18a1.06,1.06,0,0,1,.19.06,6,6,0,0,1,.77.22l.07,0c.31.09.62.21.92.33C168.34,193,172.15,198.19,174.08,205.58Z",
    style: {
      fill: "current",
      transformOrigin: "152.204px 224.482px"
    },
    id: "elv961rp3qtm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eln66owdbfu5a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.08,205.58c2.17,8.28,1.65,18-1.46,27.32s-8.41,17.07-14.9,21.77c-5.8,4.2-11.73,5.38-16.69,3.33a9.06,9.06,0,0,1-.89-.42l-.07,0a6.63,6.63,0,0,1-.59-.31c-.15-.09-.3-.17-.44-.27l-.64-.41c-3.68-2.59-6.5-7.17-8.07-13.2-2.17-8.28-1.66-18,1.46-27.33s8.41-17.06,14.9-21.76c4.73-3.43,9.55-4.85,13.85-4.14.3,0,.59.11.89.18a1.06,1.06,0,0,1,.19.06,6,6,0,0,1,.77.22l.07,0c.31.09.62.21.92.33C168.34,193,172.15,198.19,174.08,205.58Z",
    style: {
      opacity: 0.1,
      transformOrigin: "152.204px 224.482px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M163.46,185.66c-6.52-2.7-14.29-1.67-21.75,3.73-14.93,10.8-23,35-18,54,2.49,9.51,7.78,15.94,14.3,18.64s14.29,1.66,21.75-3.74c14.93-10.8,23-35,18-54C175.26,194.78,170,188.36,163.46,185.66Z",
    style: {
      fill: "current",
      transformOrigin: "150.735px 223.844px"
    },
    id: "el03p1wbp0pwnw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el6b3q2j430df"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.46,185.66c-6.52-2.7-14.29-1.67-21.75,3.73-14.93,10.8-23,35-18,54,2.49,9.51,7.78,15.94,14.3,18.64s14.29,1.66,21.75-3.74c14.93-10.8,23-35,18-54C175.26,194.78,170,188.36,163.46,185.66Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "150.735px 223.844px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M175.56,234.12c-3.38,10.17-9.2,18.62-16.37,23.81s-14.51,6.41-21.05,3.7-11.44-9.13-13.79-18.1c-2.39-9.15-1.84-19.78,1.55-29.95s9.2-18.62,16.37-23.8,14.51-6.41,21-3.71,11.44,9.14,13.79,18.11c2.39,9.15,1.84,19.78-1.55,29.94m.9.37c3.29-9.86,4.06-20.77,1.55-30.38S170.16,188,163.58,185.3s-14.42-1.68-22,3.77S128.29,203.35,125,213.21s-4.07,20.78-1.55,30.38,7.84,16.09,14.43,18.82,14.42,1.68,22-3.77,13.33-14.28,16.62-24.15Z",
    style: {
      fill: "current",
      transformOrigin: "150.703px 223.862px"
    },
    id: "elgws4qljsluo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elnqpy6050rig"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.51,257.27l14.9-3.94c1.31-.35,2.18-2.42,1.65-3.9L153,229.83c-.62-1.72-2.57-1.25-3.24.78l-7.85,23.54C141.32,255.94,142.18,257.62,143.51,257.27Zm3-30.12-16.82,9.72a3.27,3.27,0,0,0-1,4.15l9,13.82c.8,1.23,2.45.59,3-1.2l7.85-23.54C149.19,228.07,148,226.3,146.51,227.15Zm10.93-32.45c.38-1.8-.65-3.2-1.94-2.64l-14.79,6.47a3.24,3.24,0,0,0-1.27,4.12l9.68,17.4c.83,1.5,2.76.61,3.21-1.49ZM148,221.4,138.28,204c-.74-1.32-2.38-.82-3.05.93l-7.49,19.59c-.65,1.71.08,3.47,1.37,3.3l17.17-2.19C147.79,225.45,148.8,222.9,148,221.4Zm5.92,7.14,11.73,14.13c.88,1.07,2.46.27,3-1.51l5.8-20.27c.52-1.82-.43-3.4-1.76-2.93l-17.53,6.14A3.17,3.17,0,0,0,153.88,228.54ZM174,212l-7.42-15.65c-.65-1.37-2.25-1-3,.59l-10.11,21.79c-.89,1.92.05,4,1.56,3.47l17.53-6.15C173.87,215.62,174.65,213.44,174,212Z",
    style: {
      fill: "current",
      opacity: 0.4,
      transformOrigin: "151.047px 224.626px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M150.23,247.62c1.15-2.73,1.34-4.31,0-5.15s-2.32.29-3.46,3-1.42,6.42-.69,6.87S149.09,250.35,150.23,247.62Z",
    style: {
      fill: "current",
      transformOrigin: "148.421px 247.296px"
    },
    id: "el0n1gn7p82zf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elqsm70slzq4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.23,247.62c1.15-2.73,1.34-4.31,0-5.15s-2.32.29-3.46,3-1.42,6.42-.69,6.87S149.09,250.35,150.23,247.62Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "148.421px 247.296px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M151.14,252.76c2.1-.89,3.09-1.92,2.9-4.09s-1.28-2.31-3.37-1.42-4.32,3.5-4.22,4.66S149.05,253.66,151.14,252.76Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "150.255px 249.967px"
    },
    id: "elkalvs76y7sm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.19,242.64c.73-2.9,1.51-4.24,3-3.88s1.59,1.9.86,4.8-2.69,5.9-3.51,5.7S137.45,245.54,138.19,242.64Z",
    style: {
      fill: "current",
      transformOrigin: "140.125px 243.986px"
    },
    id: "el45a7nhpfgri",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el5jymtmyu3aw"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.19,242.64c.73-2.9,1.51-4.24,3-3.88s1.59,1.9.86,4.8-2.69,5.9-3.51,5.7S137.45,245.54,138.19,242.64Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "140.125px 243.986px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M134.48,245.87c-1.06-2.2-1.21-3.7.2-5.2s2.33-.83,3.39,1.38,1.23,5.79.47,6.59S135.55,248.08,134.48,245.87Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "136.331px 244.368px"
    },
    id: "elkwpv084tsj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.85,216.38c1,2.3,1.84,3.06,3.29,1.65s1.37-2.94.41-5.24-3.13-3.86-3.91-3.1S135.88,214.07,136.85,216.38Z",
    style: {
      fill: "current",
      transformOrigin: "138.669px 214.118px"
    },
    id: "elqxkro1dkk5h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elf127c3dp0za"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.85,216.38c1,2.3,1.84,3.06,3.29,1.65s1.37-2.94.41-5.24-3.13-3.86-3.91-3.1S135.88,214.07,136.85,216.38Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "138.669px 214.118px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M133,215.8c-.84,2.87-.85,4.42.66,4.9s2.32-.8,3.16-3.67.67-6.46-.13-6.72S133.81,212.93,133,215.8Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "134.903px 215.546px"
    },
    id: "el6rigxgav1j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.08,203.23c1.35,1.86,1.68,3.26.42,5s-2.27,1.32-3.62-.53-1.94-5.25-1.27-6.19S146.73,201.38,148.08,203.23Z",
    style: {
      fill: "current",
      transformOrigin: "146.311px 205.225px"
    },
    id: "elog3fuqgiw1m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ela7dp6do70b8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.08,203.23c1.35,1.86,1.68,3.26.42,5s-2.27,1.32-3.62-.53-1.94-5.25-1.27-6.19S146.73,201.38,148.08,203.23Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "146.311px 205.225px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M148.51,197.62c2.11-.58,3.16-.27,3.17,2s-1,3.13-3.15,3.71-4.49-.41-4.5-1.6S146.4,198.2,148.51,197.62Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "147.855px 200.433px"
    },
    id: "el0jjz5wot9gzi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.65,210.25c-2.11.43-3.18,1.25-3.26,3.5s1,2.65,3.06,2.23,4.54-2.57,4.58-3.77S167.76,209.83,165.65,210.25Z",
    style: {
      fill: "current",
      transformOrigin: "166.208px 213.145px"
    },
    id: "el6v65ld2u0ew",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elwex4hjbh55"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.65,210.25c-2.11.43-3.18,1.25-3.26,3.5s1,2.65,3.06,2.23,4.54-2.57,4.58-3.77S167.76,209.83,165.65,210.25Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "166.208px 213.145px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M168.61,205.69c-1.26-2-2.24-2.5-3.55-.82s-1.05,3.12.21,5.1,3.65,2.95,4.35,2.06S169.87,207.66,168.61,205.69Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "167.072px 208.109px"
    },
    id: "elb78bxnwj8ka",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.46,228.38c-2.08,1-3.19,1-3.46-1.15s.68-3.22,2.76-4.26,4.63-.65,4.77.48S168.54,227.33,166.46,228.38Z",
    style: {
      fill: "current",
      transformOrigin: "166.746px 225.695px"
    },
    id: "eli2h8gees6xq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el2wll9n59a1c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.46,228.38c-2.08,1-3.19,1-3.46-1.15s.68-3.22,2.76-4.26,4.63-.65,4.77.48S168.54,227.33,166.46,228.38Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "166.746px 225.695px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M169.74,230.75c-1.05,2.79-2,4-3.38,3.25s-1.29-2.31-.24-5.09,3.27-5.38,4-5S170.78,228,169.74,230.75Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "167.966px 229.045px"
    },
    id: "elnxwobnmn2y8",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--cucumber--inject-3",
    className: "animable",
    style: {
      transformOrigin: "188.115px 239.235px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.06,200.37c-6.37-3.2-14.26-2.74-22.17,2.15-15.83,9.76-25.74,33.51-22.14,53,1.81,9.76,6.65,16.62,13,19.82l5.41,2.72c6.37,3.2,14.27,2.74,22.18-2.14,15.83-9.77,25.73-33.52,22.13-53-1.8-9.77-6.64-16.63-13-19.83Zm2,7.31c3.48,2.86,6,7.63,7.09,13.76,1.56,8.42.33,18.06-3.46,27.14S197.08,265,190.26,269.2c-5,3.06-9.88,4.12-14.13,3.1-3.48-2.86-5.95-7.63-7.09-13.76-1.55-8.42-.32-18.06,3.47-27.15S182.15,215,189,210.78C193.94,207.71,198.85,206.66,203.09,207.68Z",
    style: {
      fill: "current",
      transformOrigin: "188.11px 239.215px"
    },
    id: "elxtdfbvp41w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eldbd43qo8ydr"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.48,222.92c1.86,10.08.11,21.28-4.18,31.11l-9-4.52c.14-.32.29-.61.43-.93,3.79-9.08,5-18.72,3.46-27.14-1.13-6.13-3.61-10.9-7.09-13.76-4.24-1-9.15,0-14.12,3.1-6.82,4.21-12.67,11.53-16.46,20.61-.13.32-.23.64-.36,1l-12-6c4-10,10.55-18.76,18.73-23.8,7.91-4.89,15.8-5.35,22.17-2.15l5.41,2.72C212.84,206.29,217.68,213.15,219.48,222.92Z",
    style: {
      opacity: 0.1,
      transformOrigin: "190.189px 226.216px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M215.45,224.09c1.56,8.42.32,18.06-3.46,27.14s-9.64,16.4-16.46,20.62c-6.09,3.76-12.09,4.5-16.89,2.09-.29-.15-.58-.31-.86-.49l-.07,0c-.19-.11-.37-.23-.56-.36l-.42-.29-.6-.46c-3.48-2.86-6-7.63-7.08-13.76-1.55-8.42-.33-18.07,3.46-27.15S182.15,215,189,210.78c5-3.06,9.88-4.13,14.12-3.1.29.07.58.14.88.24l.18.07c.24.08.5.17.75.28l.07,0c.3.12.6.26.89.4C210.66,211.11,214.07,216.57,215.45,224.09Z",
    style: {
      fill: "current",
      transformOrigin: "192.251px 241.315px"
    },
    id: "elko93qs0g68",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elq5uufkdal1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.45,224.09c1.56,8.42.32,18.06-3.46,27.14s-9.64,16.4-16.46,20.62c-6.09,3.76-12.09,4.5-16.89,2.09-.29-.15-.58-.31-.86-.49l-.07,0c-.19-.11-.37-.23-.56-.36l-.42-.29-.6-.46c-3.48-2.86-6-7.63-7.08-13.76-1.55-8.42-.33-18.07,3.46-27.15S182.15,215,189,210.78c5-3.06,9.88-4.13,14.12-3.1.29.07.58.14.88.24l.18.07c.24.08.5.17.75.28l.07,0c.3.12.6.26.89.4C210.66,211.11,214.07,216.57,215.45,224.09Z",
    style: {
      opacity: 0.1,
      transformOrigin: "192.251px 241.315px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M206.33,203.44c-6.31-3.17-14.13-2.71-22,2.12-15.68,9.68-25.5,33.2-21.93,52.55,1.79,9.68,6.58,16.47,12.89,19.64s14.13,2.71,22-2.12c15.68-9.68,25.49-33.2,21.92-52.55C217.43,213.41,212.64,206.61,206.33,203.44Z",
    style: {
      fill: "current",
      transformOrigin: "190.805px 240.595px"
    },
    id: "elil2hqdnrkei",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eli4xqrkwfgj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.33,203.44c-6.31-3.17-14.13-2.71-22,2.12-15.68,9.68-25.5,33.2-21.93,52.55,1.79,9.68,6.58,16.47,12.89,19.64s14.13,2.71,22-2.12c15.68-9.68,25.49-33.2,21.92-52.55C217.43,213.41,212.64,206.61,206.33,203.44Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "190.805px 240.595px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M214.84,252.66c-4.13,9.89-10.55,17.9-18.08,22.54s-14.95,5.33-21.27,2.15-10.73-10-12.42-19.07c-1.71-9.3-.38-19.86,3.74-29.75s10.55-17.89,18.08-22.54,15-5.32,21.27-2.15,10.73,9.95,12.41,19.08c1.72,9.29.39,19.86-3.73,29.74m.86.44c4-9.6,5.58-20.42,3.78-30.18s-6.64-16.63-13-19.83-14.26-2.74-22.17,2.15S170,218.5,166,228.09s-5.58,20.42-3.78,30.19,6.64,16.62,13,19.82,14.27,2.74,22.18-2.14S211.7,262.7,215.7,253.1Z",
    style: {
      fill: "current",
      transformOrigin: "190.85px 240.595px"
    },
    id: "el8ypk5sebgik",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elpzlge5gd4gk"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.17,273.39l15.15-2.84c1.32-.24,2.35-2.24,1.92-3.76l-5.59-20.06c-.49-1.76-2.47-1.44-3.29.53l-9.56,22.9C179.08,271.9,179.82,273.64,181.17,273.39Zm5.21-29.82L168.88,252a3.28,3.28,0,0,0-1.34,4l7.94,14.44c.71,1.29,2.4.77,3.12-1l9.56-22.9C189,244.68,187.91,242.83,186.38,243.57ZM199.65,212c.52-1.77-.4-3.25-1.73-2.78L182.7,214.6a3.24,3.24,0,0,0-1.58,4l8.38,18.06c.72,1.56,2.71.81,3.31-1.24ZM188.24,238l-8.37-18.06c-.64-1.37-2.32-1-3.12.71l-8.9,19c-.78,1.66-.18,3.47,1.12,3.4l17.28-.93C187.77,242,189,239.51,188.24,238Zm5.38,7.55,10.66,15c.8,1.13,2.43.45,3.07-1.29l7.28-19.79c.65-1.78-.18-3.42-1.54-3.06l-17.93,4.84A3.17,3.17,0,0,0,193.62,245.5Zm21.27-15-6.25-16.15c-.55-1.41-2.16-1.22-3,.37l-11.68,21c-1,1.84-.25,4,1.3,3.57l17.93-4.84A3.24,3.24,0,0,0,214.89,230.52Z",
    style: {
      fill: "current",
      opacity: 0.4,
      transformOrigin: "191.187px 241.273px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M188.58,264.26c1.34-2.63,1.65-4.2.34-5.14s-2.33.12-3.67,2.75-1.88,6.3-1.18,6.8S187.24,266.9,188.58,264.26Z",
    style: {
      fill: "current",
      transformOrigin: "186.761px 263.761px"
    },
    id: "elsumjuiry1y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el9ymn9apuprm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.58,264.26c1.34-2.63,1.65-4.2.34-5.14s-2.33.12-3.67,2.75-1.88,6.3-1.18,6.8S187.24,266.9,188.58,264.26Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "186.761px 263.761px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M189.11,269.46c2.16-.74,3.22-1.69,3.2-3.87s-1.11-2.4-3.27-1.66-4.56,3.17-4.55,4.33S187,270.2,189.11,269.46Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "188.4px 266.648px"
    },
    id: "elsla7dswm82d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.93,258.41c.95-2.84,1.82-4.12,3.33-3.64s1.44,2,.5,4.85-3.12,5.68-3.92,5.42S176,261.25,176.93,258.41Z",
    style: {
      fill: "current",
      transformOrigin: "178.836px 259.864px"
    },
    id: "elv4xu6868kxk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el0q0mg0xymb1d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.93,258.41c.95-2.84,1.82-4.12,3.33-3.64s1.44,2,.5,4.85-3.12,5.68-3.92,5.42S176,261.25,176.93,258.41Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "178.836px 259.864px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M173,261.36c-.9-2.27-.93-3.78.59-5.18s2.37-.64,3.28,1.63.79,5.86,0,6.61S173.9,263.64,173,261.36Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "174.942px 260.044px"
    },
    id: "elca79hnvul3c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.53,232.12c.79,2.37,1.61,3.19,3.16,1.89s1.59-2.83.79-5.2-2.83-4.07-3.66-3.38S176.73,229.75,177.53,232.12Z",
    style: {
      fill: "current",
      transformOrigin: "179.52px 229.95px"
    },
    id: "elfug1goykzv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elstlbntnyejb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.53,232.12c.79,2.37,1.61,3.19,3.16,1.89s1.59-2.83.79-5.2-2.83-4.07-3.66-3.38S176.73,229.75,177.53,232.12Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "179.52px 229.95px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M173.71,231.26c-1.05,2.8-1.17,4.35.29,4.94s2.38-.64,3.42-3.44,1.15-6.38.37-6.7S174.75,228.46,173.71,231.26Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "175.606px 231.189px"
    },
    id: "eli9h0p0a8v39",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.7,219.84c1.21,1.95,1.43,3.37.05,5s-2.36,1.15-3.57-.8-1.55-5.37-.81-6.26S188.49,217.89,189.7,219.84Z",
    style: {
      fill: "current",
      transformOrigin: "187.84px 221.639px"
    },
    id: "eluemv6bsmvx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elihzy2v4pk"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.7,219.84c1.21,1.95,1.43,3.37.05,5s-2.36,1.15-3.57-.8-1.55-5.37-.81-6.26S188.49,217.89,189.7,219.84Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "187.84px 221.639px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M190.54,214.27c2.15-.43,3.17,0,3,2.19s-1.27,3-3.42,3.47-4.45-.74-4.36-1.93S188.39,214.69,190.54,214.27Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "189.658px 217.077px"
    },
    id: "el24rnhae75nz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.7,228.13c-2.13.27-3.26,1-3.5,3.25s.74,2.71,2.88,2.44,4.72-2.22,4.85-3.42S208.84,227.86,206.7,228.13Z",
    style: {
      fill: "current",
      transformOrigin: "207.05px 230.992px"
    },
    id: "elbugebxeo7vn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el38e1zpprxgt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.7,228.13c-2.13.27-3.26,1-3.5,3.25s.74,2.71,2.88,2.44,4.72-2.22,4.85-3.42S208.84,227.86,206.7,228.13Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "207.05px 230.992px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M210,223.79c-1.11-2.06-2.05-2.65-3.48-1.07s-1.27,3-.16,5.1,3.41,3.21,4.18,2.37S211.1,225.86,210,223.79Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "208.243px 226.146px"
    },
    id: "el0hfw598ehght",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.18,246.26c-2.15.89-3.25.75-3.37-1.39s.92-3.16,3.07-4.05,4.66-.31,4.72.83S208.33,245.37,206.18,246.26Z",
    style: {
      fill: "current",
      transformOrigin: "206.701px 243.581px"
    },
    id: "elfz4gr4bfomf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elu479jcbf1hc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.18,246.26c-2.15.89-3.25.75-3.37-1.39s.92-3.16,3.07-4.05,4.66-.31,4.72.83S208.33,245.37,206.18,246.26Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "206.701px 243.581px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M209.27,248.88c-1.25,2.69-2.24,3.81-3.6,3s-1.12-2.39.13-5.09,3.66-5.12,4.39-4.68S210.52,246.18,209.27,248.88Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "207.653px 247.098px"
    },
    id: "elx5utjwsty88",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--cucumber--inject-3",
    className: "animable",
    style: {
      transformOrigin: "190.125px 267.805px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.07,228.94c-6.37-3.2-14.26-2.74-22.18,2.14-15.82,9.77-25.73,33.51-22.13,53,1.8,9.77,6.64,16.63,13,19.83l5.41,2.72c6.37,3.2,14.26,2.74,22.18-2.15,15.82-9.76,25.73-33.51,22.13-53-1.8-9.76-6.64-16.62-13-19.82Zm2,7.31c3.48,2.85,6,7.62,7.09,13.76,1.55,8.42.32,18.06-3.47,27.14s-9.63,16.4-16.46,20.61c-5,3.07-9.88,4.13-14.12,3.1-3.48-2.85-6-7.62-7.09-13.76-1.55-8.42-.32-18.06,3.47-27.14s9.63-16.4,16.46-20.61C196,236.28,200.86,235.22,205.1,236.25Z",
    style: {
      fill: "current",
      transformOrigin: "190.12px 267.785px"
    },
    id: "elyufglcpozsd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elnmla58modm8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221.49,251.48c1.86,10.09.11,21.29-4.19,31.12l-9-4.53c.14-.31.29-.61.42-.92,3.79-9.08,5-18.72,3.47-27.14-1.13-6.14-3.61-10.91-7.09-13.76-4.24-1-9.15,0-14.12,3.1-6.83,4.21-12.67,11.53-16.46,20.61-.13.32-.24.64-.36,1l-12-6c4-10,10.56-18.77,18.73-23.81,7.92-4.88,15.81-5.34,22.18-2.14l5.41,2.72C214.85,234.86,219.69,241.72,221.49,251.48Z",
    style: {
      opacity: 0.1,
      transformOrigin: "192.194px 254.786px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M217.46,252.66c1.55,8.42.32,18.06-3.47,27.13s-9.63,16.41-16.46,20.62c-6.09,3.77-12.09,4.5-16.88,2.09a7.25,7.25,0,0,1-.86-.48l-.07,0a6.65,6.65,0,0,1-.56-.36c-.14-.1-.29-.19-.42-.3l-.61-.46c-3.48-2.85-5.95-7.63-7.08-13.76-1.55-8.41-.33-18.06,3.46-27.15s9.65-16.39,16.47-20.6c5-3.07,9.87-4.13,14.12-3.11.29.08.58.15.87.25a1,1,0,0,1,.18.07,4.25,4.25,0,0,1,.75.28l.08,0c.3.11.6.26.89.4C212.67,239.67,216.08,245.14,217.46,252.66Z",
    style: {
      fill: "current",
      transformOrigin: "194.254px 269.898px"
    },
    id: "el6j8dpc5e5p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elgc3jtvfgtsu"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.46,252.66c1.55,8.42.32,18.06-3.47,27.13s-9.63,16.41-16.46,20.62c-6.09,3.77-12.09,4.5-16.88,2.09a7.25,7.25,0,0,1-.86-.48l-.07,0a6.65,6.65,0,0,1-.56-.36c-.14-.1-.29-.19-.42-.3l-.61-.46c-3.48-2.85-5.95-7.63-7.08-13.76-1.55-8.41-.33-18.06,3.46-27.15s9.65-16.39,16.47-20.6c5-3.07,9.87-4.13,14.12-3.11.29.08.58.15.87.25a1,1,0,0,1,.18.07,4.25,4.25,0,0,1,.75.28l.08,0c.3.11.6.26.89.4C212.67,239.67,216.08,245.14,217.46,252.66Z",
    style: {
      opacity: 0.1,
      transformOrigin: "194.254px 269.898px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M208.33,232c-6.3-3.17-14.12-2.72-22,2.12-15.68,9.67-25.5,33.2-21.93,52.55,1.79,9.67,6.58,16.47,12.89,19.64s14.13,2.71,22-2.13c15.68-9.67,25.5-33.2,21.93-52.54C219.44,242,214.64,235.18,208.33,232Z",
    style: {
      fill: "current",
      transformOrigin: "192.81px 269.153px"
    },
    id: "el2xv7ereqk1l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eldkup64l9fi7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.33,232c-6.3-3.17-14.12-2.72-22,2.12-15.68,9.67-25.5,33.2-21.93,52.55,1.79,9.67,6.58,16.47,12.89,19.64s14.13,2.71,22-2.13c15.68-9.67,25.5-33.2,21.93-52.54C219.44,242,214.64,235.18,208.33,232Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "192.81px 269.153px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M216.84,281.23c-4.12,9.89-10.54,17.89-18.08,22.54-7.39,4.56-14.94,5.32-21.26,2.14s-10.74-10-12.42-19.07c-1.72-9.29-.39-19.86,3.74-29.74s10.55-17.9,18.08-22.54,14.94-5.33,21.27-2.15,10.73,10,12.41,19.07c1.72,9.3.39,19.86-3.74,29.75m.87.43c4-9.59,5.58-20.41,3.78-30.18s-6.64-16.62-13-19.82-14.26-2.74-22.17,2.14S172,247.06,168,256.66s-5.58,20.42-3.78,30.18,6.64,16.63,13,19.83,14.26,2.74,22.18-2.15,14.34-13.26,18.35-22.86Z",
    style: {
      fill: "current",
      transformOrigin: "192.855px 269.165px"
    },
    id: "els3da34tuvdg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elrxvqsvztkn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.18,302l15.15-2.84c1.32-.25,2.34-2.25,1.92-3.76l-5.59-20.07c-.49-1.76-2.47-1.44-3.3.54l-9.55,22.9C181.08,300.47,181.82,302.21,183.18,302Zm5.2-29.82-17.49,8.46a3.27,3.27,0,0,0-1.34,4.06l7.94,14.44c.71,1.29,2.39.77,3.12-1l9.55-22.9C191,273.25,189.92,271.4,188.38,272.14Zm13.28-31.56c.52-1.77-.4-3.24-1.74-2.77l-15.22,5.36a3.25,3.25,0,0,0-1.57,4l8.37,18.06c.73,1.56,2.72.81,3.32-1.25Zm-11.41,25.93-8.38-18.06c-.63-1.37-2.31-1-3.11.72l-8.9,19c-.78,1.66-.18,3.46,1.12,3.39l17.28-.92C189.78,270.54,191,268.07,190.25,266.51Zm5.38,7.56L206.28,289c.81,1.13,2.44.45,3.08-1.28l7.28-19.8c.65-1.77-.18-3.42-1.54-3.05l-17.94,4.84A3.18,3.18,0,0,0,195.63,274.07Zm21.26-15-6.24-16.15c-.55-1.41-2.17-1.22-3.05.37l-11.69,21c-1,1.85-.24,4,1.31,3.57L215.15,263C216.51,262.66,217.45,260.53,216.89,259.09Z",
    style: {
      fill: "current",
      opacity: 0.4,
      transformOrigin: "193.177px 269.889px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M190.59,292.83c1.34-2.64,1.65-4.2.34-5.14s-2.33.11-3.67,2.75-1.89,6.3-1.19,6.8S189.25,295.47,190.59,292.83Z",
    style: {
      fill: "current",
      transformOrigin: "188.767px 292.331px"
    },
    id: "elxszowdgmu2m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elo4bul18b8ia"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.59,292.83c1.34-2.64,1.65-4.2.34-5.14s-2.33.11-3.67,2.75-1.89,6.3-1.19,6.8S189.25,295.47,190.59,292.83Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "188.767px 292.331px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M191.12,298c2.16-.74,3.22-1.7,3.19-3.87s-1.11-2.4-3.26-1.67-4.57,3.18-4.55,4.34S189,298.76,191.12,298Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "190.405px 295.192px"
    },
    id: "el32mlyw7lnj2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.94,287c.94-2.84,1.82-4.12,3.32-3.65s1.45,2,.5,4.85-3.11,5.68-3.91,5.43S178,289.81,178.94,287Z",
    style: {
      fill: "current",
      transformOrigin: "180.839px 288.45px"
    },
    id: "elp6ydbya9sj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elji0fdvdx85f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.94,287c.94-2.84,1.82-4.12,3.32-3.65s1.45,2,.5,4.85-3.11,5.68-3.91,5.43S178,289.81,178.94,287Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "180.839px 288.45px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M175,289.93c-.9-2.27-.94-3.78.58-5.18s2.38-.65,3.28,1.63.8,5.86,0,6.61S175.91,292.2,175,289.93Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "176.935px 288.612px"
    },
    id: "eleav29f6uyra",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.53,260.68c.8,2.37,1.61,3.19,3.17,1.89s1.58-2.82.79-5.19-2.84-4.08-3.67-3.38S178.74,258.32,179.53,260.68Z",
    style: {
      fill: "current",
      transformOrigin: "181.527px 258.514px"
    },
    id: "elo307kwabpw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elg0qt6yr6cj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.53,260.68c.8,2.37,1.61,3.19,3.17,1.89s1.58-2.82.79-5.19-2.84-4.08-3.67-3.38S178.74,258.32,179.53,260.68Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "181.527px 258.514px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M175.71,259.82c-1,2.8-1.17,4.35.29,4.95s2.38-.64,3.43-3.44,1.15-6.39.37-6.7S176.76,257,175.71,259.82Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "177.622px 259.762px"
    },
    id: "elm7ny5d9yt6i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.7,248.4c1.21,1.95,1.44,3.37.05,5s-2.36,1.15-3.57-.8-1.54-5.37-.81-6.26S190.5,246.45,191.7,248.4Z",
    style: {
      fill: "current",
      transformOrigin: "189.844px 250.199px"
    },
    id: "el8pl4cby3oo6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elntmk0vp6zi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.7,248.4c1.21,1.95,1.44,3.37.05,5s-2.36,1.15-3.57-.8-1.54-5.37-.81-6.26S190.5,246.45,191.7,248.4Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "189.844px 250.199px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M192.54,242.84c2.15-.43,3.18,0,3,2.19s-1.26,3-3.41,3.46-4.45-.74-4.37-1.92S190.4,243.26,192.54,242.84Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "191.659px 245.641px"
    },
    id: "el57yjvuyx8x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.71,256.69c-2.14.27-3.26,1-3.51,3.25s.75,2.72,2.89,2.45,4.71-2.23,4.84-3.42S210.84,256.42,208.71,256.69Z",
    style: {
      fill: "current",
      transformOrigin: "209.049px 259.557px"
    },
    id: "elrdw0d3ldue",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elzbcvlod8fq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.71,256.69c-2.14.27-3.26,1-3.51,3.25s.75,2.72,2.89,2.45,4.71-2.23,4.84-3.42S210.84,256.42,208.71,256.69Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "209.049px 259.557px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M212,252.36c-1.11-2.06-2.05-2.66-3.49-1.08s-1.27,3-.16,5.1,3.42,3.22,4.19,2.37S213.11,254.42,212,252.36Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "210.238px 254.71px"
    },
    id: "el42z3nzdwoa9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.19,274.83c-2.16.89-3.26.75-3.38-1.4s.92-3.16,3.07-4.05,4.67-.3,4.73.84S210.34,273.94,208.19,274.83Z",
    style: {
      fill: "current",
      transformOrigin: "208.706px 272.147px"
    },
    id: "elq36aw64q8g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el0st28frhj0kc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.19,274.83c-2.16.89-3.26.75-3.38-1.4s.92-3.16,3.07-4.05,4.67-.3,4.73.84S210.34,273.94,208.19,274.83Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "208.706px 272.147px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M211.28,277.44c-1.25,2.7-2.24,3.82-3.6,3s-1.12-2.39.13-5.09,3.66-5.13,4.38-4.69S212.52,274.74,211.28,277.44Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "209.656px 275.656px"
    },
    id: "el430hf3x9a8u",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--cucumber--inject-3",
    className: "animable",
    style: {
      transformOrigin: "140.559px 261.6px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.4,220.94c-6.88-1.85-14.52.2-21.28,6.57-13.54,12.76-18.46,38-11,56.42,3.73,9.2,9.85,14.94,16.73,16.79l5.85,1.58c6.89,1.85,14.53-.2,21.29-6.57,13.54-12.76,18.45-38,11-56.42-3.73-9.2-9.86-14.94-16.74-16.79Zm3.47,6.75c4,2.1,7.37,6.27,9.72,12.05,3.21,7.93,3.95,17.62,2.07,27.29s-6.13,18-12,23.5c-4.25,4-8.84,6-13.21,5.89-4-2.1-7.37-6.27-9.71-12.05-3.22-7.94-4-17.63-2.08-27.29s6.13-18,12-23.51C139.91,229.57,144.5,227.54,148.87,227.69Z",
    style: {
      fill: "current",
      transformOrigin: "140.553px 261.62px"
    },
    id: "eld0eg4mz5oib",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elq8lh515u26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168,239.31c3.85,9.5,4.4,20.83,2.17,31.32L160.43,268c.07-.33.16-.65.23-1,1.88-9.67,1.14-19.36-2.07-27.29-2.35-5.78-5.74-10-9.72-12.05-4.37-.15-9,1.88-13.21,5.88-5.84,5.5-10.09,13.85-12,23.51-.06.34-.1.67-.16,1l-13-3.49c1.87-10.58,6.56-20.5,13.55-27.09,6.76-6.37,14.4-8.42,21.28-6.57l5.85,1.58C158.13,224.37,164.26,230.11,168,239.31Z",
    style: {
      opacity: 0.1,
      transformOrigin: "140.99px 245.439px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M164.28,241.28c3.22,7.93,3.95,17.62,2.07,27.27s-6.13,18-12,23.52c-5.21,4.91-10.94,6.84-16.12,5.45-.31-.09-.63-.18-.94-.3,0,0-.05,0-.07,0q-.31-.1-.63-.24l-.47-.2-.68-.33c-4-2.1-7.37-6.28-9.71-12.05-3.22-7.93-4-17.63-2.08-27.29s6.14-18,12-23.5c4.25-4,8.84-6,13.2-5.89.3,0,.6,0,.91.07l.19,0a7.22,7.22,0,0,1,.79.13.11.11,0,0,1,.08,0,7.66,7.66,0,0,1,.95.21C157,229.52,161.41,234.19,164.28,241.28Z",
    style: {
      fill: "current",
      transformOrigin: "144.993px 262.838px"
    },
    id: "elyjdpp7ud2nk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elsufy0tyqdk"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.28,241.28c3.22,7.93,3.95,17.62,2.07,27.27s-6.13,18-12,23.52c-5.21,4.91-10.94,6.84-16.12,5.45-.31-.09-.63-.18-.94-.3,0,0-.05,0-.07,0q-.31-.1-.63-.24l-.47-.2-.68-.33c-4-2.1-7.37-6.28-9.71-12.05-3.22-7.93-4-17.63-2.08-27.29s6.14-18,12-23.5c4.25-4,8.84-6,13.2-5.89.3,0,.6,0,.91.07l.19,0a7.22,7.22,0,0,1,.79.13.11.11,0,0,1,.08,0,7.66,7.66,0,0,1,.95.21C157,229.52,161.41,234.19,164.28,241.28Z",
    style: {
      opacity: 0.1,
      transformOrigin: "144.993px 262.838px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M151.18,222.89c-6.82-1.84-14.38.19-21.09,6.51-13.41,12.63-18.28,37.65-10.88,55.88,3.69,9.12,9.76,14.81,16.58,16.64s14.38-.19,21.09-6.5c13.4-12.64,18.28-37.66,10.88-55.89C164.06,230.41,158,224.72,151.18,222.89Z",
    style: {
      fill: "current",
      transformOrigin: "143.484px 262.403px"
    },
    id: "elaie0e3c8kcw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el7fuy2t7e52w"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.18,222.89c-6.82-1.84-14.38.19-21.09,6.51-13.41,12.63-18.28,37.65-10.88,55.88,3.69,9.12,9.76,14.81,16.58,16.64s14.38-.19,21.09-6.5c13.4-12.64,18.28-37.66,10.88-55.89C164.06,230.41,158,224.72,151.18,222.89Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "143.484px 262.403px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M169.43,269.39c-2,10.51-6.72,19.65-13.16,25.72s-13.57,8.22-20.4,6.38-12.52-7.58-16-16.17c-3.56-8.76-4.39-19.38-2.34-29.89s6.73-19.65,13.17-25.72,13.56-8.23,20.4-6.39,12.51,7.58,16,16.18c3.55,8.75,4.38,19.37,2.33,29.89m.94.25c2-10.21,1.35-21.13-2.38-30.33s-9.86-14.94-16.74-16.79-14.52.19-21.28,6.57S118.59,245,116.6,255.17,115.25,276.3,119,285.5s9.85,14.95,16.73,16.8,14.53-.2,21.29-6.57,11.38-15.88,13.37-26.09Z",
    style: {
      fill: "current",
      transformOrigin: "143.488px 262.409px"
    },
    id: "elb5fkf8wwaza",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elluq8rcka1nr"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.64,296.47l14.26-5.83c1.25-.51,1.85-2.67,1.13-4.07L146.51,268c-.84-1.62-2.71-.91-3.12,1.19l-4.74,24.36C138.29,295.44,139.36,297,140.64,296.47Zm-.91-30.25L124.3,278a3.29,3.29,0,0,0-.5,4.25l10.69,12.54c1,1.12,2.5.27,2.86-1.58l4.75-24.36C142.51,266.78,141.08,265.18,139.73,266.22Zm6.64-33.59c.15-1.84-1.05-3.09-2.26-2.36l-13.83,8.31a3.27,3.27,0,0,0-.73,4.26l11.84,16c1,1.38,2.83.25,3-1.89Zm-6,27.7-11.84-16c-.9-1.21-2.47-.5-2.91,1.33L120.78,266c-.43,1.79.52,3.43,1.78,3.1l16.74-4.39C140.77,264.37,141.44,261.71,140.42,260.33Zm6.8,6.31,13.44,12.51c1,.94,2.48,0,2.76-1.88l3.14-20.86c.28-1.86-.87-3.31-2.13-2.68l-16.59,8.36A3.15,3.15,0,0,0,147.22,266.64ZM165,247.69l-9.37-14.56c-.82-1.27-2.37-.76-2.91,1L145.52,257c-.63,2,.57,4,2,3.23l16.59-8.35C165.37,251.26,165.86,249,165,247.69Z",
    style: {
      fill: "current",
      opacity: 0.4,
      transformOrigin: "143.614px 263.317px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M146.06,286c.78-2.85.77-4.45-.7-5.1s-2.26.58-3.05,3.43-.57,6.55.21,6.9S145.28,288.89,146.06,286Z",
    style: {
      fill: "current",
      transformOrigin: "144.195px 285.995px"
    },
    id: "el4lhyazl8ygy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el7gr3yebn11k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.06,286c.78-2.85.77-4.45-.7-5.1s-2.26.58-3.05,3.43-.57,6.55.21,6.9S145.28,288.89,146.06,286Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "144.195px 285.995px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M147.63,291c2-1.15,2.81-2.31,2.34-4.43s-1.57-2.13-3.53-1-3.83,4-3.58,5.16S145.66,292.18,147.63,291Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "146.469px 288.288px"
    },
    id: "elg5yf54pe07i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.47,282.65c.35-3,.95-4.39,2.52-4.23s1.82,1.68,1.47,4.65-1.91,6.19-2.74,6.1S133.12,285.62,133.47,282.65Z",
    style: {
      fill: "current",
      transformOrigin: "135.491px 283.79px"
    },
    id: "eld1ueltxln5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el234kn2smilt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.47,282.65c.35-3,.95-4.39,2.52-4.23s1.82,1.68,1.47,4.65-1.91,6.19-2.74,6.1S133.12,285.62,133.47,282.65Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "135.491px 283.79px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M130.21,286.34c-1.34-2-1.68-3.52-.47-5.19s2.2-1.12,3.54.93,2,5.58,1.32,6.48S131.55,288.39,130.21,286.34Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "131.933px 284.523px"
    },
    id: "elg8fbap9w5pu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.75,256.78c1.26,2.16,2.22,2.8,3.48,1.22s1-3.09-.27-5.25-3.6-3.42-4.27-2.58S127.5,254.62,128.75,256.78Z",
    style: {
      fill: "current",
      transformOrigin: "130.221px 254.393px"
    },
    id: "eldkwdnsnelbt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elypypabmk4qd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.75,256.78c1.26,2.16,2.22,2.8,3.48,1.22s1-3.09-.27-5.25-3.6-3.42-4.27-2.58S127.5,254.62,128.75,256.78Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "130.221px 254.393px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M124.83,256.71c-.46,3-.26,4.49,1.29,4.78s2.2-1.1,2.66-4.05-.17-6.49-1-6.64S125.3,253.75,124.83,256.71Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "126.774px 256.161px"
    },
    id: "elfyl3gw1nkmi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.2,242.3c1.57,1.67,2.08,3,1.06,4.92s-2.08,1.61-3.66-.06-2.6-4.95-2-6S136.62,240.63,138.2,242.3Z",
    style: {
      fill: "current",
      transformOrigin: "136.607px 244.578px"
    },
    id: "el2znxhoq8abx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elj7vfbceefl"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.2,242.3c1.57,1.67,2.08,3,1.06,4.92s-2.08,1.61-3.66-.06-2.6-4.95-2-6S136.62,240.63,138.2,242.3Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "136.607px 244.578px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M137.9,236.68c2-.85,3.1-.67,3.4,1.54s-.63,3.23-2.65,4.08-4.51.17-4.67-1S135.88,237.53,137.9,236.68Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "137.663px 239.445px"
    },
    id: "eln9loe2ubpb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.52,247c-2,.7-3,1.65-2.78,3.89s1.28,2.51,3.32,1.82,4.17-3.13,4.06-4.33S158.56,246.3,156.52,247Z",
    style: {
      fill: "current",
      transformOrigin: "157.417px 249.898px"
    },
    id: "el3hay02hh1cy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el6d5pvq4f828"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.52,247c-2,.7-3,1.65-2.78,3.89s1.28,2.51,3.32,1.82,4.17-3.13,4.06-4.33S158.56,246.3,156.52,247Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "157.417px 249.898px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M158.87,242.08c-1.5-1.79-2.54-2.18-3.63-.35s-.63,3.23.87,5,4,2.46,4.58,1.48S160.38,243.88,158.87,242.08Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "157.755px 244.595px"
    },
    id: "elifjnv7kup1c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.67,264.86c-1.93,1.31-3,1.39-3.59-.68s.26-3.29,2.19-4.59,4.51-1.24,4.8-.13S161.6,263.56,159.67,264.86Z",
    style: {
      fill: "current",
      transformOrigin: "159.498px 262.209px"
    },
    id: "elcgwpdi9mlzd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eluyb4mfqcj0e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.67,264.86c-1.93,1.31-3,1.39-3.59-.68s.26-3.29,2.19-4.59,4.51-1.24,4.8-.13S161.6,263.56,159.67,264.86Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "159.498px 262.209px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M163.22,266.8c-.68,2.89-1.42,4.18-2.92,3.65s-1.58-2.12-.9-5,2.55-5.76,3.35-5.48S163.9,263.9,163.22,266.8Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "161.286px 265.259px"
    },
    id: "elel2nairb4q",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Egg--inject-3",
    className: "animable",
    style: {
      transformOrigin: "339.324px 234.595px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.86,234.88a33.81,33.81,0,0,0,54.19,30.58c.46-.34.9-.71,1.35-1.09s.88-.76,1.29-1.16c1.51-1.35,2.92-2.76,4.28-4.21a66.91,66.91,0,0,0,14.33-23.65,67.88,67.88,0,0,0,2.9-11.1c.33-2,.58-4,.74-6a20,20,0,0,0-4.67-14.43c-.22-.25-.45-.5-.68-.74l-.33-.34a19.77,19.77,0,0,0-12.5-5.82c-1.36-.1-2.73-.15-4.09-.18A68.63,68.63,0,0,0,342.52,198a67.32,67.32,0,0,0-24,9.72,66.37,66.37,0,0,0-5.64,4.11c-.46.35-.92.71-1.36,1.09s-.87.77-1.29,1.17a29.35,29.35,0,0,0-2.66,2.82,33.38,33.38,0,0,0-2.39,3.21h0A33.7,33.7,0,0,0,299.86,234.88Z",
    style: {
      fill: "current",
      transformOrigin: "339.324px 234.593px"
    },
    id: "elale3oghrsdc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elqov38glxcf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.86,234.88a33.81,33.81,0,0,0,54.19,30.58c.46-.34.9-.71,1.35-1.09s.88-.76,1.29-1.16c1.51-1.35,2.92-2.76,4.28-4.21a66.91,66.91,0,0,0,14.33-23.65,67.88,67.88,0,0,0,2.9-11.1c.33-2,.58-4,.74-6a20,20,0,0,0-4.67-14.43c-.22-.25-.45-.5-.68-.74l-.33-.34a19.77,19.77,0,0,0-12.5-5.82c-1.36-.1-2.73-.15-4.09-.18A68.63,68.63,0,0,0,342.52,198a67.32,67.32,0,0,0-24,9.72,66.37,66.37,0,0,0-5.64,4.11c-.46.35-.92.71-1.36,1.09s-.87.77-1.29,1.17a29.35,29.35,0,0,0-2.66,2.82,33.38,33.38,0,0,0-2.39,3.21h0A33.7,33.7,0,0,0,299.86,234.88Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "339.324px 234.593px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M299.86,234.88c-.51,4.55-.26,11.26,2.76,15.55,8.06,11.43,23.32,14.26,35.88,10.32a33.44,33.44,0,0,0,10.44-5.44c.46-.34.91-.71,1.36-1.09s.87-.75,1.29-1.16c1.5-1.35,2.92-2.76,4.28-4.21a67.21,67.21,0,0,0,9.05-12.19,68.57,68.57,0,0,0,8.17-22.55,27.38,27.38,0,0,0,.3-6.39c-.65-7.61-8-10.41-12.63-10.78-1.36-.1-2.73-.15-4.09-.18A68.63,68.63,0,0,0,342.52,198a67.32,67.32,0,0,0-24,9.72,66.37,66.37,0,0,0-5.64,4.11c-.46.35-.92.71-1.36,1.09s-.87.77-1.29,1.17a29.35,29.35,0,0,0-2.66,2.82,33.38,33.38,0,0,0-2.39,3.21h0A33.7,33.7,0,0,0,299.86,234.88Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "336.554px 229.589px"
    },
    id: "elwjh6snizckg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.17,216.91a19.76,19.76,0,0,1,27.8,3h0c1.83,2.27,2,6,1.07,10.38-2.16,10.54-12.68,18.22-21.16,18.14-4.46,0-8.83-1.41-10.66-3.68h0A19.77,19.77,0,0,1,316.17,216.91Z",
    style: {
      fill: "current",
      transformOrigin: "327.201px 230.482px"
    },
    id: "el6ikiyw889kg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elyk6o3wodmm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309.32,227.93c0,8.59,8.68,14,19.37,13,9.09-.86,15.66-8.25,16.86-14.74a25.83,25.83,0,0,1-.51,4.08c-2.16,10.54-12.68,18.22-21.16,18.14-4.46,0-8.83-1.41-10.66-3.68h0A19.7,19.7,0,0,1,309.32,227.93Z",
    style: {
      opacity: 0.1,
      transformOrigin: "327.187px 237.3px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elkbcn3ggc4xa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M337.72,217.22c2,1.7,1.48,3.33.88,3.9-1.29,1.23-3,.37-6.85-1.83s-9.64-.91-9.57-2.36c0-.61.24-1,1.24-1.58a10,10,0,0,1,4.52-1C331.92,214.2,335.55,215.38,337.72,217.22Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "330.66px 218.01px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elusqyu7ec5tr"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M307.73,260.57a33.68,33.68,0,0,1-6.61-12c-.22-.7-.4-1.41-.57-2.12,1.31,4.74,6.83,16.39,24.07,20.85,19.31,5,35.06-6.92,44.52-19A66.57,66.57,0,0,1,361,259c-1.36,1.45-2.77,2.86-4.28,4.21-.41.4-.85.78-1.29,1.16s-.89.75-1.35,1.09a33.79,33.79,0,0,1-46.32-4.89Z",
    style: {
      fill: "current",
      opacity: 0.3,
      transformOrigin: "334.845px 259.454px"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--egg--inject-3",
    className: "animable",
    style: {
      transformOrigin: "351.932px 278.352px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.89,280.91a33.81,33.81,0,0,0,45.51,33.75,33.42,33.42,0,0,0,10.16-6c.44-.36.87-.75,1.3-1.16s.83-.8,1.23-1.23c1.44-1.42,2.77-2.9,4.06-4.42a67.92,67.92,0,0,0,15.44-35.57q.35-3,.44-6a19.94,19.94,0,0,0-5.39-14.17l-.72-.72-.35-.31a19.73,19.73,0,0,0-12.78-5.18c-1.37,0-2.73,0-4.1,0a67.65,67.65,0,0,0-37.54,12.85q-2.79,2-5.43,4.39c-.44.38-.87.77-1.29,1.16s-.84.82-1.23,1.24a28.82,28.82,0,0,0-2.51,2.95,34.61,34.61,0,0,0-2.24,3.33h0A33.7,33.7,0,0,0,312.89,280.91Z",
    style: {
      fill: "current",
      transformOrigin: "351.932px 278.336px"
    },
    id: "el6zsiy4n1igl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elup569amcmih"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.89,280.91a33.81,33.81,0,0,0,45.51,33.75,33.42,33.42,0,0,0,10.16-6c.44-.36.87-.75,1.3-1.16s.83-.8,1.23-1.23c1.44-1.42,2.77-2.9,4.06-4.42a67.92,67.92,0,0,0,15.44-35.57q.35-3,.44-6a19.94,19.94,0,0,0-5.39-14.17l-.72-.72-.35-.31a19.73,19.73,0,0,0-12.78-5.18c-1.37,0-2.73,0-4.1,0a67.65,67.65,0,0,0-37.54,12.85q-2.79,2-5.43,4.39c-.44.38-.87.77-1.29,1.16s-.84.82-1.23,1.24a28.82,28.82,0,0,0-2.51,2.95,34.61,34.61,0,0,0-2.24,3.33h0A33.7,33.7,0,0,0,312.89,280.91Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "351.932px 278.336px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M312.89,280.91c-.27,4.57.31,11.25,3.55,15.38,8.62,11,24,13.07,36.35,8.5a33.57,33.57,0,0,0,10.16-6c.44-.36.87-.75,1.3-1.15s.83-.8,1.23-1.23c1.43-1.43,2.78-2.91,4.06-4.42A67.49,67.49,0,0,0,378,279.38a65.72,65.72,0,0,0,4.69-11.7A68.93,68.93,0,0,0,385,256.45a27.4,27.4,0,0,0,0-6.4c-1-7.56-8.55-10-13.16-10.12-1.37,0-2.73,0-4.1,0a67.65,67.65,0,0,0-37.54,12.85q-2.79,2-5.43,4.39c-.44.38-.87.77-1.29,1.16s-.84.82-1.23,1.24a28.82,28.82,0,0,0-2.51,2.95,34.61,34.61,0,0,0-2.24,3.33h0A33.7,33.7,0,0,0,312.89,280.91Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "349.01px 273.497px"
    },
    id: "elsjie61cm39s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.27,262.13a19.76,19.76,0,0,1,27.91,1.55h0c1.95,2.17,2.27,5.9,1.6,10.31-1.62,10.64-11.74,18.84-20.21,19.2-4.46.18-8.89-1-10.84-3.15h0A19.77,19.77,0,0,1,328.27,262.13Z",
    style: {
      fill: "current",
      transformOrigin: "339.895px 275.15px"
    },
    id: "elbtw8zwxexz7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ellucqn1l9gzq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322,273.49c.41,8.58,9.38,13.52,20,12,9-1.31,15.23-9,16.09-15.56a24.8,24.8,0,0,1-.3,4.09c-1.62,10.64-11.74,18.84-20.21,19.2-4.46.18-8.89-1-10.84-3.15h0A19.69,19.69,0,0,1,322,273.49Z",
    style: {
      opacity: 0.1,
      transformOrigin: "339.896px 281.584px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eles0h6ssemnp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M349.81,261.35c2.1,1.6,1.64,3.25,1.08,3.85-1.23,1.3-2.93.51-6.94-1.48s-9.67-.42-9.68-1.87c0-.62.19-1,1.17-1.65a10.11,10.11,0,0,1,4.45-1.27C343.87,258.63,347.54,259.62,349.81,261.35Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "342.816px 262.357px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el1mpx2dm8qan"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.05,306.17a33.74,33.74,0,0,1-7.21-11.69c-.25-.69-.47-1.39-.67-2.09,1.54,4.67,7.65,16,25.1,19.59,19.53,4,34.66-8.68,43.5-21.19a66.52,66.52,0,0,1-7.62,11.1c-1.29,1.52-2.62,3-4.06,4.42-.4.43-.81.83-1.23,1.23s-.86.8-1.3,1.16a33.42,33.42,0,0,1-10.16,6A33.8,33.8,0,0,1,322.05,306.17Z",
    style: {
      fill: "current",
      opacity: 0.3,
      transformOrigin: "348.47px 303.797px"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--salmon--inject-3",
    className: "animable",
    style: {
      transformOrigin: "301.051px 259.598px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326,247.46a24.07,24.07,0,0,1,3.63,5.28c3.11,6.5-.54,14-2.07,20.41-.68,2.86-1.44,5.87-3.46,8-2.38,2.49-6,3.27-9.36,3.93l-10.11,2c-5.57,1.09-13.15,2-17.44-2.57a150.23,150.23,0,0,1-14.05-18.39c-1.34-2-2.1-3.33-1.77-5.8a98.63,98.63,0,0,1,4.2-18.16,8.88,8.88,0,0,1,7.8-7.33c7.22-1.82,15.81-4.13,23.28-3.49a10.22,10.22,0,0,1,4.18,1.1c5.38,3,9.57,8.81,13.66,13.34C325,246.32,325.46,246.89,326,247.46Z",
    style: {
      fill: "current",
      transformOrigin: "301.07px 259.598px"
    },
    id: "ele426n0yyak",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el2s245lo8m1v"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326,247.46a24.07,24.07,0,0,1,3.63,5.28c3.11,6.5-.54,14-2.07,20.41-.68,2.86-1.44,5.87-3.46,8-2.38,2.49-6,3.27-9.36,3.93l-10.11,2c-5.57,1.09-13.15,2-17.44-2.57a150.23,150.23,0,0,1-14.05-18.39c-1.34-2-2.1-3.33-1.77-5.8a98.63,98.63,0,0,1,4.2-18.16,8.88,8.88,0,0,1,7.8-7.33c7.22-1.82,15.81-4.13,23.28-3.49a10.22,10.22,0,0,1,4.18,1.1c5.38,3,9.57,8.81,13.66,13.34C325,246.32,325.46,246.89,326,247.46Z",
    style: {
      opacity: 0.15,
      transformOrigin: "301.07px 259.598px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M280,275.18a10.6,10.6,0,0,1,5.18.84,7.4,7.4,0,0,0,3.05.81,9,9,0,0,0,2.17-.45c1.28-.39,2.76-.8,3.94,0,.06,0,.06.21,0,.22a28.08,28.08,0,0,0-4.39,1.15,6.62,6.62,0,0,1-4.24.07,16.2,16.2,0,0,0-4.78-1.28h-.36c-.34-.45-.69-.9-1-1.35Z",
    style: {
      fill: "current",
      transformOrigin: "286.978px 276.636px"
    },
    id: "elajnt0chg20w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.85,241.91c.24.06.16.56-.08.56a3.38,3.38,0,0,0-2.52,1.53,15.29,15.29,0,0,1-2.15,2.78,4.15,4.15,0,0,1-2.23.89c.14-.5.27-1,.41-1.51a2.75,2.75,0,0,0,1.59-.78C277.26,244,278.49,241.32,280.85,241.91Z",
    style: {
      fill: "current",
      transformOrigin: "277.432px 244.748px"
    },
    id: "elapkuff2ecx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.76,262.29c-3.08,1.13-6.34.2-9.39-.56a22.73,22.73,0,0,0-5.3-.92,21.61,21.61,0,0,0-4.86.65,44.68,44.68,0,0,1-6.83,1.22,6.35,6.35,0,0,1-.1-1.83c2.8,0,5.51-.88,8.25-1.38a15.64,15.64,0,0,1,9,.82c3,1.19,6,2.53,9.24,1.54C297.94,261.77,297.94,262.23,297.76,262.29Z",
    style: {
      fill: "current",
      transformOrigin: "284.575px 260.984px"
    },
    id: "el3e79um3hyo4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279,266.63a14.68,14.68,0,0,1,6,1.71c2.1,1,4.68,2.43,7.12,1.82.14,0,.16.25,0,.29a9,9,0,0,1-6.61-.19c-2.43-.85-4.73-1.77-7.35-1.77a30.85,30.85,0,0,0-3.33.21L273.68,267A33,33,0,0,1,279,266.63Z",
    style: {
      fill: "current",
      transformOrigin: "282.956px 268.808px"
    },
    id: "elcfk4f3fygee",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.71,252.78a18.44,18.44,0,0,0,5.65,1.65,10.74,10.74,0,0,0,2.83-.19,20.72,20.72,0,0,1,2.77-.68c.62,0,.44.74.23,1-.87,1.24-3.15,1.51-4.53,1.62a12.64,12.64,0,0,1-5.25-.67c-1.75-.63-3.39-1.63-5.19-2.1-1.49-.39-3.68-.33-4.81.91-.21.22-.29-.22-.18-.37C278.28,251.21,281.84,251.67,284.71,252.78Z",
    style: {
      fill: "current",
      transformOrigin: "286.284px 254.067px"
    },
    id: "elzcwkzk5v0tj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.52,259.47c-3.5-1.14-6.63-4.34-9.19-6.88-2.31-2.3-4.38-4.86-6.59-7.29-1.89-2.09-5.14-5.4-2.61-8.22a8.41,8.41,0,0,1,3.5-1.86,35,35,0,0,1,6.32-1.51c2.09-.37,4.16-.92,6.28-1.19a28.86,28.86,0,0,1,13.22,1c3.21,1.11,6.18,4.78,8.5,7.17,2.83,2.92,5.47,6,8.11,9.09,1.23,1.44,2,4.14.46,5.69a5.91,5.91,0,0,1-2.94,1.29c-6.51,1.44-13.07,2.85-19.77,3.17A14.68,14.68,0,0,1,299.52,259.47Z",
    style: {
      fill: "current",
      transformOrigin: "304.29px 246.082px"
    },
    id: "els0i9n4bt6qr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eldthjnxpi52n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.64,258.28a4.56,4.56,0,0,1,.12,2.08,60.67,60.67,0,0,1-4.52,17.21,9,9,0,0,1-2,3.23,8.71,8.71,0,0,1-3.11,1.61,89.68,89.68,0,0,1-14.36,3.25,48.4,48.4,0,0,1-10.38,1,3.12,3.12,0,0,1-1.32-.27c-1.18-.63-1.16-2.3-.93-3.61a56.55,56.55,0,0,1,3.65-12.35c1.64-3.85,4-7.8,8-9.23a18.36,18.36,0,0,1,4.11-.81q5.69-.69,11.33-1.66,2.81-.48,5.58-1C327.12,257.45,328.92,256.55,329.64,258.28Z",
    style: {
      opacity: 0.15,
      transformOrigin: "311.422px 271.955px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elpk48z4il6xd"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "304.325px 245.97px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M319.13,256.34a32.66,32.66,0,0,0,3.52.82c-1.36.3-2.73.59-4.09.86-3.66-1.23-7.75-3.67-11.62-2.38-.24.08-.23-.44-.07-.53C311.06,253,315,255.14,319.13,256.34Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "314.702px 256.119px"
    },
    id: "eltpuifhpgq9a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.16,242.66a20.19,20.19,0,0,1,5.12,2.14c1.55.93,2.86,2.43,4.57,3,1.94.68,4,.12,6-.37a16.75,16.75,0,0,1,5.35-.73c3.81.24,7.2,2.42,10.9,3.19a12.55,12.55,0,0,0,6.15-.12,8.14,8.14,0,0,0,1.39-.58l.46.54a5.73,5.73,0,0,1,.74,1.14,14.16,14.16,0,0,1-4.84,1.33c-4.23.37-7.8-1.25-11.66-2.67a12,12,0,0,0-6.32-.79c-1.84.32-3.63.9-5.51,1a7.42,7.42,0,0,1-5.06-1.28,29,29,0,0,0-5-3.3,26.31,26.31,0,0,0-7-1.89l-.42-.05a10.3,10.3,0,0,1-1.22-1.84A38.42,38.42,0,0,1,287.16,242.66Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "304.325px 246.817px"
    },
    id: "elkqwbcph2pn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.88,236.47a8,8,0,0,0,3.23.07c1.2-.15,2.4-.24,3.6-.32.12,0,.13.28,0,.3-1.95.47-4.14,1.17-6.17,1s-3.92-1.31-5.83-1.86a30.22,30.22,0,0,0-5.52-1c1.12-.31,2.24-.54,3.38-.74.46.1.93.22,1.38.34C293,234.85,294.87,235.91,296.88,236.47Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "294.997px 235.733px"
    },
    id: "eljnx0xwb2g8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.43,243.32a13.82,13.82,0,0,1-5.09,0c-1.88-.36-3.62-1.19-5.5-1.54a12.83,12.83,0,0,0-6.39.45c-1.6.55-3.12,1.33-4.85,1.34a10.66,10.66,0,0,1-4.29-1c-1.5-.63-2.9-1.45-4.38-2.11a15.16,15.16,0,0,0-4.58-1.18c-.19,0-.16-.42,0-.46,2.95-.78,6,1.12,8.62,2.32a12.07,12.07,0,0,0,4.75,1.39c1.81,0,3.4-.77,5.1-1.25a13,13,0,0,1,4.56-.47,23.3,23.3,0,0,1,5.48,1.49,13.87,13.87,0,0,0,6.07.5Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "303.824px 241.104px"
    },
    id: "el6ec14lbfan4",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elvqk7rq71nd"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      transformOrigin: "311.67px 272.01px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.12,264.67c-.11.62-.24,1.24-.37,1.85-.63-.37-1.31-.65-1.91-1.06a10.6,10.6,0,0,1-3-3.87,12,12,0,0,0-1.51-2.21,4.52,4.52,0,0,0-1-.84l1.5-.27a10.81,10.81,0,0,1,1.54,1.79c1.19,1.66,2.16,3.36,4.09,4.27Z",
    style: {
      fill: "current",
      transformOrigin: "325.225px 262.395px"
    },
    id: "elxsbw6wszsip",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324,274a10.92,10.92,0,0,1-2.54-2.25,8.91,8.91,0,0,1-1.37-3.1A18.83,18.83,0,0,0,318.8,265a5.45,5.45,0,0,0-1.05-1.42c-.39-.38-.87-.6-1.14-1.08-.06-.1,0-.35.1-.38,2.11-.46,3.35,3.31,3.81,4.75a9.1,9.1,0,0,0,2,3.83,18.3,18.3,0,0,0,3.44,2.47l.78.49c-.22.63-.45,1.26-.69,1.88C325.39,275,324.69,274.51,324,274Z",
    style: {
      fill: "current",
      transformOrigin: "321.663px 268.811px"
    },
    id: "el9ktuwwn1ey6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.83,275.79a6.29,6.29,0,0,0,1,1c1.87,1.42,4.07,2.39,6,3.71a12,12,0,0,1,4.49,5l-.63.11-.79.14a10.79,10.79,0,0,0-1-1.35,19.86,19.86,0,0,0-5.29-4,24.76,24.76,0,0,1-4.39-2.74C294.45,277.07,294.63,276.43,294.83,275.79Z",
    style: {
      fill: "current",
      transformOrigin: "300.27px 280.77px"
    },
    id: "elpvkewocqv8s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.3,277.58c-2.62-3.54-7.34-2.8-10.63-5.33a9.23,9.23,0,0,1-3-3.94c-.66-1.67-.89-3.48-1.53-5.15a9.52,9.52,0,0,0-.91-1.73c.17-.07.32-.16.49-.22a10.81,10.81,0,0,1,1.48-.41c0,.08.1.16.14.24,1.78,3.42,1.4,7.46,4.81,9.95,3.13,2.28,7.4,2,9.85,5.31a15.16,15.16,0,0,1,2.12,4.56,5.23,5.23,0,0,1-.87.61A14.81,14.81,0,0,0,320.3,277.58Z",
    style: {
      fill: "current",
      transformOrigin: "313.675px 271.135px"
    },
    id: "eljmdgmbvly5c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.66,283.41c-1.05-2.15-3.4-3.33-5.37-4.46a30.1,30.1,0,0,0-3.48-1.68,6.78,6.78,0,0,1-2.36-1.46c-1.6-1.6-2.13-3.82-2.55-6,0-.07.06-.19.1-.08.78,1.92,1.84,4.1,3.61,5.29a21.58,21.58,0,0,0,3.71,1.56c1.16.49,2.27,1.08,3.38,1.68a10.46,10.46,0,0,1,4.57,4c.1.19.19.39.28.59-.62.19-1.25.37-1.88.54Z",
    style: {
      fill: "current",
      transformOrigin: "310.725px 276.548px"
    },
    id: "elkzi22gmm56o",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "el5xyrsumiim2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.35,258.4a2.84,2.84,0,0,1-1.44,1.24c-5.74,2.86-13.17,1.84-18.14,5.89a17.54,17.54,0,0,0-2.92,3.22,44.79,44.79,0,0,0-4,6.52,4.08,4.08,0,0,1-.92,1.37,1.31,1.31,0,0,1-1.54.19,1.66,1.66,0,0,1-.53-.83,7.8,7.8,0,0,1-.18-3.12c.45-4.69,2-9.39,1.12-14-.23-1.16-.5-2.64.49-3.28.81-.53,1.86-.09,2.75.28,4,1.62,8.4,1.19,12.59.81,1.92-.18,3.84-.08,5.72-.23C316.73,256.34,324,254.74,322.35,258.4Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.1,
      transformOrigin: "307.596px 266.176px"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--salmon--inject-3",
    className: "animable",
    style: {
      transformOrigin: "265.482px 277.135px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.49,260.07a29,29,0,0,0-4.91,6c-4.39,7.57-.7,17,.53,24.92.55,3.54,1.17,7.25,3.42,10,2.64,3.25,6.93,4.55,11,5.67l12.05,3.37c6.64,1.86,15.73,3.75,21.37-1.42a181.83,181.83,0,0,0,18.8-20.91c1.82-2.28,2.87-3.84,2.71-6.85a120.27,120.27,0,0,0-3.32-22.41c-.58-2.32-1.28-4.73-2.92-6.47a14,14,0,0,0-5.82-3.17c-8.57-2.9-18.75-6.53-27.87-6.48a12.4,12.4,0,0,0-5.16.92c-6.82,3.13-12.45,9.76-17.84,14.84C237.82,258.78,237.14,259.42,236.49,260.07Z",
    style: {
      fill: "current",
      transformOrigin: "265.482px 277.135px"
    },
    id: "eld0t1g23o3k7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ela0dtf7a8xwk"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.49,260.07a29,29,0,0,0-4.91,6c-4.39,7.57-.7,17,.53,24.92.55,3.54,1.17,7.25,3.42,10,2.64,3.25,6.93,4.55,11,5.67l12.05,3.37c6.64,1.86,15.73,3.75,21.37-1.42a181.83,181.83,0,0,0,18.8-20.91c1.82-2.28,2.87-3.84,2.71-6.85a120.27,120.27,0,0,0-3.32-22.41c-.58-2.32-1.28-4.73-2.92-6.47a14,14,0,0,0-5.82-3.17c-8.57-2.9-18.75-6.53-27.87-6.48a12.4,12.4,0,0,0-5.16.92c-6.82,3.13-12.45,9.76-17.84,14.84C237.82,258.78,237.14,259.42,236.49,260.07Z",
    style: {
      opacity: 0.15,
      transformOrigin: "265.482px 277.135px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M289.47,298.09a13.1,13.1,0,0,0-6.36.52,9,9,0,0,1-3.77.69,10.08,10.08,0,0,1-2.58-.76c-1.52-.6-3.28-1.23-4.78-.34-.08,0-.09.24,0,.27a32.06,32.06,0,0,1,5.2,1.82,8.16,8.16,0,0,0,5.13.49c2-.5,3.81-1.2,5.92-1.08a3,3,0,0,1,.43.05l1.38-1.55Z",
    style: {
      fill: "current",
      transformOrigin: "280.978px 299.372px"
    },
    id: "elkt09cnner9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.66,257.71c-.29.05-.25.67,0,.69a4.1,4.1,0,0,1,2.9,2.1,18.42,18.42,0,0,0,2.33,3.57,5.09,5.09,0,0,0,2.61,1.3c-.11-.63-.22-1.25-.35-1.88a3.26,3.26,0,0,1-1.84-1.09C295.81,260.61,294.58,257.23,291.66,257.71Z",
    style: {
      fill: "current",
      transformOrigin: "295.479px 261.517px"
    },
    id: "el22srwn1kvmri",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.2,280.76c3.62,1.67,7.66.86,11.43.23a28.5,28.5,0,0,1,6.51-.6,25.86,25.86,0,0,1,5.82,1.27,56.32,56.32,0,0,0,8.16,2.13,7.85,7.85,0,0,0,.3-2.2c-3.39-.3-6.59-1.61-9.87-2.48a19,19,0,0,0-10.91.13c-3.74,1.15-7.49,2.48-11.35,1C269,280.11,269,280.67,269.2,280.76Z",
    style: {
      fill: "current",
      transformOrigin: "285.24px 281.082px"
    },
    id: "eluhpztqo752p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.48,287.83a17.73,17.73,0,0,0-7.38,1.5c-2.65,1.05-5.91,2.49-8.8,1.51-.17,0-.22.29-.09.36,2.66,1.29,5.22,1.13,8,.39,3-.79,5.9-1.68,9.08-1.42a36.19,36.19,0,0,1,4,.58q.81-1,1.59-2A40,40,0,0,0,291.48,287.83Z",
    style: {
      fill: "current",
      transformOrigin: "286.508px 289.994px"
    },
    id: "elreqsd9a7dy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.93,270.51a22.47,22.47,0,0,1-7,1.45,13.23,13.23,0,0,1-3.42-.51,24.25,24.25,0,0,0-3.28-1.09c-.75-.11-.61.86-.38,1.24.94,1.59,3.67,2.13,5.33,2.4a15.34,15.34,0,0,0,6.43-.31c2.18-.59,4.25-1.64,6.48-2,1.85-.33,4.5,0,5.74,1.56.23.29.38-.23.26-.43C293.87,269.23,289.52,269.44,285.93,270.51Z",
    style: {
      fill: "current",
      transformOrigin: "283.9px 272.014px"
    },
    id: "el96llpvsv04q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.34,277.17c4.35-1,8.46-4.61,11.8-7.44,3-2.57,5.78-5.46,8.69-8.19,2.5-2.34,6.75-6,4-9.71-1-1.28-2.64-1.92-4.06-2.59a42.22,42.22,0,0,0-7.51-2.44c-2.49-.65-4.94-1.52-7.49-2.06a35.08,35.08,0,0,0-16.11-.08c-4,1-8,5.19-11,7.86-3.71,3.26-7.21,6.74-10.71,10.23-1.63,1.62-2.86,4.81-1.1,6.84a7.1,7.1,0,0,0,3.43,1.85c7.75,2.37,15.55,4.72,23.65,5.76A17.64,17.64,0,0,0,267.34,277.17Z",
    style: {
      fill: "current",
      transformOrigin: "262.856px 260.621px"
    },
    id: "el0wl6jfp19q3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eljfdz9xmswir"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231,272.82a5.33,5.33,0,0,0-.34,2.51,73.78,73.78,0,0,0,3.8,21.28,10.88,10.88,0,0,0,2.14,4.1,10.65,10.65,0,0,0,3.61,2.26,110,110,0,0,0,17.07,5.33,59.23,59.23,0,0,0,12.48,2.23,3.74,3.74,0,0,0,1.63-.2c1.49-.65,1.63-2.67,1.48-4.28a68.52,68.52,0,0,0-3.23-15.32c-1.61-4.82-4.12-9.84-8.74-12A22.38,22.38,0,0,0,256,277.4q-6.81-1.38-13.57-3.11c-2.22-.56-4.44-1.16-6.65-1.78C234.11,272.05,232,270.78,231,272.82Z",
    style: {
      opacity: 0.15,
      transformOrigin: "251.774px 291.122px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eldf8zjm0lmj8"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "262.87px 260.405px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.89,271.49a39.85,39.85,0,0,1-4.34.65c1.62.49,3.25,1,4.87,1.44,4.55-1.14,9.74-3.71,14.31-1.76.28.12.32-.52.13-.63C254,268.21,249,270.43,243.89,271.49Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "249.264px 271.638px"
    },
    id: "el80xjivh81xw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.94,258a24.56,24.56,0,0,0-6.41,2.09c-2,1-3.69,2.68-5.83,3.24-2.42.63-4.91-.25-7.18-1a20.74,20.74,0,0,0-6.41-1.4c-4.63-.07-9,2.24-13.51,2.81a15.18,15.18,0,0,1-7.44-.74,10,10,0,0,1-1.63-.83l-.61.61a6.49,6.49,0,0,0-1,1.31,17.39,17.39,0,0,0,5.75,2.08c5.08.85,9.56-.76,14.38-2.11a14.48,14.48,0,0,1,7.72-.34c2.21.56,4.32,1.44,6.58,1.79a9,9,0,0,0,6.26-1.06,35.7,35.7,0,0,1,6.42-3.51,32,32,0,0,1,8.61-1.61l.52,0a14.32,14.32,0,0,0,1.66-2.12A47.76,47.76,0,0,0,283.94,258Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "262.87px 261.808px"
    },
    id: "el8w5sghl10zr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.77,249.57a9.59,9.59,0,0,1-3.92-.23c-1.44-.3-2.88-.52-4.33-.73-.15,0-.18.32-.06.36,2.32.76,4.9,1.82,7.37,1.81s4.88-1.21,7.25-1.69a35.76,35.76,0,0,1,6.77-.63c-1.32-.49-2.65-.87-4-1.23-.58.08-1.15.18-1.71.28C277.61,248,275.26,249.09,272.77,249.57Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "275.118px 249.005px"
    },
    id: "elwvel05jf3o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.37,255.49a16.6,16.6,0,0,0,6.17.5c2.3-.24,4.5-1.09,6.8-1.32a15.54,15.54,0,0,1,7.71,1.16c1.88.81,3.64,1.91,5.74,2.09a13,13,0,0,0,5.3-.84c1.87-.63,3.65-1.48,5.51-2.14a19.07,19.07,0,0,1,5.66-1c.23,0,.23-.49,0-.56-3.49-1.22-7.43.78-10.66,2a14.63,14.63,0,0,1-5.89,1.22c-2.2-.12-4.05-1.27-6.06-2a16,16,0,0,0-5.48-1,29,29,0,0,0-6.78,1.27,16.65,16.65,0,0,1-7.4,0Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "263.901px 255.468px"
    },
    id: "el1u79jgz29s9",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elgprebpm36f8"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      transformOrigin: "251.485px 291px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231,280.61q.12,1.14.27,2.28c.8-.39,1.65-.67,2.42-1.1,1.78-1,2.9-2.75,4-4.4a14.72,14.72,0,0,1,2.05-2.54,5.94,5.94,0,0,1,1.33-.91c-.6-.15-1.19-.32-1.78-.48a13.94,13.94,0,0,0-2,2c-1.61,1.91-2.95,3.87-5.38,4.78Z",
    style: {
      fill: "current",
      transformOrigin: "236.035px 278.175px"
    },
    id: "el1ewm3kzkoso",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.28,292.44a13.06,13.06,0,0,0,3.29-2.48,11,11,0,0,0,2-3.62,23.34,23.34,0,0,1,1.91-4.38,7.07,7.07,0,0,1,1.41-1.63,6,6,0,0,0,1.5-1.19c.07-.11.08-.42-.09-.47-2.51-.76-4.38,3.69-5.08,5.39a11.08,11.08,0,0,1-2.83,4.44,21.88,21.88,0,0,1-4.41,2.65l-1,.53c.2.78.41,1.56.64,2.34C234.5,293.48,235.39,293,236.28,292.44Z",
    style: {
      fill: "current",
      transformOrigin: "239.709px 286.302px"
    },
    id: "el6dipyjoq4ig",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.45,297.4a7.49,7.49,0,0,1-1.36,1.13c-2.41,1.55-5.17,2.51-7.66,3.91a14.66,14.66,0,0,0-5.92,5.67l.74.19,1,.24a13.45,13.45,0,0,1,1.34-1.54,24.6,24.6,0,0,1,6.81-4.32,30.07,30.07,0,0,0,5.57-2.89C271.78,299,271.63,298.19,271.45,297.4Z",
    style: {
      fill: "current",
      transformOrigin: "264.24px 302.97px"
    },
    id: "elvj6vhvnnftj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.42,297.1c3.52-4,9.15-2.68,13.39-5.43a11.22,11.22,0,0,0,4-4.48c1-2,1.42-4.12,2.36-6.09a11.3,11.3,0,0,1,1.26-2c-.19-.1-.36-.22-.56-.31a13.7,13.7,0,0,0-1.76-.64c-.06.1-.13.18-.19.28-2.49,4-2.42,8.9-6.79,11.58-4,2.47-9.17,1.72-12.45,5.48a18.27,18.27,0,0,0-3,5.33,7.84,7.84,0,0,0,1,.82A18.15,18.15,0,0,1,240.42,297.1Z",
    style: {
      fill: "current",
      transformOrigin: "249.055px 289.895px"
    },
    id: "el6nvbeg0x91r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.27,304.51c1.48-2.49,4.43-3.7,6.93-4.88a34.73,34.73,0,0,1,4.38-1.69,8.34,8.34,0,0,0,3-1.55c2.09-1.78,2.94-4.42,3.66-7,0-.08-.05-.23-.11-.11-1.13,2.25-2.62,4.79-4.89,6.06a26,26,0,0,1-4.64,1.53c-1.45.48-2.86,1.09-4.25,1.71a12.69,12.69,0,0,0-5.93,4.44c-.15.22-.27.46-.4.69.74.29,1.47.57,2.22.83Z",
    style: {
      fill: "current",
      transformOrigin: "252.13px 296.888px"
    },
    id: "elqi13mg530hq",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elsdwzu2mu71"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.79,273.66a3.5,3.5,0,0,0,1.62,1.65c6.68,4,15.78,3.5,21.41,8.9a21.1,21.1,0,0,1,3.22,4.17,52.87,52.87,0,0,1,4.2,8.29,5,5,0,0,0,1,1.75,1.58,1.58,0,0,0,1.85.37,1.8,1.8,0,0,0,.71-1,9.38,9.38,0,0,0,.53-3.76c-.09-5.72-1.55-11.57,0-17.08.39-1.38.85-3.14-.28-4-.92-.71-2.24-.27-3.36.08-5,1.57-10.29.64-15.33-.24-2.3-.4-4.64-.47-6.9-.83C246.8,271.71,238.18,269.07,239.79,273.66Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.1,
      transformOrigin: "257.176px 284.96px"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--salmon--inject-3",
    className: "animable",
    style: {
      transformOrigin: "227.211px 256.535px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.5,232a24.49,24.49,0,0,0-6,2.24c-6.26,3.56-7.55,11.76-10,17.92-1.08,2.74-2.18,5.63-1.74,8.54.51,3.41,3,6.11,5.42,8.59l7.15,7.41c3.94,4.08,9.61,9.2,15.76,7.88a150.73,150.73,0,0,0,22.05-7c2.24-.87,3.63-1.53,4.77-3.74a98.77,98.77,0,0,0,7-17.29,8.87,8.87,0,0,0-2.19-10.48c-4.88-5.63-10.6-12.44-17.09-16.2a10.14,10.14,0,0,0-4.05-1.49c-6.14-.62-12.9,1.75-18.84,3.11C215,231.64,214.24,231.81,213.5,232Z",
    style: {
      fill: "current",
      transformOrigin: "227.211px 256.535px"
    },
    id: "elqbz38r8hznm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elmkf4i31yx5k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.5,232a24.49,24.49,0,0,0-6,2.24c-6.26,3.56-7.55,11.76-10,17.92-1.08,2.74-2.18,5.63-1.74,8.54.51,3.41,3,6.11,5.42,8.59l7.15,7.41c3.94,4.08,9.61,9.2,15.76,7.88a150.73,150.73,0,0,0,22.05-7c2.24-.87,3.63-1.53,4.77-3.74a98.77,98.77,0,0,0,7-17.29,8.87,8.87,0,0,0-2.19-10.48c-4.88-5.63-10.6-12.44-17.09-16.2a10.14,10.14,0,0,0-4.05-1.49c-6.14-.62-12.9,1.75-18.84,3.11C215,231.64,214.24,231.81,213.5,232Z",
    style: {
      opacity: 0.15,
      transformOrigin: "227.211px 256.535px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M235.3,281a10.81,10.81,0,0,0-4.73-2.28,7.49,7.49,0,0,1-3-1.08,8.93,8.93,0,0,1-1.52-1.61c-.83-1.06-1.81-2.24-3.25-2.23-.07,0-.16.13-.1.19a26.81,26.81,0,0,1,2.93,3.46A6.77,6.77,0,0,0,229.1,280a16,16,0,0,1,4.65,1.69c.1.06.19.14.29.21l1.62-.52Z",
    style: {
      fill: "current",
      transformOrigin: "229.17px 277.85px"
    },
    id: "el2m1926ufamx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.65,253.29c-.23-.09-.46.36-.25.5a3.38,3.38,0,0,1,1.19,2.7,15.14,15.14,0,0,0,.16,3.5,4.3,4.3,0,0,0,1.32,2c.18-.5.36-1,.53-1.48a2.64,2.64,0,0,1-.85-1.55C255.39,257.07,255.92,254.15,253.65,253.29Z",
    style: {
      fill: "current",
      transformOrigin: "254.959px 257.634px"
    },
    id: "elhxjoz3iibi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.12,260.3c1.87,2.69,5.08,3.8,8,4.92A23.43,23.43,0,0,1,241,267.5a21.47,21.47,0,0,1,3.61,3.32,44.55,44.55,0,0,0,4.9,4.91,6.23,6.23,0,0,0,1.14-1.43c-2.29-1.63-4-3.89-6-5.87a15.72,15.72,0,0,0-7.8-4.45c-3.14-.74-6.35-1.36-8.46-4C228.27,259.78,228,260.15,228.12,260.3Z",
    style: {
      fill: "current",
      transformOrigin: "239.37px 267.826px"
    },
    id: "el3ejufewty4l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241,274.59a14.55,14.55,0,0,0-5.86-2c-2.32-.36-5.24-.7-6.88-2.59-.1-.11-.28.11-.21.21a9,9,0,0,0,5.53,3.62c2.48.7,4.89,1.26,7,2.77a28.66,28.66,0,0,1,2.61,2.08l1.95-.75A34.38,34.38,0,0,0,241,274.59Z",
    style: {
      fill: "current",
      transformOrigin: "236.587px 274.325px"
    },
    id: "elcaqclb5kfmm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.26,260a18.88,18.88,0,0,1-5.58-1.89,10.79,10.79,0,0,1-2.21-1.78,20.18,20.18,0,0,0-1.87-2.14c-.49-.39-.8.35-.79.72,0,1.52,1.72,3,2.79,3.92a12.44,12.44,0,0,0,4.69,2.46c1.79.49,3.7.61,5.44,1.25,1.46.54,3.21,1.84,3.43,3.5,0,.31.37,0,.36-.2C250.43,262.38,247.25,260.72,244.26,260Z",
    style: {
      fill: "current",
      transformOrigin: "242.165px 260.125px"
    },
    id: "elz0dkvf0gtl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.29,257c3.52,1.07,7.92.24,11.47-.37,3.22-.56,6.38-1.47,9.57-2.2,2.76-.63,7.31-1.48,6.86-5.24a8.6,8.6,0,0,0-1.8-3.53,35.65,35.65,0,0,0-4.32-4.86c-1.5-1.5-2.88-3.14-4.46-4.58a28.93,28.93,0,0,0-11.4-6.76c-3.27-.93-7.81.38-11.07,1-4,.76-7.93,1.78-11.87,2.8-1.82.47-4,2.23-3.63,4.4a5.89,5.89,0,0,0,1.68,2.74c4.51,4.91,9.07,9.82,14.38,13.93A14.62,14.62,0,0,0,228.29,257Z",
    style: {
      fill: "current",
      transformOrigin: "231.91px 243.326px"
    },
    id: "elq8992ajizwi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elxd5ywxyferk"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.28,238.76A4.45,4.45,0,0,0,203,240.4a60.65,60.65,0,0,0-6.15,16.68,8.94,8.94,0,0,0-.19,3.81,8.78,8.78,0,0,0,1.62,3.1,90.35,90.35,0,0,0,9.91,10.89,49.12,49.12,0,0,0,7.92,6.78,3.08,3.08,0,0,0,1.25.53c1.32.16,2.26-1.22,2.82-2.42a56.11,56.11,0,0,0,4.09-12.22c.86-4.09,1.17-8.7-1.23-12.13a18.83,18.83,0,0,0-2.91-3q-4.27-3.82-8.35-7.85-2-2-4-4C206.83,239.52,205.86,237.74,204.28,238.76Z",
    style: {
      opacity: 0.15,
      transformOrigin: "210.72px 260.329px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elxgdt0yzudfq"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "231.9px 242.375px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214,243.19a33.3,33.3,0,0,1-3.34-1.35c.94,1,1.89,2,2.86,3,3.7,1.09,8.45,1.42,10.88,4.71.15.2.44-.24.36-.4C222.54,245.07,218.06,244.56,214,243.19Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "217.717px 245.721px"
    },
    id: "el0iy5asuuhy3w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.05,250.29a20.62,20.62,0,0,0-5.42-1.19c-1.8-.12-3.74.36-5.49-.13-2-.55-3.39-2.22-4.67-3.72a16.81,16.81,0,0,0-4-3.66c-3.26-2-7.29-2.14-10.76-3.63a12.56,12.56,0,0,1-5-3.62,8.52,8.52,0,0,1-.81-1.27l-.69.18a5.75,5.75,0,0,0-1.26.51,14.1,14.1,0,0,0,3.22,3.87c3.25,2.72,7.1,3.44,11.08,4.49a11.87,11.87,0,0,1,5.63,3c1.33,1.31,2.46,2.81,3.92,4a7.43,7.43,0,0,0,4.89,1.84,29.56,29.56,0,0,1,6,.19,25.7,25.7,0,0,1,6.78,2.44l.38.2a11.54,11.54,0,0,0,2-.82A39.84,39.84,0,0,0,248.05,250.29Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "231.9px 243.43px"
    },
    id: "elsi4tk328v38",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.63,239.64a7.88,7.88,0,0,1-2.69-1.79c-.89-.81-1.83-1.57-2.77-2.32-.09-.08-.26.15-.19.23,1.33,1.5,2.72,3.33,4.48,4.35s4,1.17,5.85,1.82a29.61,29.61,0,0,1,5.07,2.37c-.73-.9-1.53-1.72-2.34-2.54l-1.33-.51C247.72,240.53,245.6,240.34,243.63,239.64Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "245.672px 239.907px"
    },
    id: "elrf1hlg25b8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.58,231.2a13.94,13.94,0,0,0,4.17,2.92c1.74.78,3.65,1.1,5.39,1.89a12.86,12.86,0,0,1,5,4,16,16,0,0,0,3.2,3.88,10.87,10.87,0,0,0,4.12,1.6c1.59.34,3.21.47,4.8.77a15.9,15.9,0,0,1,4.43,1.66c.17.09.37-.25.26-.38-2-2.32-5.6-2.54-8.39-3a12.32,12.32,0,0,1-4.69-1.59c-1.51-1-2.35-2.58-3.47-4a13.07,13.07,0,0,0-3.47-3,23.48,23.48,0,0,0-5.34-1.92,13.82,13.82,0,0,1-5.26-3.07Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "235.281px 239.447px"
    },
    id: "elvgv943nxie7",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "el6lmfzbwi2t2"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      transformOrigin: "209.98px 259.035px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201,244.29c-.26.57-.5,1.15-.75,1.73.73,0,1.45.21,2.18.23a10.72,10.72,0,0,0,4.68-1.45,11.69,11.69,0,0,1,2.51-1,4.61,4.61,0,0,1,1.32-.1l-1.06-1.08a11.76,11.76,0,0,0-2.29.59c-1.94.68-3.7,1.52-5.8,1.15Z",
    style: {
      fill: "current",
      transformOrigin: "205.595px 244.435px"
    },
    id: "elzxzz34q09s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.88,254.89a10.91,10.91,0,0,0,3.37-.38,8.89,8.89,0,0,0,2.9-1.76,19.06,19.06,0,0,1,3.19-2.31,5.6,5.6,0,0,1,1.67-.57,5.07,5.07,0,0,0,1.56-.22c.1-.05.24-.27.14-.37-1.47-1.59-4.65.79-5.85,1.71a9.18,9.18,0,0,1-3.86,2,18.13,18.13,0,0,1-4.23,0l-.92,0c-.18.64-.36,1.29-.51,1.93Z",
    style: {
      fill: "current",
      transformOrigin: "205.042px 251.833px"
    },
    id: "elzyfqr32raji",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.79,273.05a6.19,6.19,0,0,1-1.44.23c-2.35.1-4.71-.36-7.06-.4a12.07,12.07,0,0,0-6.57,1.55l.46.45.57.57a11.1,11.1,0,0,1,1.6-.53,19.88,19.88,0,0,1,6.62-.24,25.44,25.44,0,0,0,5.17.27C222.36,274.32,222.58,273.69,222.79,273.05Z",
    style: {
      fill: "current",
      transformOrigin: "215.255px 274.157px"
    },
    id: "el5efjmwrtz99",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.88,259.92c4.18-1.39,7.62,1.91,11.77,1.72a9.2,9.2,0,0,0,4.71-1.52c1.49-1,2.72-2.33,4.2-3.33a9.52,9.52,0,0,1,1.73-.91c-.09-.15-.16-.31-.26-.46a12.37,12.37,0,0,0-1-1.18l-.25.12c-3.42,1.78-5.42,5.31-9.64,5.4-3.87.08-7.22-2.6-11.12-1.29a15.36,15.36,0,0,0-4.35,2.52,5.66,5.66,0,0,0,.36,1A15.48,15.48,0,0,1,200.88,259.92Z",
    style: {
      fill: "current",
      transformOrigin: "209.98px 258.115px"
    },
    id: "eldc5vz2jcd8n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.53,266.79c2.09-1.16,4.69-.79,7-.58a28.81,28.81,0,0,1,3.81.62,6.81,6.81,0,0,0,2.77.15c2.23-.4,3.93-1.92,5.51-3.43,0-.05.06-.19,0-.13-1.73,1.13-3.85,2.31-6,2.27a21.36,21.36,0,0,1-3.93-.85c-1.23-.26-2.49-.41-3.73-.55a10.54,10.54,0,0,0-6.06.68c-.19.1-.38.22-.57.33.4.51.81,1,1.23,1.51Z",
    style: {
      fill: "current",
      transformOrigin: "209.488px 265.231px"
    },
    id: "eleptbuvo4k44",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elt4kfprwswtg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.19,243a2.87,2.87,0,0,0,.47,1.84c3.06,5.63,9.74,9,11.49,15.22a17.38,17.38,0,0,1,.55,4.31,44.25,44.25,0,0,1-.46,7.63,3.88,3.88,0,0,0,0,1.66,1.31,1.31,0,0,0,1.16,1,1.57,1.57,0,0,0,.9-.38,7.74,7.74,0,0,0,1.94-2.45c2.31-4.1,3.71-8.86,7.11-12.12.85-.82,1.91-1.88,1.47-3-.35-.9-1.48-1.13-2.42-1.35-4.2-1-7.57-3.83-10.78-6.55-1.46-1.24-3.1-2.26-4.55-3.46C216,244.56,211,239.09,210.19,243Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.1,
      transformOrigin: "222.551px 258.133px"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--shrimp--inject-3",
    className: "animable",
    style: {
      transformOrigin: "302.727px 278.152px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.44,281.29c-6.29,1.91-16.94.09-16.09-5s6.83-4.33,12.66-1c-2.91-6.73-1.09-11.53,2.91-11.39s7.11,6.71,3,13.81Z",
    style: {
      fill: "current",
      transformOrigin: "275.58px 272.964px"
    },
    id: "elyouqa33jgnk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elw54dw0lrlm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.44,281.29c-6.29,1.91-16.94.09-16.09-5s6.83-4.33,12.66-1c-2.91-6.73-1.09-11.53,2.91-11.39s7.11,6.71,3,13.81Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "275.58px 272.964px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elaczwhpzr45l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.3,277.52c1.54,1.46,4,2.05,6.09,2.19a18.63,18.63,0,0,0,3.17,0c.54-.05,1.07-.11,1.6-.19a4.29,4.29,0,0,0,1.47-.31c.44.42.84-.58.48-.95a9.53,9.53,0,0,1-2.39-4.41,12.45,12.45,0,0,1,0-5.05c.05-.31-.3-.28-.41-.06a8.65,8.65,0,0,0-.29,5.79,10.59,10.59,0,0,0,1.87,3.79l-.7.12c-.53.07-1.07.12-1.61.17a24.58,24.58,0,0,1-3.21.07,18.18,18.18,0,0,1-2.94-.37,30.26,30.26,0,0,1-2.92-1C270.4,277.26,270.21,277.43,270.3,277.52Z",
    style: {
      fill: "current",
      opacity: 0.4,
      transformOrigin: "276.763px 274.174px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M281.27,281.52c10.11,17.32,33.13,20.64,45.57,11.76,6.18-4.41,11.61-11.74,11.51-21.53-.09-9.59-21.14-9.19-22.9-3.82-3.27,9.93-9.5,13.75-16.77,14-6.22.26-14.73-4.19-14.73-4.19S280.76,278.41,281.27,281.52Z",
    style: {
      fill: "current",
      transformOrigin: "309.783px 281.1px"
    },
    id: "el102mv1avr01",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elaunv8uvpxm6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.27,281.52c10.11,17.32,33.13,20.64,45.57,11.76,6.18-4.41,11.61-11.74,11.51-21.53-.09-9.59-21.14-9.19-22.9-3.82-3.27,9.93-9.5,13.75-16.77,14-6.22.26-14.73-4.19-14.73-4.19S280.76,278.41,281.27,281.52Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "309.783px 281.1px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elf843mg6da0d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M305.11,283.15c1.32,3.85,4.13,7.51,8,9,.08,0,.23-.07.16-.15a42,42,0,0,1-3.17-3.76,19.31,19.31,0,0,1-2.64-5.15,11.75,11.75,0,0,1-.69-3.34,16.21,16.21,0,0,1-2.23,1.06A16.37,16.37,0,0,0,305.11,283.15Z",
    style: {
      fill: "current",
      opacity: 0.4,
      transformOrigin: "308.914px 285.95px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elebkoom3rrbb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313.28,278.79c2.85,2.91,7,5,11.08,4.73.08,0,.18-.17.08-.21a43,43,0,0,1-4.48-2,19.22,19.22,0,0,1-4.6-3.51,9.76,9.76,0,0,1-2.58-4,20,20,0,0,1-1.64,2.29A14.3,14.3,0,0,0,313.28,278.79Z",
    style: {
      fill: "current",
      opacity: 0.4,
      transformOrigin: "317.811px 278.672px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elzk3oycbhi1f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297.35,282a19.07,19.07,0,0,1-2.2-.26c.33,3.87,2,7.86,5.1,10.26.06.05.24,0,.19-.11a43.86,43.86,0,0,1-2-4.49A19.2,19.2,0,0,1,297.35,282Z",
    style: {
      fill: "current",
      opacity: 0.4,
      transformOrigin: "297.799px 286.88px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M316.15,271.68a3.51,3.51,0,0,0,.27.4c.22.27.51.48.72.75a4.78,4.78,0,0,0,3.66,2c2.45.05,3.73-1.5,7.45,1.44s7.39,2.54,8.59-.48a7,7,0,0,1,.44-.75.92.92,0,0,1,.19-.28c.26-.27.58-.49.86-.74a6.63,6.63,0,0,0,1.43-1.78l0-.06a3,3,0,0,0-.37-3.48c-.64-.61-1.66-.86-2.05-1.66a4.47,4.47,0,0,1-.19-1.72,4.08,4.08,0,0,0-1.43-2.9,4.43,4.43,0,0,0-2.11-.93c-.54-.1-1.06-.29-1.6-.34-.38,0-.77,0-1.14-.08a3.88,3.88,0,0,1-1.06-.35,12.71,12.71,0,0,1-1.85-1.24,4.73,4.73,0,0,0-2.93-1.22c-1.33.07-2.36,1.12-3.55,1.71-1.8.91-4.09.83-5.62,2.14a3.93,3.93,0,0,0-1.22,3.81c.23.93.81,1.76.95,2.7.09.59,0,1.19.08,1.77A3.53,3.53,0,0,0,316.15,271.68Z",
    style: {
      fill: "current",
      transformOrigin: "327.347px 268.269px"
    },
    id: "el0tng9j9euxl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elybdxerp1esh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M316.15,271.68a3.51,3.51,0,0,0,.27.4c.22.27.51.48.72.75a4.78,4.78,0,0,0,3.66,2c2.45.05,3.73-1.5,7.45,1.44s7.39,2.54,8.59-.48a7,7,0,0,1,.44-.75.92.92,0,0,1,.19-.28c.26-.27.58-.49.86-.74a6.63,6.63,0,0,0,1.43-1.78l0-.06a3,3,0,0,0-.37-3.48c-.64-.61-1.66-.86-2.05-1.66a4.47,4.47,0,0,1-.19-1.72,4.08,4.08,0,0,0-1.43-2.9,4.43,4.43,0,0,0-2.11-.93c-.54-.1-1.06-.29-1.6-.34-.38,0-.77,0-1.14-.08a3.88,3.88,0,0,1-1.06-.35,12.71,12.71,0,0,1-1.85-1.24,4.73,4.73,0,0,0-2.93-1.22c-1.33.07-2.36,1.12-3.55,1.71-1.8.91-4.09.83-5.62,2.14a3.93,3.93,0,0,0-1.22,3.81c.23.93.81,1.76.95,2.7.09.59,0,1.19.08,1.77A3.53,3.53,0,0,0,316.15,271.68Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "327.347px 268.269px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ell4pe84gqiy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.73,266.14c0,.15.12.34.29.33.5,0,.9-.52,1.35-.7a3.94,3.94,0,0,1,1.4-.29,4.66,4.66,0,0,1,2.78.8,4.25,4.25,0,0,1,1.55,2.23,4.83,4.83,0,0,1,.28,1.56c0,.95,0,1.83.05,1.95s.15.27.26.13a19.51,19.51,0,0,1,1.51-2,4,4,0,0,1,2.16-1.09,3.54,3.54,0,0,1,4,2c.05.13.17,0,.19-.07a2.45,2.45,0,0,0-1.27-2.36,4.74,4.74,0,0,0-5.66.47,4.17,4.17,0,0,0-.36.37,5,5,0,0,0-.17-1.23,5.54,5.54,0,0,0-2.13-2.92l-.3-.2.31-.19a5.91,5.91,0,0,1,.89-.4,3.73,3.73,0,0,1,1.87-.23,3,3,0,0,1,1.49.63,2.23,2.23,0,0,1,.57.65c.05.09.1.25.22.28s.24-.08.2-.1c.16.11,0-.44,0-.54l-.09-.2a2.5,2.5,0,0,0-.23-.39,2.89,2.89,0,0,0-.77-.75,3.68,3.68,0,0,0-1.68-.61,4.62,4.62,0,0,0-1.91.27,6.63,6.63,0,0,0-.94.43,4.44,4.44,0,0,0-.94.65,5.4,5.4,0,0,0-2-.34C320.6,264.31,318.52,264.75,318.73,266.14Z",
    style: {
      fill: "current",
      opacity: 0.5,
      transformOrigin: "326.637px 267.733px"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--rice--inject-3",
    className: "animable",
    style: {
      transformOrigin: "237.935px 298.363px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350.56,320.54a120.85,120.85,0,0,0,11.38-7.43,9.78,9.78,0,0,0-.74-.85c-2.73-2.8-7.07-4.14-10.73-2.76-1.68-6.7-10.14-10.7-16.38-7.75a13.74,13.74,0,0,0-21.35-9.59A15.52,15.52,0,0,0,286,293.41a12.74,12.74,0,0,0-22.8,2.91,13,13,0,0,0-18.81,14,9.27,9.27,0,0,0-9.83,15c-4.85-.94-9.86,2.87-11,7.67a13.25,13.25,0,0,0,2.15,10.43c8,.78,16.14,1.2,24.41,1.2C288.1,344.57,323.79,336,350.56,320.54Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "292.604px 314.866px"
    },
    id: "el2h8exc53vg7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.93,285.78c6.26,13,18.38,25,35.61,34.93,26.79,15.44,62.49,23.93,100.53,23.9a228.63,228.63,0,0,0,67.57-9.86,8.6,8.6,0,0,0-5-3.37c-3.7-1-8.44.48-9.85,4.31a11.26,11.26,0,0,0-20.09-3.3c-1.56-6.5-10.15-10.11-15.89-6.68a11.46,11.46,0,0,0-15.52-16.12,10,10,0,0,0-12.62-12.86,13.63,13.63,0,0,0-15.91-17.26,15.22,15.22,0,0,0-22.26-12.94c-2.61-8.28-13.67-12.55-21.16-8.18A10.66,10.66,0,0,0,159,262.07a11.72,11.72,0,0,0-19.39,8.47,10.33,10.33,0,0,0-12-.72c-3.59,2.38-6.3,7.72-5,11.83A10.7,10.7,0,0,0,113.93,285.78Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "215.785px 298.359px"
    },
    id: "el0kxmpb4f5ft",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.48,313.89a7.24,7.24,0,0,1,4.68-1.82,8.25,8.25,0,0,1,5,1.5,8.92,8.92,0,0,1,3.16,4.32,9.63,9.63,0,0,1,.31,5.4L200,322.4a6.7,6.7,0,0,1,5.88-2.13,6.63,6.63,0,0,1,5,3.68l-1.7.64a7.47,7.47,0,0,1,.46-4.55,6.9,6.9,0,0,1,1.23-2,8.51,8.51,0,0,1,.83-.77,8,8,0,0,1,.94-.62,7.5,7.5,0,0,1,2.08-.79,7.93,7.93,0,0,1,2.17-.1,7,7,0,0,1,3.86,1.58,7.49,7.49,0,0,0-3.88-.85,6.61,6.61,0,0,0-3.57,1.2A7.4,7.4,0,0,0,212,319a5.21,5.21,0,0,0-.82,1.59,6.26,6.26,0,0,0-.19,3.52.91.91,0,0,1-1.68.68l0,0a4.83,4.83,0,0,0-7.81-1.06,1,1,0,0,1-1.66-.88,8.53,8.53,0,0,0-.09-4.4,7.89,7.89,0,0,0-2.36-3.75,7.82,7.82,0,0,0-8.84-.79Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "204.615px 318.675px"
    },
    id: "elweygkbenkq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.88,277.14A7.18,7.18,0,0,1,154,276a7,7,0,0,1,4.2,1.41,6.15,6.15,0,0,1,1.57,1.75,5.49,5.49,0,0,1,.75,2.28,9.87,9.87,0,0,1-.65,4.46l-1.64-1a4.87,4.87,0,0,1,2.57-1.5,5.54,5.54,0,0,1,2.87.23,6.62,6.62,0,0,1,4,3.66H166a6.67,6.67,0,0,1,5.48-3.85,6.07,6.07,0,0,1,5.59,2.83,6.16,6.16,0,0,0-5.43-1.65,5.59,5.59,0,0,0-4,3.36.89.89,0,0,1-1.14.51.9.9,0,0,1-.47-.43l0-.07a5.25,5.25,0,0,0-3-2.51,3.13,3.13,0,0,0-3.38.72,1,1,0,0,1-1.64-1,9.81,9.81,0,0,0,.71-3.64,4.44,4.44,0,0,0-1.47-3.09,6.46,6.46,0,0,0-3.36-1.64A8.15,8.15,0,0,0,149.88,277.14Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "163.475px 282.271px"
    },
    id: "el2zvqhjftjk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eldv0p57597fl"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1,
      transformOrigin: "315.29px 312.659px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M301,310.38a7.18,7.18,0,0,1,3.66-2.13,7,7,0,0,1,4.42.34,6.22,6.22,0,0,1,1.95,1.3,5.8,5.8,0,0,1,1.29,2,10.24,10.24,0,0,1,.46,4.49l-1.83-.56a4.79,4.79,0,0,1,2.12-2.08,5.57,5.57,0,0,1,2.84-.49,6.71,6.71,0,0,1,4.79,2.57l-1.59.41a6.62,6.62,0,0,1,4.36-5.07,6.06,6.06,0,0,1,6.11,1.37,6.17,6.17,0,0,0-5.67-.27,5.61,5.61,0,0,0-3,4.24.89.89,0,0,1-1,.77.85.85,0,0,1-.56-.31l-.05-.05a5.21,5.21,0,0,0-3.51-1.7,3.13,3.13,0,0,0-3.1,1.53,1,1,0,0,1-1.32.4,1,1,0,0,1-.51-.95,9.9,9.9,0,0,0-.2-3.71,4.49,4.49,0,0,0-2.19-2.63,6.55,6.55,0,0,0-3.66-.77A8.22,8.22,0,0,0,301,310.38Z",
    id: "el0mpm36iniusf",
    className: "animable",
    style: {
      transformOrigin: "315.29px 312.659px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M233.4,333.3a6,6,0,0,1,5.21-3.53,6.83,6.83,0,0,1,6,3.08l-1.78.76a5.76,5.76,0,0,1,1.38-5,5,5,0,0,1,4.57-1.54,5.61,5.61,0,0,0-3.44,2.43,4.83,4.83,0,0,0-.59,3.7A1,1,0,0,1,243,334l0-.05a6.08,6.08,0,0,0-4.34-2.49,6.19,6.19,0,0,0-2.67.35A7.56,7.56,0,0,0,233.4,333.3Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "241.09px 330.671px"
    },
    id: "el9vfnz41p0rv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.32,309.32a6,6,0,0,1,5.76-2.53,6.85,6.85,0,0,1,5.31,4.11l-1.89.43a5.74,5.74,0,0,1,2.27-4.69,4.94,4.94,0,0,1,4.77-.68,5.59,5.59,0,0,0-3.82,1.76,4.83,4.83,0,0,0-1.25,3.53,1,1,0,0,1-1.87.48l0-.05a6,6,0,0,0-3.82-3.24,6.2,6.2,0,0,0-2.69-.14A7.62,7.62,0,0,0,154.32,309.32Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "162.43px 308.933px"
    },
    id: "elo6ms0eggp3q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.34,292.41a7.59,7.59,0,0,0-2.52-1.51,6.18,6.18,0,0,0-2.67-.34,5.78,5.78,0,0,0-2.46.78,5.93,5.93,0,0,0-1.88,1.71l0,0a1,1,0,0,1-1.75-.81,4.83,4.83,0,0,0-.59-3.7,5.69,5.69,0,0,0-3.44-2.43,5,5,0,0,1,4.57,1.55,5.76,5.76,0,0,1,1.38,5l-1.78-.77a6.75,6.75,0,0,1,2.59-2.33,6.93,6.93,0,0,1,3.37-.75A6,6,0,0,1,213.34,292.41Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "205.685px 289.718px"
    },
    id: "elzgrmau0bz69",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elq03awcptxle"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1,
      transformOrigin: "280.22px 303.218px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.53,305.84a6,6,0,0,1,5.21-3.53,6.77,6.77,0,0,1,6,3.08l-1.78.76a5.76,5.76,0,0,1,1.38-5,5,5,0,0,1,4.57-1.54,5.64,5.64,0,0,0-3.44,2.43,4.82,4.82,0,0,0-.59,3.7,1,1,0,0,1-1.75.81l0,0a5.8,5.8,0,0,0-1.88-1.7,5.89,5.89,0,0,0-2.46-.79,6.21,6.21,0,0,0-2.67.35A7.56,7.56,0,0,0,272.53,305.84Z",
    id: "el0n2lz4wne2u",
    className: "animable",
    style: {
      transformOrigin: "280.22px 303.218px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M229.92,309.56c1.14,1.7,1.5,2.68.77,3.17s-1.49-.22-2.63-1.93-1.87-4-1.48-4.24S228.79,307.86,229.92,309.56Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "228.772px 309.709px"
    },
    id: "elbs04yri467a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.07,290.8c.4-2,.83-3,1.69-2.79s.9,1.22.5,3.23-1.49,4.14-1.95,4.05S225.66,292.81,226.07,290.8Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "227.175px 291.638px"
    },
    id: "elv98lp893n1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.71,330c1.78-1,2.78-1.31,3.22-.55s-.33,1.48-2.11,2.49-4.11,1.59-4.34,1.19S223.93,331,225.71,330Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "225.755px 331.142px"
    },
    id: "elqd1eha810d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.05,299.4c-2,.48-3,.49-3.24-.36s.72-1.33,2.71-1.81,4.39-.4,4.5,0S150,298.92,148.05,299.4Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "148.399px 298.313px"
    },
    id: "elu2xzb375f7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.54,266.9c1.75,1.07,2.49,1.8,2,2.55s-1.45.43-3.2-.64-3.38-2.81-3.14-3.22S167.79,265.84,169.54,266.9Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "168.432px 267.663px"
    },
    id: "elyn0sq6b8znl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.69,282.34c1.22-1.65,2-2.32,2.73-1.79s.29,1.48-.93,3.12-3.12,3.11-3.5,2.83S134.47,284,135.69,282.34Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "136.337px 283.453px"
    },
    id: "elma2f5i0c23o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.64,296.79c-1.11,1.73-1.86,2.45-2.6,2s-.39-1.46.72-3.18,2.9-3.31,3.3-3.05S187.75,295.07,186.64,296.79Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "185.911px 295.726px"
    },
    id: "elb54sktcuw3k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.08,269.56c1.53,1.36,2.13,2.22,1.54,2.87s-1.5.16-3-1.2-2.82-3.38-2.51-3.73S184.55,268.2,186.08,269.56Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "184.954px 270.073px"
    },
    id: "elwwjobv6d85o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.92,322.51c-1.75,1.08-2.74,1.41-3.2.66s.28-1.48,2-2.56,4-1.74,4.29-1.34S181.66,321.43,179.92,322.51Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "179.815px 321.364px"
    },
    id: "eltu4ss44an2q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.94,335c1.47,1.43,2,2.31,1.42,2.94s-1.51.09-3-1.34-2.66-3.5-2.34-3.84S267.48,333.59,268.94,335Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "267.779px 335.45px"
    },
    id: "elp1fo5z4kru",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elkf2ua197ey"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.47,319.34c-.91,1.84-1.57,2.64-2.36,2.26s-.56-1.41.35-3.25,2.5-3.62,2.92-3.41S290.37,317.5,289.47,319.34Z",
    style: {
      opacity: 0.1,
      transformOrigin: "288.586px 318.308px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elkgqcfw4ij5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.33,298.68c1.86.86,2.68,1.5,2.31,2.3s-1.39.59-3.25-.27-3.68-2.41-3.49-2.84S321.47,297.82,323.33,298.68Z",
    style: {
      opacity: 0.1,
      transformOrigin: "322.307px 299.586px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M328.84,324.07c-1.25,1.61-2.07,2.27-2.76,1.73s-.26-1.49,1-3.11,3.18-3,3.55-2.75S330.1,322.45,328.84,324.07Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "328.233px 322.948px"
    },
    id: "elxtvt03859m",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--shrimp--inject-3",
    className: "animable",
    style: {
      transformOrigin: "236.596px 305.496px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263,324.65c-5.32-.31-13.36,3.14-11.73,7s6.2,2.11,10.15-1.65c-1,5.86,1.33,9.29,4.45,8.42s4.33-6.63-.23-11.45Z",
    style: {
      fill: "current",
      transformOrigin: "259.851px 331.592px"
    },
    id: "ela81p0mjx7d6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el7mn2d0btskb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263,324.65c-5.32-.31-13.36,3.14-11.73,7s6.2,2.11,10.15-1.65c-1,5.86,1.33,9.29,4.45,8.42s4.33-6.63-.23-11.45Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "259.851px 331.592px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eldrirji48g7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255,329.73a8.19,8.19,0,0,1,4.38-2.88,16.73,16.73,0,0,1,2.5-.57c.43-.06.87-.11,1.3-.15a3.34,3.34,0,0,1,1.22,0c.26-.42.77.3.56.65a7.85,7.85,0,0,0-1.06,3.93,10.42,10.42,0,0,0,.95,4c.1.23-.18.27-.31.12a6.94,6.94,0,0,1-1.32-4.51,8.55,8.55,0,0,1,.74-3.34l-.57,0-1.3.17a22.1,22.1,0,0,0-2.54.55,14.75,14.75,0,0,0-2.24.85,20.89,20.89,0,0,0-2.12,1.32C255.07,329.92,254.89,329.82,255,329.73Z",
    style: {
      fill: "current",
      opacity: 0.4,
      transformOrigin: "259.988px 330.46px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M262.83,324.5c4.68-15.56,22.19-22.54,33.68-17.9,5.7,2.3,11.36,7,13.15,14.78,1.74,7.58-14.92,11.25-17.33,7.36-4.46-7.21-10.08-9-15.87-7.89-4.95,1-10.81,6.09-10.81,6.09A2.65,2.65,0,0,1,262.83,324.5Z",
    style: {
      fill: "current",
      transformOrigin: "286.309px 317.748px"
    },
    id: "elpa5d63852u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elt3iw7w7q6qp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.83,324.5c4.68-15.56,22.19-22.54,33.68-17.9,5.7,2.3,11.36,7,13.15,14.78,1.74,7.58-14.92,11.25-17.33,7.36-4.46-7.21-10.08-9-15.87-7.89-4.95,1-10.81,6.09-10.81,6.09A2.65,2.65,0,0,1,262.83,324.5Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "286.309px 317.748px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elge01ffv7hg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.31,318.7a12,12,0,0,1,4.56-8.63c.06,0,.2,0,.16.09a35,35,0,0,0-1.79,3.57,15.21,15.21,0,0,0-1.1,4.56,9.08,9.08,0,0,0,.09,2.75,13.36,13.36,0,0,0-2-.4A12.6,12.6,0,0,1,281.31,318.7Z",
    style: {
      fill: "current",
      opacity: 0.4,
      transformOrigin: "283.629px 315.555px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elzffkl508iwd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288.57,320.59a12,12,0,0,1,7.83-5.83c.07,0,.17.1.1.15a37.24,37.24,0,0,0-3.14,2.45,15.49,15.49,0,0,0-3,3.64,7.84,7.84,0,0,0-1.27,3.63,16.6,16.6,0,0,0-1.73-1.48A11.36,11.36,0,0,1,288.57,320.59Z",
    style: {
      fill: "current",
      opacity: 0.4,
      transformOrigin: "291.942px 319.695px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eluautsynlah8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275.42,321.11a16.45,16.45,0,0,0-1.69.62,11.83,11.83,0,0,1,2.07-9.05c0-.05.2,0,.18.05a34.68,34.68,0,0,0-.73,3.92A15.51,15.51,0,0,0,275.42,321.11Z",
    style: {
      fill: "current",
      opacity: 0.4,
      transformOrigin: "274.762px 317.195px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M292.18,325.64a1.78,1.78,0,0,1,.14-.36c.12-.26.3-.47.42-.73a3.85,3.85,0,0,1,2.51-2.26c1.92-.51,3.22.48,5.59-2.55s5.34-3.39,6.86-1.25a4.74,4.74,0,0,0,.49.51.9.9,0,0,0,.2.19c.26.16.55.27.82.42a5,5,0,0,1,1.46,1.13l0,0a2.46,2.46,0,0,1,.37,2.81c-.39.6-1.15,1-1.3,1.7a3.28,3.28,0,0,0,.17,1.38,3.32,3.32,0,0,1-.57,2.56,3.53,3.53,0,0,1-1.49,1.13,13.25,13.25,0,0,1-1.2.58c-.29.1-.59.16-.88.28a3.18,3.18,0,0,0-.77.47,11,11,0,0,0-1.22,1.33,3.8,3.8,0,0,1-2.08,1.51c-1.06.2-2.07-.43-3.12-.67-1.59-.38-3.37.13-4.83-.62a3.15,3.15,0,0,1-1.68-2.77c0-.78.3-1.54.23-2.31,0-.48-.22-.93-.27-1.41A2.79,2.79,0,0,1,292.18,325.64Z",
    style: {
      fill: "current",
      transformOrigin: "301.674px 325.829px"
    },
    id: "elkfk0j4nujni",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elrdv0d58amnd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.18,325.64a1.78,1.78,0,0,1,.14-.36c.12-.26.3-.47.42-.73a3.85,3.85,0,0,1,2.51-2.26c1.92-.51,3.22.48,5.59-2.55s5.34-3.39,6.86-1.25a4.74,4.74,0,0,0,.49.51.9.9,0,0,0,.2.19c.26.16.55.27.82.42a5,5,0,0,1,1.46,1.13l0,0a2.46,2.46,0,0,1,.37,2.81c-.39.6-1.15,1-1.3,1.7a3.28,3.28,0,0,0,.17,1.38,3.32,3.32,0,0,1-.57,2.56,3.53,3.53,0,0,1-1.49,1.13,13.25,13.25,0,0,1-1.2.58c-.29.1-.59.16-.88.28a3.18,3.18,0,0,0-.77.47,11,11,0,0,0-1.22,1.33,3.8,3.8,0,0,1-2.08,1.51c-1.06.2-2.07-.43-3.12-.67-1.59-.38-3.37.13-4.83-.62a3.15,3.15,0,0,1-1.68-2.77c0-.78.3-1.54.23-2.31,0-.48-.22-.93-.27-1.41A2.79,2.79,0,0,1,292.18,325.64Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "301.674px 325.829px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elt6sp3oh3z1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.26,329.52c0-.12,0-.29.17-.31.39-.07.8.23,1.19.3a3.48,3.48,0,0,0,1.16-.05,3.74,3.74,0,0,0,2-1.15,3.51,3.51,0,0,0,.8-2.05,3.92,3.92,0,0,0-.08-1.28c-.16-.76-.32-1.46-.33-1.55s.07-.25.19-.15a14.65,14.65,0,0,0,1.56,1.27,3.18,3.18,0,0,0,1.9.45,2.88,2.88,0,0,0,2.77-2.31c0-.11.13-.05.16,0a2,2,0,0,1-.56,2.1,3.84,3.84,0,0,1-4.54.71c-.13-.07-.24-.15-.36-.23a3.44,3.44,0,0,1,.1,1,4.53,4.53,0,0,1-1.12,2.71l-.2.21.28.09a5.36,5.36,0,0,0,.78.15,3.1,3.1,0,0,0,1.51-.17,2.58,2.58,0,0,0,1.06-.78,2.06,2.06,0,0,0,.33-.62c0-.09,0-.22.12-.27s.2,0,.17.05c.11-.12.09.34.08.42l0,.18a2.47,2.47,0,0,1-.11.36,2.51,2.51,0,0,1-.46.73,3.05,3.05,0,0,1-1.21.8,3.59,3.59,0,0,1-1.56.14,4.72,4.72,0,0,1-.82-.15,3.26,3.26,0,0,1-.86-.34,4.23,4.23,0,0,1-1.5.64C297.08,330.61,295.36,330.66,295.26,329.52Z",
    style: {
      fill: "current",
      opacity: 0.5,
      transformOrigin: "301.054px 326.577px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--shrimp--inject-3",
    className: "animable",
    style: {
      transformOrigin: "194.144px 297.106px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.52,306.94c6,1.94,13.51,9.24,10,12.79s-7.81-.32-10.59-6.2c-1.39,7-5.47,9.76-8.57,7.44s-2-9.23,5.19-12.63Z",
    style: {
      fill: "current",
      transformOrigin: "215.573px 314.357px"
    },
    id: "elsoi6eapmd5n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elwysrd395str"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.52,306.94c6,1.94,13.51,9.24,10,12.79s-7.81-.32-10.59-6.2c-1.39,7-5.47,9.76-8.57,7.44s-2-9.23,5.19-12.63Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "215.573px 314.357px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el37fwzkrsoip"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.3,316.05a9.87,9.87,0,0,0-3.63-5.09,19.8,19.8,0,0,0-2.54-1.71l-1.38-.73a4.22,4.22,0,0,0-1.34-.55c-.11-.58-1,0-.9.48a9.31,9.31,0,0,1-.52,4.82,12.41,12.41,0,0,1-2.77,4c-.21.21.08.38.29.27a8.31,8.31,0,0,0,3.41-4.44,10.12,10.12,0,0,0,.61-4l.62.29c.46.24.92.49,1.37.75a23.17,23.17,0,0,1,2.59,1.71,17.51,17.51,0,0,1,2.13,1.91,23,23,0,0,1,1.78,2.38C222.08,316.2,222.33,316.18,222.3,316.05Z",
    style: {
      fill: "current",
      opacity: 0.4,
      transformOrigin: "215.725px 312.651px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M215.78,306.84c1.5-19.31-15-34.61-29.73-34.4-7.33.11-15.67,2.94-21,10.78-5.2,7.67,11.74,18.92,16.09,15.63,8.06-6.09,15.11-5.7,21.05-1.94,5.07,3.22,9.39,11.43,9.39,11.43S214.48,309.59,215.78,306.84Z",
    style: {
      fill: "current",
      transformOrigin: "189.972px 290.531px"
    },
    id: "elltfid874b3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el9f5nptur8n5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.78,306.84c1.5-19.31-15-34.61-29.73-34.4-7.33.11-15.67,2.94-21,10.78-5.2,7.67,11.74,18.92,16.09,15.63,8.06-6.09,15.11-5.7,21.05-1.94,5.07,3.22,9.39,11.43,9.39,11.43S214.48,309.59,215.78,306.84Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "189.972px 290.531px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elmevwi4t28m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.74,292.44c1.07-3.78.85-8.24-1.36-11.56,0-.06-.22-.06-.21,0a44,44,0,0,1,.45,4.73,18.55,18.55,0,0,1-.73,5.54,11.87,11.87,0,0,1-1.29,3,15.36,15.36,0,0,1,2.35.39A14.37,14.37,0,0,0,197.74,292.44Z",
    style: {
      fill: "current",
      opacity: 0.4,
      transformOrigin: "196.481px 287.688px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elpv1s0vryo7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.85,291.41c-.65-3.87-2.77-7.8-6.2-9.85-.07,0-.23,0-.17.13a42.94,42.94,0,0,1,2.44,4.07,18.51,18.51,0,0,1,1.72,5.32,9.26,9.26,0,0,1-.15,4.59,18.76,18.76,0,0,1,2.56-.91A13,13,0,0,0,188.85,291.41Z",
    style: {
      fill: "current",
      opacity: 0.4,
      transformOrigin: "185.774px 288.615px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elf94vjgsy4ho"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.25,297.65a19.25,19.25,0,0,1,1.61,1.42,14.09,14.09,0,0,0,1.59-10.95c0-.07-.2-.13-.21,0a43.64,43.64,0,0,1-.88,4.67A18.54,18.54,0,0,1,203.25,297.65Z",
    style: {
      fill: "current",
      opacity: 0.4,
      transformOrigin: "205.086px 293.557px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M182.67,295.48a3.69,3.69,0,0,0,0-.47c0-.34-.14-.65-.15-1a4.62,4.62,0,0,0-1.82-3.59c-1.92-1.39-3.79-.86-5.13-5.25s-4.47-6.07-7.08-4.34a5.84,5.84,0,0,1-.76.36.91.91,0,0,1-.31.12c-.35.07-.73.07-1.09.12a6,6,0,0,0-2.11.62l-.06,0a3,3,0,0,0-1.62,3c.17.85.85,1.6.72,2.45a4.15,4.15,0,0,1-.8,1.47,4,4,0,0,0-.46,3.1,4.2,4.2,0,0,0,1.17,1.89c.37.38.68.82,1.08,1.16s.59.44.86.69a3.42,3.42,0,0,1,.65.86,11.06,11.06,0,0,1,.78,2,4.62,4.62,0,0,0,1.67,2.58c1.09.67,2.48.41,3.75.59,1.94.27,3.7,1.59,5.65,1.39a3.78,3.78,0,0,0,3.06-2.35c.33-.87.32-1.84.73-2.67.25-.52.65-.95.91-1.45A3.24,3.24,0,0,0,182.67,295.48Z",
    style: {
      fill: "current",
      transformOrigin: "172.274px 291.705px"
    },
    id: "el0d2ho8erzbfj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elqx036jziclf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.67,295.48a3.69,3.69,0,0,0,0-.47c0-.34-.14-.65-.15-1a4.62,4.62,0,0,0-1.82-3.59c-1.92-1.39-3.79-.86-5.13-5.25s-4.47-6.07-7.08-4.34a5.84,5.84,0,0,1-.76.36.91.91,0,0,1-.31.12c-.35.07-.73.07-1.09.12a6,6,0,0,0-2.11.62l-.06,0a3,3,0,0,0-1.62,3c.17.85.85,1.6.72,2.45a4.15,4.15,0,0,1-.8,1.47,4,4,0,0,0-.46,3.1,4.2,4.2,0,0,0,1.17,1.89c.37.38.68.82,1.08,1.16s.59.44.86.69a3.42,3.42,0,0,1,.65.86,11.06,11.06,0,0,1,.78,2,4.62,4.62,0,0,0,1.67,2.58c1.09.67,2.48.41,3.75.59,1.94.27,3.7,1.59,5.65,1.39a3.78,3.78,0,0,0,3.06-2.35c.33-.87.32-1.84.73-2.67.25-.52.65-.95.91-1.45A3.24,3.24,0,0,0,182.67,295.48Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "172.274px 291.705px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ellgfuiz14jh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.57,298.46c.07-.13.1-.33,0-.42-.41-.25-1-.08-1.46-.18a4.14,4.14,0,0,1-1.26-.54,4.51,4.51,0,0,1-1.78-2.17,4.12,4.12,0,0,1,0-2.62,4.72,4.72,0,0,1,.63-1.39c.51-.78,1-1.48,1-1.58s0-.3-.14-.25a16.84,16.84,0,0,1-2.28.74,3.79,3.79,0,0,1-2.32-.32,3.42,3.42,0,0,1-2.08-3.75c0-.13-.13-.11-.19-.05a2.35,2.35,0,0,0-.28,2.57,4.52,4.52,0,0,0,4.75,2.74,3.86,3.86,0,0,0,.49-.09,4.14,4.14,0,0,0-.54,1.07,5.35,5.35,0,0,0,.08,3.49c0,.11.09.21.13.32l-.35,0a5.85,5.85,0,0,1-.93-.17,3.62,3.62,0,0,1-1.61-.84,3,3,0,0,1-.84-1.32,2.36,2.36,0,0,1-.09-.84c0-.1.06-.25,0-.34s-.24-.07-.22,0c-.07-.17-.24.35-.26.44a1.74,1.74,0,0,0-.05.22,2.08,2.08,0,0,0,0,.43,2.73,2.73,0,0,0,.2,1,3.44,3.44,0,0,0,1,1.41,4.52,4.52,0,0,0,1.67.83,5.35,5.35,0,0,0,1,.18,4.11,4.11,0,0,0,1.11,0,5.29,5.29,0,0,0,1.39,1.36C175.08,298.89,177,299.68,177.57,298.46Z",
    style: {
      fill: "current",
      opacity: 0.5,
      transformOrigin: "172.393px 292.495px"
    },
    className: "animable"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chopsticks--inject-3",
    className: "animable animator-hidden",
    style: {
      transformOrigin: "243.406px 68.9371px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--chopsticks--inject-3",
    className: "animable",
    style: {
      transformOrigin: "243.406px 68.9371px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M407.72,28.92,109.78,56.33a2.62,2.62,0,1,0,.42,5.23L408.71,41.23a6.17,6.17,0,0,0-1-12.31Z",
    style: {
      fill: "current",
      transformOrigin: "260.874px 45.2342px"
    },
    id: "elcu50f3lckkv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elqxxi9t37o1p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M407.72,28.92,109.78,56.33a2.62,2.62,0,1,0,.42,5.23L408.71,41.23a6.17,6.17,0,0,0-1-12.31Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "260.874px 45.2342px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M407.72,28.92l-78.17,7.19c-3.26,3.07-2.62,8.52.84,10.46l78.32-5.34a6.17,6.17,0,0,0-1-12.31Z",
    style: {
      fill: "current",
      transformOrigin: "370.901px 37.7349px"
    },
    id: "elkeystap8jt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elthztjq1pazk"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M407.72,28.92l-78.17,7.19c-3.26,3.07-2.62,8.52.84,10.46l78.32-5.34a6.17,6.17,0,0,0-1-12.31Z",
    style: {
      opacity: 0.3,
      transformOrigin: "370.901px 37.7349px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M359.84,33.33l-2.3.21c-.07.25-.16.5-.22.76a15.06,15.06,0,0,0-.33,4.87,12.54,12.54,0,0,0,1.19,4.28c.17.36.38.77.62,1.18l2.1-.14a8.43,8.43,0,0,1-.68-1.07,10.83,10.83,0,0,1-1.17-3.85,14,14,0,0,1,.29-4.38A18.82,18.82,0,0,1,359.84,33.33Z",
    style: {
      fill: "current",
      transformOrigin: "358.911px 38.98px"
    },
    id: "eltrhcximhrym",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.69,44a10.68,10.68,0,0,1-1.17-3.86,14,14,0,0,1,.29-4.37c.12-.61.29-1.2.46-1.78l-2.29.21c-.06.23-.14.45-.19.67a15.06,15.06,0,0,0-.33,4.87,12.59,12.59,0,0,0,1.19,4.29c.16.33.35.7.57,1.09L353.3,45A10,10,0,0,1,352.69,44Z",
    style: {
      fill: "current",
      transformOrigin: "351.346px 39.555px"
    },
    id: "elpy108ntnoe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--shrimp--inject-3",
    className: "animable",
    style: {
      transformOrigin: "111.281px 71.9716px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.86,88c8.2,3.64,17.56,15,12.17,19.47s-10.9-1.63-13.92-10.3c-3,9.54-9.14,12.87-13.14,9.16s-1.36-13.25,9.17-16.94Z",
    style: {
      fill: "current",
      transformOrigin: "139.409px 98.4871px"
    },
    id: "elljgrb5guxwq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el0o9pmew5u42i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.86,88c8.2,3.64,17.56,15,12.17,19.47s-10.9-1.63-13.92-10.3c-3,9.54-9.14,12.87-13.14,9.16s-1.36-13.25,9.17-16.94Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "139.409px 98.4871px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elg29u0iszi54"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149,101.8c-.28-2.88-2.34-5.71-4.33-7.7a27.29,27.29,0,0,0-3.31-2.77c-.59-.43-1.2-.84-1.81-1.23a6,6,0,0,0-1.8-1c-.08-.82-1.39-.14-1.35.55A13,13,0,0,1,135,96.34a17.33,17.33,0,0,1-4.49,5.23c-.33.28.06.55.37.43a11.73,11.73,0,0,0,5.46-5.72,14.61,14.61,0,0,0,1.46-5.58c.27.18.56.34.82.51.61.4,1.21.82,1.81,1.26a33.16,33.16,0,0,1,3.37,2.78,24.89,24.89,0,0,1,2.71,3,35.33,35.33,0,0,1,2.14,3.61C148.67,102,149,102,149,101.8Z",
    style: {
      fill: "current",
      opacity: 0.4,
      transformOrigin: "139.692px 95.377px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M141.24,87.89c5-26.87-15.78-50.8-36.54-52.73-10.29-1-22.42,1.77-31,12-8.45,10,13.62,28.31,20.22,24.35,12.23-7.33,22-5.73,29.82.45,6.64,5.28,11.45,17.45,11.45,17.45S139,91.56,141.24,87.89Z",
    style: {
      fill: "current",
      transformOrigin: "106.896px 62.5024px"
    },
    id: "elvzqunmp13nk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el5lmgntxle16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.24,87.89c5-26.87-15.78-50.8-36.54-52.73-10.29-1-22.42,1.77-31,12-8.45,10,13.62,28.31,20.22,24.35,12.23-7.33,22-5.73,29.82.45,6.64,5.28,11.45,17.45,11.45,17.45S139,91.56,141.24,87.89Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "106.896px 62.5024px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elv113m4s8vng"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.1,65c2.07-5.14,2.44-11.43-.17-16.42-.05-.1-.31-.13-.3,0a60.09,60.09,0,0,1-.08,6.71,26,26,0,0,1-1.87,7.66A16.05,16.05,0,0,1,113.42,67a19.93,19.93,0,0,1,3.24.9A22.75,22.75,0,0,0,118.1,65Z",
    style: {
      fill: "current",
      opacity: 0.4,
      transformOrigin: "116.595px 58.1967px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el56jxv67fxa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.79,62.19c-.35-5.54-2.72-11.37-7.22-14.75-.09-.07-.33,0-.27.15a59.77,59.77,0,0,1,2.82,6.08,26.18,26.18,0,0,1,1.61,7.73,13.21,13.21,0,0,1-.9,6.41,27.23,27.23,0,0,1,3.73-.9A19.53,19.53,0,0,0,105.79,62.19Z",
    style: {
      fill: "current",
      opacity: 0.4,
      transformOrigin: "102.066px 57.6114px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elotwharucn9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125,73.11a25.93,25.93,0,0,1,2,2.23c3.1-4.29,4.94-9.89,3.88-15.12,0-.11-.26-.21-.3-.07a61.8,61.8,0,0,1-1.93,6.43A26.33,26.33,0,0,1,125,73.11Z",
    style: {
      fill: "current",
      opacity: 0.4,
      transformOrigin: "128.091px 67.7107px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M96.49,67a3.7,3.7,0,0,0,.07-.66c0-.48-.09-.94-.06-1.41a6.53,6.53,0,0,0-2-5.32c-2.48-2.24-5.18-1.76-6.4-8.13s-5.36-9.19-9.29-7.15a11.42,11.42,0,0,1-1.12.39,1.45,1.45,0,0,1-.44.12c-.51,0-1,0-1.55,0a8.63,8.63,0,0,0-3.06.55l-.09,0a4.15,4.15,0,0,0-2.72,3.91c.12,1.21,1,2.37.64,3.55a6,6,0,0,1-1.34,1.94A5.63,5.63,0,0,0,68,59.07a6,6,0,0,0,1.35,2.83c.47.59.83,1.25,1.35,1.79.36.38.76.7,1.1,1.1a5.08,5.08,0,0,1,.79,1.3A16.36,16.36,0,0,1,73.39,69a6.49,6.49,0,0,0,2,3.87c1.43,1.11,3.43,1,5.18,1.39,2.67.68,5,2.8,7.71,2.81a5.31,5.31,0,0,0,4.64-2.84c.6-1.17.74-2.53,1.44-3.64.42-.68,1-1.22,1.49-1.89A4.61,4.61,0,0,0,96.49,67Z",
    style: {
      fill: "current",
      transformOrigin: "82.2501px 60.3726px"
    },
    id: "elx5dqas2q3h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elgeqpjhpc6b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.49,67a3.7,3.7,0,0,0,.07-.66c0-.48-.09-.94-.06-1.41a6.53,6.53,0,0,0-2-5.32c-2.48-2.24-5.18-1.76-6.4-8.13s-5.36-9.19-9.29-7.15a11.42,11.42,0,0,1-1.12.39,1.45,1.45,0,0,1-.44.12c-.51,0-1,0-1.55,0a8.63,8.63,0,0,0-3.06.55l-.09,0a4.15,4.15,0,0,0-2.72,3.91c.12,1.21,1,2.37.64,3.55a6,6,0,0,1-1.34,1.94A5.63,5.63,0,0,0,68,59.07a6,6,0,0,0,1.35,2.83c.47.59.83,1.25,1.35,1.79.36.38.76.7,1.1,1.1a5.08,5.08,0,0,1,.79,1.3A16.36,16.36,0,0,1,73.39,69a6.49,6.49,0,0,0,2,3.87c1.43,1.11,3.43,1,5.18,1.39,2.67.68,5,2.8,7.71,2.81a5.31,5.31,0,0,0,4.64-2.84c.6-1.17.74-2.53,1.44-3.64.42-.68,1-1.22,1.49-1.89A4.61,4.61,0,0,0,96.49,67Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "82.2501px 60.3726px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elhet9lxekjcv"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.89,70.39c.11-.18.19-.46,0-.61-.54-.4-1.39-.26-2-.47a5.23,5.23,0,0,1-1.69-1A6.34,6.34,0,0,1,83,65.06a5.87,5.87,0,0,1,.39-3.69,6.43,6.43,0,0,1,1.1-1.85c.83-1,1.6-1.93,1.69-2.06s.09-.42-.16-.37a25,25,0,0,1-3.31.7,5.45,5.45,0,0,1-3.2-.8,4.81,4.81,0,0,1-2.35-5.58c.06-.18-.17-.18-.27-.1a3.34,3.34,0,0,0-.78,3.57,6.42,6.42,0,0,0,6.25,4.56c.24,0,.48,0,.71-.06a6.21,6.21,0,0,0-.93,1.42,7.6,7.6,0,0,0-.4,4.91,3.62,3.62,0,0,0,.13.47,4.17,4.17,0,0,1-.49-.08,8.51,8.51,0,0,1-1.28-.38A5.23,5.23,0,0,1,78,64.3a4.15,4.15,0,0,1-1-2,3.12,3.12,0,0,1,0-1.18c0-.15.12-.35,0-.49s-.32-.14-.3-.07c-.07-.26-.39.45-.44.58a2.46,2.46,0,0,0-.09.29,3.14,3.14,0,0,0-.12.61,4.24,4.24,0,0,0,.13,1.46,5,5,0,0,0,1.2,2.12,6.45,6.45,0,0,0,2.21,1.42,8.63,8.63,0,0,0,1.34.4,6.09,6.09,0,0,0,1.56.16,7.12,7.12,0,0,0,1.74,2.11C85.34,70.61,87.87,72,88.89,70.39Z",
    style: {
      fill: "current",
      opacity: 0.5,
      transformOrigin: "82.448px 61.194px"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M412.89,72.38,113.75,66.5a2.62,2.62,0,1,0-.16,5.24l298.91,13a6.17,6.17,0,1,0,.39-12.34Z",
    style: {
      fill: "current",
      transformOrigin: "264.959px 75.6209px"
    },
    id: "elgnlwcxcgitg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elrbre5j8irf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.89,72.38,113.75,66.5a2.62,2.62,0,1,0-.16,5.24l298.91,13a6.17,6.17,0,1,0,.39-12.34Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "264.959px 75.6209px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M412.89,72.38l-78.48-1.54c-3.58,2.68-3.56,8.17-.33,10.48l78.42,3.4a6.17,6.17,0,1,0,.39-12.34Z",
    style: {
      fill: "current",
      transformOrigin: "375.281px 77.7816px"
    },
    id: "elbe0r48z3b8f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elk4sk9vcda8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.89,72.38l-78.48-1.54c-3.58,2.68-3.56,8.17-.33,10.48l78.42,3.4a6.17,6.17,0,1,0,.39-12.34Z",
    style: {
      opacity: 0.3,
      transformOrigin: "375.281px 77.7816px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M364.81,71.43l-2.3,0c-.1.24-.21.48-.3.73a14.86,14.86,0,0,0-.87,4.8,12.68,12.68,0,0,0,.7,4.4c.13.37.29.8.49,1.23l2.1.1a10,10,0,0,1-.56-1.14,10.9,10.9,0,0,1-.73-4,13.89,13.89,0,0,1,.77-4.32C364.31,72.61,364.56,72,364.81,71.43Z",
    style: {
      fill: "current",
      transformOrigin: "363.074px 77.06px"
    },
    id: "eluavw6opxe3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.52,81.27a10.68,10.68,0,0,1-.73-4,13.83,13.83,0,0,1,.77-4.32c.19-.59.42-1.16.66-1.72l-2.3,0c-.09.21-.19.43-.26.65a15.08,15.08,0,0,0-.88,4.79,12.88,12.88,0,0,0,.71,4.4c.12.34.27.74.44,1.14l2.09.1A10.09,10.09,0,0,1,356.52,81.27Z",
    style: {
      fill: "current",
      transformOrigin: "355.499px 76.77px"
    },
    id: "el894d6rh8hv9",
    className: "animable"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.b57f487a.svg";
export { ForwardRef as ReactComponent };